class AdjustmentOrderRequestDto {
  /** dono */
  dono = "";

  /** 调整后数量 */
  finalQty = undefined;

  /** id */
  id = undefined;

  /** 原数量 */
  initQty = undefined;
}

class AllocationApprovalResponseDto {
  /** 调拨类型 */
  allocationType = undefined;

  /** 调拨单单号 */
  aono = "";

  /** 申请原因 */
  applyCause = "";

  /** 审批号 */
  approvalNo = "";

  /** 审批状态 */
  approvalStatus = undefined;

  /** centerId */
  centerId = "";

  /** 调拨单修改类型 */
  changeType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间结束 */
  createTimeEnd = "";

  /** 创建时间开始 */
  createTimeStart = "";

  /** 删除0：否1：是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 修改类型 */
  modifyType = undefined;

  /** referenceID */
  referenceId = "";

  /** shipment */
  shipment = "";

  /** 目标仓库编码 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间结束 */
  updateTimeEnd = "";

  /** 更新时间开始 */
  updateTimeStart = "";
}

class AllocationApprovalResponseModel {
  /** 审批前调拨状态 */
  allocationStatus = undefined;

  /** 调拨类型 */
  allocationType = undefined;

  /** 调拨单单号 */
  aono = "";

  /** 申请原因 */
  applyCause = "";

  /** 审批号 */
  approvalNo = "";

  /** 审批状态 */
  approvalStatus = undefined;

  /** centerId */
  centerId = "";

  /** centerId */
  centerIdBefore = "";

  /** 调拨单修改类型 */
  changeType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间结束 */
  createTimeEnd = "";

  /** 创建时间开始 */
  createTimeStart = "";

  /** 删除0：否1：是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 修改类型 */
  modifyType = undefined;

  /** referenceID */
  referenceId = "";

  /** referenceID */
  referenceIdBefore = "";

  /** shipment */
  shipment = "";

  /** shipment */
  shipmentBefore = "";

  /** 目标仓库编码 */
  targetWarehouseCode = "";

  /** 目标仓库编码 */
  targetWarehouseCodeBefore = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 目标仓库名称 */
  targetWarehouseNameBefore = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间结束 */
  updateTimeEnd = "";

  /** 更新时间开始 */
  updateTimeStart = "";
}

class AllocationBatchCreateRequestDto {
  /** 调拨单号 */
  aonos = [];

  /** centerId */
  centerId = "";

  /** 货柜号 */
  containerNo = "";

  /** 装柜类型: 10 散货,20 20GP,30 40HQ */
  loadCabinType = undefined;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道名称 */
  logisticsChannelName = "";

  /** 物流商 */
  logisticsProvider = "";

  /** 物流商名称 */
  logisticsProviderName = "";

  /** 封条号 */
  sealno = "";

  /** 运输方式：10 空运，20 海运，30 快船，40 铁路 */
  shippingType = undefined;

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** Tms单号 */
  tmsno = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨 */
  type = undefined;

  /** 是否整柜 0否 1是 */
  wholeFlag = undefined;
}

class AllocationBatchDetailResponseDto {
  /** 调拨单 */
  allocationMasterResponseDtos = [];

  /** 调拨批次 */
  batchResponseDto = new AllocationBatchResponseDto();
}

class AllocationBatchResponseDto {
  /** 调拨批次单号 */
  abno = "";

  /** 箱数 */
  boxQty = undefined;

  /** centerId */
  centerId = "";

  /** 货柜号 */
  containerNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 出库时间 */
  deliveryTime = "";

  /** id */
  id = undefined;

  /** 装柜类型: 10 散货,20 20GP,30 40HQ */
  loadCabinType = undefined;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道名称 */
  logisticsChannelName = "";

  /** 物流商 */
  logisticsProvider = "";

  /** 物流商名称 */
  logisticsProviderName = "";

  /** pod文件 */
  podFile = "";

  /** 封条号 */
  sealno = "";

  /** 运输方式：10 空运，20 海运，30 快船，40 铁路 */
  shippingType = undefined;

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 调拨批次状态：10 未扫描，20 已扫描，30 已确认，40 已发运，50 已完成 */
  status = undefined;

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** Tms单号 */
  tmsno = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 体积 */
  volume = undefined;

  /** 重量 */
  weight = undefined;

  /** 是否整柜 0否 1是 */
  wholeFlag = undefined;
}

class AllocationBatchUploadPodFileRequestDto {
  /** 调拨批次单号 */
  abno = "";

  /** pod文件 */
  podFile = "";
}

class AllocationBoxCollectDto {
  /** 调拨单分箱信息 */
  allocationBoxDtos = [];

  /** 调拨单SKU信息 */
  allocationDetailDtos = [];

  /** 调拨单信息 */
  allocationMasterDto = new AllocationMasterResponseDto();
}

class AllocationBoxDetailRequestDto {
  /** ASIN */
  asin = "";

  /** FNSKU */
  fnsku = "";

  /** MSKU */
  msku = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";
}

class AllocationBoxDetailResponseDto {
  /** ASIN */
  asin = "";

  /** 箱号 */
  boxNo = "";

  /** FNSKU */
  fnsku = "";

  /** MSKU */
  msku = "";

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 变体规格 */
  variants = "";
}

class AllocationBoxHeadDto {
  /** 调拨单号 */
  aono = "";

  /** 箱数/第几箱 */
  boxNumAndCurrent = "";

  /** 总数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** sku * 数量 */
  skuNum = [];
}

class AllocationBoxRequestDto {
  /** 调拨单号 */
  aono = "";

  /** 分箱明细 */
  boxDetailDtos = [];

  /** 箱号 */
  boxNo = "";

  /** 高度（单位：cm） */
  height = undefined;

  /** 长度（单位：cm） */
  length = undefined;

  /** 重量 */
  weight = undefined;

  /** 宽度（单位：cm） */
  width = undefined;
}

class AllocationBoxResponseDto {
  /** 调拨单号 */
  aono = "";

  /** 箱外条码 */
  barcode = "";

  /** 箱号 */
  boxNo = "";

  /** 分箱明细 */
  detailModels = [];

  /** 高度（单位：cm） */
  height = undefined;

  /** 长度（单位：cm） */
  length = undefined;

  /** 重量 */
  weight = undefined;

  /** 宽度（单位：cm） */
  width = undefined;
}

class AllocationBoxingReportDto {
  /** asin */
  asin = "";

  /** 箱号 */
  boxNo = "";

  /** 总箱数 */
  boxNum = "";

  /** 品牌 */
  brandName = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 体积重 */
  chargeWeight = "";

  /** emptyStr */
  emptyStr = "";

  /** 英文标题 */
  englishTitle = "";

  /** 高度 */
  height = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 是否拼箱 */
  isSpellBox = "";

  /** 长度 */
  length = undefined;

  /** 物流分组 */
  logisticsGroup = "";

  /** 材质 */
  material = "";

  /** 采购单号 */
  pono = "";

  /** 产品图片 */
  productImageUrl = new ImageEntity();

  /** 产品链接 */
  productLink = "";

  /** 产品标题 */
  productTitle = "";

  /** 采购成本 */
  purchaseCost = undefined;

  /** 用途 */
  purpose = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 总体积重 */
  sumChargeWeight = "";

  /** 总数量 */
  sumQty = "";

  /** 总体积 */
  sumVolume = "";

  /** 总重 */
  sumWeight = "";

  /** 体积/箱(m³) */
  volume = "";

  /** 重量 */
  weight = undefined;

  /** 宽度 */
  width = undefined;
}

class AllocationContainerRequestDto {
  /** 货柜号 */
  containerNo = "";
}

class AllocationContainerResponseDto {
  /** 实装率 */
  actualRate = undefined;

  /** 箱数 */
  boxQty = undefined;

  /** 货柜号 */
  containerNo = "";

  /** 装柜类型：10龙舟整柜，20 捷仕整柜，30 捷仕散柜，40 空运装柜 */
  containerType = undefined;

  /** 货柜容积（L） */
  containerVolume = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 实装容积（L） */
  realVolume = undefined;

  /** 运输方式：10 空运，20 海运，30 快船，40 铁路 */
  shippingType = undefined;

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AllocationDetailCreateRequestDto {
  /** ASIN */
  asin = "";

  /** 品牌名称 */
  brandName = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 产品英文标题 */
  englishTitle = "";

  /** FNSKU */
  fnsku = "";

  /** 物流分组 */
  logisticsGroup = "";

  /** 材质 */
  material = "";

  /** MSKU */
  msku = "";

  /** 采购单号 */
  pono = "";

  /** 产品编号 */
  productCode = "";

  /** 产品高(cm) */
  productHeight = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品长(cm) */
  productLength = undefined;

  /** 产品链接 */
  productLink = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 产品重量(g) */
  productWeight = undefined;

  /** 产品宽(cm) */
  productWidth = undefined;

  /** 采购成本 */
  purchaseCost = undefined;

  /** 用途 */
  purpose = "";

  /** 数量 */
  qty = undefined;

  /** SKU */
  sku = "";

  /** 变体规格 */
  variants = "";
}

class AllocationDetailCreateRpcRequestDto {
  /** ASIN */
  asin = "";

  /** 品牌名称 */
  brandName = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** centerId */
  centerId = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 产品英文标题 */
  englishTitle = "";

  /** FNSKU */
  fnsku = "";

  /** 物流分组 */
  logisticsGroup = "";

  /** 材质 */
  material = "";

  /** MSKU */
  msku = "";

  /** 采购单号 */
  pono = "";

  /** 产品编号 */
  productCode = "";

  /** 产品高(cm) */
  productHeight = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品长(cm) */
  productLength = undefined;

  /** 产品链接 */
  productLink = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 产品重量(g) */
  productWeight = undefined;

  /** 产品宽(cm) */
  productWidth = undefined;

  /** 采购成本 */
  purchaseCost = undefined;

  /** 用途 */
  purpose = "";

  /** 数量 */
  qty = undefined;

  /** referenceId */
  referenceId = "";

  /** shipment */
  shipment = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** SKU */
  sku = "";

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓国家简码 */
  targetWarehouseCountryCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称 */
  tradeCompanyInName = "";

  /** 变体规格 */
  variants = "";
}

class AllocationDetailInfoRpcResponseDto {
  /** 调拨单号 */
  aono = "";

  /** 调拨批次物流渠道商编号 */
  batchLogisticsProviderName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** shipment */
  shipment = "";

  /** 运输方式 1：龙舟空运 2：龙舟海运 3：龙舟快船 4：龙舟散货 10 普通空运 15：普通空运(带电带磁)，20 普通海运，30 快船，40 铁路 50：卡车 60：快递 */
  shippingType = undefined;

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 调拨状态：10 未处理，20 已打印，30 已拣货，40 已装箱，50 待发运，55：发运中 57：发运失败 60 已发运，62：已退件签收 65：中转签收 68：中转发运 69：部分收货 70 已完成，80 已取消 90 待还货 */
  status = undefined;

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 调出交易主体编号 */
  tradeCompanyCode = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨 50：WFS调拨 */
  type = undefined;
}

class AllocationDetailModel {
  /** aono */
  aono = "";

  /** asin */
  asin = "";

  /** brandName */
  brandName = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** createBy */
  createBy = "";

  /** createTime */
  createTime = "";

  /** deleted */
  deleted = undefined;

  /** englishTitle */
  englishTitle = "";

  /** fnsku */
  fnsku = "";

  /** fnskuUrl */
  fnskuUrl = "";

  /** id */
  id = undefined;

  /** isNew */
  isNew = undefined;

  /** logisticsGroup */
  logisticsGroup = "";

  /** material */
  material = "";

  /** msku */
  msku = "";

  /** notReceivedQuantity */
  notReceivedQuantity = undefined;

  /** pono */
  pono = "";

  /** productCode */
  productCode = "";

  /** productHeight */
  productHeight = undefined;

  /** productImageUrl */
  productImageUrl = "";

  /** productLength */
  productLength = undefined;

  /** productLink */
  productLink = "";

  /** productTitle */
  productTitle = "";

  /** productType */
  productType = undefined;

  /** productWeight */
  productWeight = undefined;

  /** productWidth */
  productWidth = undefined;

  /** purchaseCost */
  purchaseCost = undefined;

  /** purpose */
  purpose = "";

  /** qty */
  qty = undefined;

  /** sku */
  sku = "";

  /** updateBy */
  updateBy = "";

  /** updateTime */
  updateTime = "";

  /** variants */
  variants = "";
}

class AllocationDetailResponseDto {
  /** 调拨单号 */
  aono = "";

  /** ASIN */
  asin = "";

  /** 品牌名称 */
  brandName = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 售后邮箱 */
  email = "";

  /** 产品英文标题 */
  englishTitle = "";

  /** FNSKU */
  fnsku = "";

  /** FNSKU标签文件路径 */
  fnskuUrl = "";

  /** id */
  id = undefined;

  /** 物流分组 */
  logisticsGroup = "";

  /** 材质 */
  material = "";

  /** MSKU */
  msku = "";

  /** 未接收数量 */
  notReceivedQuantity = undefined;

  /** 采购单号 */
  pono = "";

  /** 产品编号 */
  productCode = "";

  /** 产品高(cm) */
  productHeight = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品长(cm) */
  productLength = undefined;

  /** 产品链接 */
  productLink = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 产品重量(g) */
  productWeight = undefined;

  /** 产品宽(cm) */
  productWidth = undefined;

  /** 采购成本 */
  purchaseCost = undefined;

  /** 用途 */
  purpose = "";

  /** 数量 */
  qty = undefined;

  /** SKU */
  sku = "";

  /** 更新人 */
  updateBy = "";

  /** 变体规格 */
  variants = "";
}

class AllocationDetailRpcResponseDto {
  /** 调拨单号 */
  aono = "";

  /** ASIN */
  asin = "";

  /** 品牌名称 */
  brandName = "";

  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** 产品英文标题 */
  englishTitle = "";

  /** FNSKU */
  fnsku = "";

  /** id */
  id = undefined;

  /** 物流分组 */
  logisticsGroup = "";

  /** 材质 */
  material = "";

  /** MSKU */
  msku = "";

  /** 采购单号 */
  pono = "";

  /** 产品编号 */
  productCode = "";

  /** 产品高(cm) */
  productHeight = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品长(cm) */
  productLength = undefined;

  /** 产品链接 */
  productLink = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 产品重量(g) */
  productWeight = undefined;

  /** 产品宽(cm) */
  productWidth = undefined;

  /** 采购成本 */
  purchaseCost = undefined;

  /** 用途 */
  purpose = "";

  /** 数量 */
  qty = undefined;

  /** SKU */
  sku = "";

  /** 变体规格 */
  variants = "";
}

class AllocationMasterBoxDetailResponseDto {
  /** ASIN */
  asin = "";

  /** 箱号 */
  boxNo = "";

  /** 品牌 */
  brandName = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 体积重 */
  chargeWeight = undefined;

  /** FNSKU */
  fnsku = "";

  /** 高度 */
  height = undefined;

  /** 长度 */
  length = undefined;

  /** 材质 */
  material = "";

  /** 型号 */
  model = "";

  /** MSKU */
  msku = "";

  /** 用途 */
  purpose = "";

  /** 数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** 单个重量 */
  singleWeight = undefined;

  /** sku */
  sku = "";

  /** sku名称 */
  skuName = "";

  /** 产品体积 */
  volume = undefined;

  /** 抛货率基数 */
  volumeGoodsBase = undefined;

  /** 整箱重量 */
  weight = undefined;

  /** 宽度 */
  width = undefined;
}

class AllocationMasterBoxingReportDto {
  /** 空运模板数据 */
  air = [];

  /** aono */
  aono = "";

  /** 总箱数 */
  boxNum = undefined;

  /** centerId */
  centerId = "";

  /** 收件人国家 */
  country = "";

  /** 事业部 */
  department = "";

  /** 是否带电 */
  isElectricity = "";

  /** 渠道服务 */
  logisticsChannelName = "";

  /** referenceId */
  referenceId = "";

  /** 海运模板数据 */
  sea = [];

  /** shipTo */
  shipTo = "";

  /** shipment */
  shipment = "";

  /** shipmentName */
  shipmentName = "";

  /** 运输方式 */
  shippingType = undefined;

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 交易主体名称 */
  tradeCompanyName = "";
}

class AllocationMasterCreateForPageRequestDto {
  /** 调拨单明细 */
  allocationDetailCreateRequestDtos = [];

  /** 散货审批附件 */
  bulkCargoFile = "";

  /** centerId */
  centerId = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 是否校验shipment：1是 0否 */
  checkShipmentFlag = undefined;

  /** 创建人 */
  createBy = "";

  /** 是否前端页面创建 */
  isPage = false;

  /** 是否装板 0 否 1 是 默认0不装板 */
  isPlate = undefined;

  /** 外箱标签数量 */
  labelQty = undefined;

  /** 站点/市场 */
  marketplaces = "";

  /** referenceId */
  referenceId = "";

  /** 备注 */
  remark = "";

  /** 是否调拨销售 1：是 0：否 */
  saleFlag = undefined;

  /** shipment */
  shipment = "";

  /** shipmentName */
  shipmentName = "";

  /** 运输方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  shippingType = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓国家简码 */
  targetWarehouseCountryCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 调出交易主体编号 */
  tradeCompanyCode = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称 */
  tradeCompanyInName = "";

  /** 调出交易主体名称 */
  tradeCompanyName = "";

  /** 是否中转：1是 0否 */
  transitFlag = undefined;

  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨 50: WFS调拨 */
  type = undefined;

  /** 是否上传装箱信息：1是 0否 */
  uploadBoxFlag = undefined;

  /** 总体积 */
  volume = undefined;

  /** 总重量 */
  weight = undefined;
}

class AllocationMasterCreateForTransferDetailRequestDto {
  /** 产品名称 */
  productTitle = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";
}

class AllocationMasterCreateForTransferRequestDto {
  /** 创建子库转移调拨单明细 */
  allocationMasterCreateForTransferDetailRequestDtoList = [];

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 备注 */
  remark = "";

  /** 仓库编号 */
  rootWarehouseCode = "";

  /** 仓库名称 */
  rootWarehouseName = "";

  /** 调出子库编号 */
  sourceWarehouseCode = "";

  /** 调出子库名称 */
  sourceWarehouseName = "";

  /** 调入子库编号 */
  targetWarehouseCode = "";

  /** 调入子库名称 */
  targetWarehouseName = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class AllocationMasterCreateRequestDto {
  /** 调拨单明细 */
  allocationDetailCreateRequestDtos = [];

  /** 散货审批附件 */
  bulkCargoFile = "";

  /** centerId */
  centerId = "";

  /** 渠道key-弃用 */
  channelKey = "";

  /** 渠道名称-弃用 */
  channelName = "";

  /** 是否校验shipment：1是 0否 */
  checkShipmentFlag = undefined;

  /** 创建人 */
  createBy = "";

  /** 站点/市场 */
  marketplaces = "";

  /** referenceId */
  referenceId = "";

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** shipmentName */
  shipmentName = "";

  /** 运输方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  shippingType = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** 来源类型 */
  sourceType = undefined;

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 目标仓库编号-弃用 */
  targetWarehouseCode = "";

  /** 目标仓国家简码 */
  targetWarehouseCountryCode = "";

  /** 目标仓库名称-弃用 */
  targetWarehouseName = "";

  /** 调出交易主体编号 */
  tradeCompanyCode = "";

  /** 调入交易主体编号-弃用 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称-弃用 */
  tradeCompanyInName = "";

  /** 调出交易主体名称 */
  tradeCompanyName = "";

  /** 是否中转：1是 0否 */
  transitFlag = undefined;

  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨 50: WFS调拨 */
  type = undefined;

  /** 是否上传装箱信息：1是 0否 */
  uploadBoxFlag = undefined;
}

class AllocationMasterListResponseDto {
  /** 调拨批次号 */
  abno = "";

  /** 调拨单号 */
  aono = "";

  /** 箱外标签文件路径 */
  boxLabelPath = "";

  /** 箱数 */
  boxQty = undefined;

  /** 散货审批附件 */
  bulkCargoFile = "";

  /** 订舱状态：10待绑舱，20预订舱，30预订舱驳回，40已订舱，50已绑舱，60体外订舱 */
  cabinStatus = undefined;

  /** centerId */
  centerId = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 体积重5k */
  chargeWeight5k = undefined;

  /** 体积重6k */
  chargeWeight6k = undefined;

  /** 是否校验shipment：1是 0否 */
  checkShipmentFlag = undefined;

  /** 货柜号 */
  containerNo = "";

  /** 计泡基数 */
  countBubbleBase = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申报币种 */
  declareCurrency = "";

  /** 申报价格 */
  declarePrice = undefined;

  /** 出库时间 */
  deliveryTime = "";

  /** 出库单号 */
  dono = "";

  /** FBA账号 */
  fbaAccount = "";

  /** FBA到仓时间 */
  fbaInTime = "";

  /** id */
  id = undefined;

  /** 是否新品调拨 */
  ifNewProduct = undefined;

  /** 是否装板 */
  isPlate = undefined;

  /** 外箱标签数量 */
  labelQty = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 是否需要物流面单 0:否 1:是 */
  logisticsFlag = undefined;

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 站点/市场 */
  marketplaces = "";

  /** 拣货单号 */
  pickno = "";

  /** 托盘数 */
  plateQty = undefined;

  /** 总数量 */
  qty = undefined;

  /** referenceId */
  referenceId = "";

  /** 备注 */
  remark = "";

  /** 是否调拨销售 1：是 0：否 */
  saleFlag = undefined;

  /** shipment */
  shipment = "";

  /** shipmentName */
  shipmentName = "";

  /** 运输方式 1：龙舟空运 2：龙舟海运 3：龙舟快船 4：龙舟散货 10 普通空运 15：普通空运(带电带磁)，20 普通海运，30 快船，40 铁路 50：卡车 60：快递 */
  shippingType = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺信息 */
  shopDepartmentMappingResponseDto = new ShopDepartmentMappingResponseDto();

  /** 店铺名称 */
  shopName = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** sku种类数量 */
  skuQty = undefined;

  /** 来源类型：10 手工创建，20 调拨计划创建 */
  sourceType = undefined;

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 调拨状态：10 未处理，20 已打印，30 已拣货，40 已装箱，50 待发运，55：发运中 57：发运失败 60 已发运，62：已退件签收 65：中转签收 68：中转发运 69：部分收货 70 已完成，80 已取消 90 待还货 */
  status = undefined;

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 是否含税 0:否1:是 */
  taxFlag = undefined;

  /** 调出交易主体编号 */
  tradeCompanyCode = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称 */
  tradeCompanyInName = "";

  /** 调出交易主体名称 */
  tradeCompanyName = "";

  /** 是否中转：1是 0否 */
  transitFlag = undefined;

  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨 50：WFS调拨 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 是否上传装箱信息：1是 0否 */
  uploadBoxFlag = undefined;

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 重量 */
  weight = undefined;
}

class AllocationMasterModel {
  /** abno */
  abno = "";

  /** aono */
  aono = "";

  /** boxLabelPath */
  boxLabelPath = "";

  /** boxQty */
  boxQty = undefined;

  /** boxTime */
  boxTime = "";

  /** bulkCargoFile */
  bulkCargoFile = "";

  /** cabinStatus */
  cabinStatus = undefined;

  /** centerId */
  centerId = "";

  /** channelKey */
  channelKey = "";

  /** channelName */
  channelName = "";

  /** checkShipmentFlag */
  checkShipmentFlag = undefined;

  /** containerNo */
  containerNo = "";

  /** countBubbleBase */
  countBubbleBase = undefined;

  /** createBy */
  createBy = "";

  /** createPickTime */
  createPickTime = "";

  /** createTime */
  createTime = "";

  /** declareCurrency */
  declareCurrency = "";

  /** declarePrice */
  declarePrice = undefined;

  /** deleted */
  deleted = undefined;

  /** deliveryTime */
  deliveryTime = "";

  /** dono */
  dono = "";

  /** errorInfo */
  errorInfo = "";

  /** fbaAccount */
  fbaAccount = "";

  /** fbaInTime */
  fbaInTime = "";

  /** id */
  id = undefined;

  /** ifNewProduct */
  ifNewProduct = undefined;

  /** isPlate */
  isPlate = undefined;

  /** labelQty */
  labelQty = undefined;

  /** logisticsChannelCode */
  logisticsChannelCode = "";

  /** logisticsChannelName */
  logisticsChannelName = "";

  /** logisticsFlag */
  logisticsFlag = undefined;

  /** logisticsLabelPath */
  logisticsLabelPath = "";

  /** logisticsProviderCode */
  logisticsProviderCode = "";

  /** logisticsProviderName */
  logisticsProviderName = "";

  /** marketplaces */
  marketplaces = "";

  /** pickTime */
  pickTime = "";

  /** pickno */
  pickno = "";

  /** plateQty */
  plateQty = undefined;

  /** qty */
  qty = undefined;

  /** referenceId */
  referenceId = "";

  /** remark */
  remark = "";

  /** saleFlag */
  saleFlag = undefined;

  /** shipment */
  shipment = "";

  /** shipmentName */
  shipmentName = "";

  /** shippingType */
  shippingType = undefined;

  /** shopCode */
  shopCode = "";

  /** shopName */
  shopName = "";

  /** siteKey */
  siteKey = "";

  /** siteName */
  siteName = "";

  /** skuQty */
  skuQty = undefined;

  /** sourceType */
  sourceType = undefined;

  /** sourceWarehouseCode */
  sourceWarehouseCode = "";

  /** sourceWarehouseName */
  sourceWarehouseName = "";

  /** status */
  status = undefined;

  /** targetWarehouseCode */
  targetWarehouseCode = "";

  /** targetWarehouseName */
  targetWarehouseName = "";

  /** taxFlag */
  taxFlag = undefined;

  /** tradeCompanyCode */
  tradeCompanyCode = "";

  /** tradeCompanyInCode */
  tradeCompanyInCode = "";

  /** tradeCompanyInName */
  tradeCompanyInName = "";

  /** tradeCompanyName */
  tradeCompanyName = "";

  /** transitFlag */
  transitFlag = undefined;

  /** type */
  type = undefined;

  /** updateBy */
  updateBy = "";

  /** updateTime */
  updateTime = "";

  /** uploadBoxFlag */
  uploadBoxFlag = undefined;

  /** volume */
  volume = undefined;

  /** waybillNo */
  waybillNo = "";

  /** weight */
  weight = undefined;
}

class AllocationMasterParamsDto {
  /** 调拨批次号 */
  abno = "";

  /** 调拨单号列表 */
  aoNoIn = [];

  /** 调拨单号 */
  aono = "";

  /** 排序规则 desc or asc */
  asc = "";

  /** 起始箱数 */
  beginBoxQty = undefined;

  /** 开始创建时间 */
  beginCreateTime = "";

  /** 开始出库时间 */
  beginDeliveryTime = "";

  /** 开始FBA到仓时间 */
  beginFbaInTime = "";

  /** 箱数 */
  boxQty = undefined;

  /** 散货审批附件 */
  bulkCargoFile = "";

  /** 订舱状态：10待绑舱，20预订舱，30预订舱驳回，40已订舱，50已绑舱，60体外订舱 */
  cabinStatus = undefined;

  /** 订舱状态 多选 */
  cabinStatusList = [];

  /** centerId */
  centerId = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 是否校验shipment：1是 0否 */
  checkShipmentFlag = undefined;

  /** 货柜号 */
  containerNo = "";

  /** 计泡基数 */
  countBubbleBase = undefined;

  /** 创建人 */
  createBy = "";

  /** 申报币种 */
  declareCurrency = "";

  /** 申报价格 */
  declarePrice = undefined;

  /** 出库时间 */
  deliveryTime = "";

  /** 出库单号 */
  dono = "";

  /** 结束箱数 */
  endBoxQty = undefined;

  /** 结束创建时间 */
  endCreateTime = "";

  /** 结束出库时间 */
  endDeliveryTime = "";

  /** 结束FBA到仓时间 */
  endFbaInTime = "";

  /** FBA账号 */
  fbaAccount = "";

  /** id */
  id = undefined;

  /** id集合 勾选导出时传 */
  ids = [];

  /** 1是，0否 */
  ifNewProduct = undefined;

  /** 是否装板 */
  isPlate = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 是否需要物流面单 0:否 1:是 */
  logisticsFlag = undefined;

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 站点/市场 */
  marketplaces = "";

  /** 排序字段 create_time or update_time */
  orderBy = "";

  /** 拣货人 */
  pickBy = "";

  /** 拣货单号 */
  pickno = "";

  /** 托盘数 */
  plateQty = undefined;

  /** 总数量 */
  qty = undefined;

  /** referenceId */
  referenceId = "";

  /** shipment */
  shipment = "";

  /** shipmentName */
  shipmentName = "";

  /** 运输方式 1：龙舟空运 2：龙舟海运 3：龙舟快船 4：龙舟散货 10 普通空运 15：普通空运(带电带磁)，20 普通海运，30 快船，40 铁路 50：卡车 60：快递 */
  shippingType = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** sku */
  sku = "";

  /** sku种类数量 */
  skuQty = undefined;

  /** 来源母仓库编号 */
  sourceRootWarehouseCode = "";

  /** 来源母仓库编号 */
  sourceRootWarehouseCodeList = [];

  /** 来源类型：10 手工创建，20 调拨计划创建 */
  sourceType = undefined;

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库编号集合 */
  sourceWarehouseCodeList = [];

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 调拨状态：10 未处理，20 已打印，30 已拣货，40 已装箱，50 待发运，55 发运中，57 发运失败 ，60 已发运，62 已退件签收，65 中转签收，68 中转发运 69: 部分收货 70 已完成，80 已取消 90 待还货 */
  status = undefined;

  /** 状态 多选 */
  statusList = [];

  /** 调拨状态范围 */
  statusRange = undefined;

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 是否含税 0:否1:是 */
  taxFlag = undefined;

  /** 调出交易主体编号 */
  tradeCompanyCode = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称 */
  tradeCompanyInName = "";

  /** 调出交易主体名称 */
  tradeCompanyName = "";

  /** 是否中转：1是 0否 */
  transitFlag = undefined;

  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨 50：WFS调拨 */
  type = undefined;

  /** 是否上传装箱信息：1是 0否 */
  uploadBoxFlag = undefined;

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 重量 */
  weight = undefined;
}

class AllocationMasterResponseDto {
  /** 调拨批次号 */
  abno = "";

  /** 调拨单号 */
  aono = "";

  /** 箱外标签文件路径 */
  boxLabelPath = "";

  /** 箱数 */
  boxQty = undefined;

  /** 散货审批附件 */
  bulkCargoFile = "";

  /** 订舱状态：10待绑舱，20预订舱，30预订舱驳回，40已订舱，50已绑舱，60体外订舱 */
  cabinStatus = undefined;

  /** centerId */
  centerId = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 体积重5k */
  chargeWeight5k = undefined;

  /** 体积重6k */
  chargeWeight6k = undefined;

  /** 是否校验shipment：1是 0否 */
  checkShipmentFlag = undefined;

  /** 货柜号 */
  containerNo = "";

  /** 计泡基数 */
  countBubbleBase = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申报币种 */
  declareCurrency = "";

  /** 申报价格 */
  declarePrice = undefined;

  /** 出库时间 */
  deliveryTime = "";

  /** 出库单号 */
  dono = "";

  /** FBA账号 */
  fbaAccount = "";

  /** FBA到仓时间 */
  fbaInTime = "";

  /** id */
  id = undefined;

  /** 是否新品调拨 */
  ifNewProduct = undefined;

  /** 是否装板 */
  isPlate = undefined;

  /** 外箱标签数量 */
  labelQty = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 是否需要物流面单 0:否 1:是 */
  logisticsFlag = undefined;

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 站点/市场 */
  marketplaces = "";

  /** 拣货单号 */
  pickno = "";

  /** 托盘数 */
  plateQty = undefined;

  /** 总数量 */
  qty = undefined;

  /** referenceId */
  referenceId = "";

  /** 备注 */
  remark = "";

  /** 是否调拨销售 1：是 0：否 */
  saleFlag = undefined;

  /** shipment */
  shipment = "";

  /** shipmentName */
  shipmentName = "";

  /** 运输方式 1：龙舟空运 2：龙舟海运 3：龙舟快船 4：龙舟散货 10 普通空运 15：普通空运(带电带磁)，20 普通海运，30 快船，40 铁路 50：卡车 60：快递 */
  shippingType = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺信息 */
  shopDepartmentMappingResponseDto = new ShopDepartmentMappingResponseDto();

  /** 店铺名称 */
  shopName = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** sku种类数量 */
  skuQty = undefined;

  /** 来源类型：10 手工创建，20 调拨计划创建 */
  sourceType = undefined;

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 调拨状态：10 未处理，20 已打印，30 已拣货，40 已装箱，50 待发运，55：发运中 57：发运失败 60 已发运，62：已退件签收 65：中转签收 68：中转发运 69：部分收货 70 已完成，80 已取消 90 待还货 */
  status = undefined;

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 是否含税 0:否1:是 */
  taxFlag = undefined;

  /** 调出交易主体编号 */
  tradeCompanyCode = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称 */
  tradeCompanyInName = "";

  /** 调出交易主体名称 */
  tradeCompanyName = "";

  /** 是否中转：1是 0否 */
  transitFlag = undefined;

  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨 50：WFS调拨 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 是否上传装箱信息：1是 0否 */
  uploadBoxFlag = undefined;

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 重量 */
  weight = undefined;
}

class AllocationMasterRpcResponseDto {
  /** 调拨批次号 */
  abno = "";

  /** 调拨单号 */
  aono = "";

  /** 箱外标签文件路径 */
  boxLabelPath = "";

  /** 箱数 */
  boxQty = undefined;

  /** 散货审批附件 */
  bulkCargoFile = "";

  /** 订舱状态：10待绑舱，20预订舱，30预订舱驳回，40已订舱，50已绑舱，60体外订舱 */
  cabinStatus = undefined;

  /** centerId */
  centerId = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 体积重5k */
  chargeWeight5k = undefined;

  /** 体积重6k */
  chargeWeight6k = undefined;

  /** 货柜号 */
  containerNo = "";

  /** 计泡基数 */
  countBubbleBase = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申报币种 */
  declareCurrency = "";

  /** 申报价格 */
  declarePrice = undefined;

  /** 出库时间 */
  deliveryTime = "";

  /** 出库单号 */
  dono = "";

  /** FBA账号 */
  fbaAccount = "";

  /** id */
  id = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 是否需要物流面单 0:否 1:是 */
  logisticsFlag = undefined;

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 站点/市场 */
  marketplaces = "";

  /** 拣货单号 */
  pickno = "";

  /** 渠道/平台key */
  platformKey = "";

  /** 渠道/平台名称 */
  platformName = "";

  /** 总数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** shipmentName */
  shipmentName = "";

  /** 运输方式：10 空运，20 海运，30 快船，40 铁路 */
  shippingType = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺信息 */
  shopDepartmentMappingResponseDto = new ShopDepartmentMappingResponseDto();

  /** 店铺名称 */
  shopName = "";

  /** sku种类数量 */
  skuQty = undefined;

  /** sku数量详情 */
  skuQtyDetailList = [];

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 调拨状态：10 未处理，20 已打印，30 已拣货，40 已装箱，50 待发运，60 已发运，70 已完成，80 已取消 */
  status = undefined;

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 是否含税 0:否1:是 */
  taxFlag = undefined;

  /** 调出交易主体编号 */
  tradeCompanyCode = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称 */
  tradeCompanyInName = "";

  /** 调出交易主体名称 */
  tradeCompanyName = "";

  /** 是否中转：1是 0否 */
  transitFlag = undefined;

  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 是否上传装箱信息：1是 0否 */
  uploadBoxFlag = undefined;

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 重量 */
  weight = undefined;
}

class AllocationMasterUpdateRequestDto {
  /** 调拨单号 */
  aono = "";

  /** 运输方式 */
  shippingType = undefined;
}

class AllocationMasterWFSResponseDto {
  /** 品牌名称 */
  brandName = "";

  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** CenterId */
  centerId = "";

  /** 产品高 */
  fnsku = "";

  /** 产品高 */
  heightCm = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 物流分组 */
  logisticsGroup = "";

  /** 产品长 */
  longCm = undefined;

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 每箱数量（MPQ） */
  mpq = undefined;

  /** msku */
  msku = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** 产品编号 */
  productNo = "";

  /** 产品用途（CN） */
  productUseCn = "";

  /** 需求数量 */
  qty = undefined;

  /** sku */
  skuNo = "";

  /** 产品名称（CN） */
  skuTitleCn = "";

  /** SKU标题（EN） */
  skuTitleEn = "";

  /** 装箱体积（CM3） */
  volume = undefined;

  /** 产品重量（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class AllocationMasterWithDetailsResponseDto {
  /** 调拨批次号 */
  abno = "";

  /** 调拨单号 */
  aono = "";

  /** 箱外标签文件路径 */
  boxLabelPath = "";

  /** 箱数 */
  boxQty = undefined;

  /** 散货审批附件 */
  bulkCargoFile = "";

  /** 订舱状态：10待绑舱，20预订舱，30预订舱驳回，40已订舱，50已绑舱，60体外订舱 */
  cabinStatus = undefined;

  /** centerId */
  centerId = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 体积重5k */
  chargeWeight5k = undefined;

  /** 体积重6k */
  chargeWeight6k = undefined;

  /** 是否校验shipment：1是 0否 */
  checkShipmentFlag = undefined;

  /** 货柜号 */
  containerNo = "";

  /** 计泡基数 */
  countBubbleBase = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申报币种 */
  declareCurrency = "";

  /** 申报价格 */
  declarePrice = undefined;

  /** 出库时间 */
  deliveryTime = "";

  /** 明细 */
  details = [];

  /** 出库单号 */
  dono = "";

  /** FBA账号 */
  fbaAccount = "";

  /** FBA到仓时间 */
  fbaInTime = "";

  /** id */
  id = undefined;

  /** 是否新品调拨 */
  ifNewProduct = undefined;

  /** 是否装板 */
  isPlate = undefined;

  /** 外箱标签数量 */
  labelQty = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 是否需要物流面单 0:否 1:是 */
  logisticsFlag = undefined;

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 站点/市场 */
  marketplaces = "";

  /** 拣货单号 */
  pickno = "";

  /** 托盘数 */
  plateQty = undefined;

  /** 总数量 */
  qty = undefined;

  /** referenceId */
  referenceId = "";

  /** 备注 */
  remark = "";

  /** 是否调拨销售 1：是 0：否 */
  saleFlag = undefined;

  /** shipment */
  shipment = "";

  /** shipmentName */
  shipmentName = "";

  /** 运输方式 1：龙舟空运 2：龙舟海运 3：龙舟快船 4：龙舟散货 10 普通空运 15：普通空运(带电带磁)，20 普通海运，30 快船，40 铁路 50：卡车 60：快递 */
  shippingType = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺信息 */
  shopDepartmentMappingResponseDto = new ShopDepartmentMappingResponseDto();

  /** 店铺名称 */
  shopName = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** sku种类数量 */
  skuQty = undefined;

  /** 来源类型：10 手工创建，20 调拨计划创建 */
  sourceType = undefined;

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 调拨状态：10 未处理，20 已打印，30 已拣货，40 已装箱，50 待发运，55：发运中 57：发运失败 60 已发运，62：已退件签收 65：中转签收 68：中转发运 69：部分收货 70 已完成，80 已取消 90 待还货 */
  status = undefined;

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 是否含税 0:否1:是 */
  taxFlag = undefined;

  /** 调出交易主体编号 */
  tradeCompanyCode = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称 */
  tradeCompanyInName = "";

  /** 调出交易主体名称 */
  tradeCompanyName = "";

  /** 是否中转：1是 0否 */
  transitFlag = undefined;

  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨 50：WFS调拨 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 是否上传装箱信息：1是 0否 */
  uploadBoxFlag = undefined;

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 重量 */
  weight = undefined;
}

class AllocationOperationTimeResponseDto {
  /** 调拨单号 */
  aono = "";

  /** 分箱时间 */
  boxTime = "";

  /** 创建拣货单时间 */
  createPickTime = "";

  /** 创建时间 */
  createTime = "";

  /** 发运时间 */
  deliveryTime = "";

  /** 拣货时间 */
  pickTime = "";
}

class AllocationPlanPageResponseDto {
  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨，50 WFS调拨 */
  allocationType = undefined;

  /** 调拨单号 */
  aono = "";

  /** 品牌名称 */
  brandName = "";

  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** centerId */
  centerId = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 商品尺寸: 10 标准件，20 大件 */
  commoditySize = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建人姓名 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 错误信息 */
  errorMessage = "";

  /** 积加发货地址ID */
  gjShipfromAddress = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 物流分组 */
  logisticsGroup = "";

  /** 材质 */
  material = "";

  /** MSKU */
  msku = "";

  /** 产品编号 */
  productCode = "";

  /** 产品英文标题 */
  productEnglishTitle = "";

  /** 产品高(cm) */
  productHeight = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品长(cm) */
  productLength = undefined;

  /** 产品标题 */
  productTitle = "";

  /** 产品重量(g) */
  productWeight = undefined;

  /** 产品宽(cm) */
  productWidth = undefined;

  /** 用途 */
  purpose = "";

  /** 数量 */
  qty = undefined;

  /** referenceId */
  referenceId = "";

  /** 备注 */
  remark = "";

  /** 销售负责人 */
  saleOwner = "";

  /** shipment */
  shipment = "";

  /** 运输方式：1 龙舟空运，2 龙舟海运，3 龙舟快船，4 龙舟散货，10 普通空运，15 普通空运(带电带磁)，20 普通海运，30 快船，40 铁路，50 卡车，60 快递 */
  shippingType = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU */
  sku = "";

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 调拨计划状态：10 待生成，15 生成中，20 生成成功，30 生成失败 */
  status = undefined;

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 订舱状态：10待绑舱，20预订舱，30预订舱驳回，40已订舱，50已绑舱，60体外订舱 */
  toCabinStatus = undefined;

  /** 调拨单状态：10 未处理，20 已打印，30 已拣货，40 已装箱，50 待发运，60 已发运，65 中转签收，68 中转发运，70 已完成，80 已取消，90 待还货 */
  toStatus = undefined;

  /** 调拨计划单号 */
  tpno = "";

  /** 调出交易主体编号 */
  tradeCompanyCode = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称 */
  tradeCompanyInName = "";

  /** 调出交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新人姓名 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class AllocationPlanUpdateRequestDto {
  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨，50 WFS调拨 */
  allocationType = undefined;

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** id */
  id = undefined;

  /** 数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** 运输方式：1 龙舟空运，2 龙舟海运，3 龙舟快船，4 龙舟散货，10 普通空运，15 普通空运(带电带磁)，20 普通海运，30 快船，40 铁路，50 卡车，60 快递 */
  shippingType = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU */
  sku = "";

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 调拨计划单号 */
  tpno = "";

  /** 调出交易主体编号 */
  tradeCompanyCode = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称 */
  tradeCompanyInName = "";

  /** 调出交易主体名称 */
  tradeCompanyName = "";
}

class AllocationTrialPageResponseDto {
  /** 调拨单明细 */
  allocationDetailModels = [];

  /** 调拨单 */
  allocationMasterModel = new AllocationMasterModel();

  /** 调拨类型 */
  allocationType = undefined;

  /** 申请原因 */
  applyCause = "";

  /** 审批状态 */
  approvalStatus = undefined;

  /** centerId */
  centerId = "";

  /** centerId */
  centerIdBefore = "";

  /** 调拨单修改类型 */
  changeType = undefined;

  /** 修改类型 */
  modifyType = undefined;

  /** referenceID */
  referenceId = "";

  /** referenceID */
  referenceIdBefore = "";

  /** shipment */
  shipment = "";

  /** shipment */
  shipmentBefore = "";

  /** 目标仓库编码 */
  targetWarehouseCode = "";

  /** 目标仓库编码 */
  targetWarehouseCodeBefore = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 目标仓库名称 */
  targetWarehouseNameBefore = "";
}

class AllocationUpdateCabinStatusRequestDto {
  /** 调拨单号 */
  aono = "";

  /** 订舱状态 */
  cabinStatus = undefined;

  /** 是否解绑调拨批次 */
  isUnbind = false;
}

class AllocationUpdateOrderStatusDto {
  /** 调拨单单号 */
  aoNo = "";

  /** 状态 */
  status = undefined;
}

class AllocationWFSLabelResponseDto {
  /** 承运人标签 */
  boxLabelPath = "";

  /** 入库货件标签 */
  logisticsLabelPath = "";
}

class ApprovalBeforeRequestDto {
  /** 业务Key，例如盘点单号 */
  businessKey = "";

  /** 页大小 */
  pageNumber = undefined;

  /** 页号 */
  pageSize = undefined;

  /** 流程定义key,盘点：InventoryApproval */
  processKey = "";
}

class ApprovalRequestDto {
  /** 审批状态：待提交：-1，已驳回：0；已通过<流程结束传>：1；审批中<只要流程没结束都是传该状态>：2；已撤回：3 ；已挂起：4；已删除：5；流程终止：-2 */
  approvalStatus = undefined;

  /** 审批意见 */
  approvalSug = "";

  /** 审批流程号 */
  businessKey = "";

  /** 表单数据 */
  formData = undefined;

  /** 本次操作 */
  operateTaskDto = new CurrentTaskDto();

  /** 流程实例id */
  processInstanceId = "";

  /** 流程定义key */
  processKey = "";

  /** 是否需要开启审批流 */
  startApproval = false;

  /** 驳回目标节点 */
  taskDto = new TaskDto();
}

class AssigneeDto {
  /** 操作人内部编号 */
  userCode = "";

  /** 操作人名称 */
  userName = "";
}

class BatchPostponementRequestDto {
  /** 需求订单NO */
  dono = "";

  /** id */
  id = undefined;

  /** SKU编号 */
  skuNo = "";
}

class ChangeOrderApprovalDto {
  /** 备注 */
  applyMemo = "";

  /** 审批状态 0：驳回 1: 通过 */
  approvalStatus = undefined;

  /** id */
  id = undefined;
}

class ChangeOrderCreateDto {
  /** Bu编码 */
  buCode = undefined;

  /** 变更单明细 */
  detailList = [];

  /** 变更模式：0：前提 1：延后 2:作废 */
  mode = undefined;

  /** 变更原因 */
  reason = "";

  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 变更类型：0：合并 1：拆分 2:作废 */
  type = undefined;
}

class ChangeOrderDetailCreateDto {
  /** 调拨单创建占用数量 */
  allocationOccupyQty = undefined;

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 发运数量 */
  deliveryQty = undefined;

  /** 需求日期 0：上半月 1：下半月 */
  demandDate = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 需求订单NO */
  dono = "";

  /** 是否工厂直发 */
  factoryDirectHairFlag = false;

  /** 终审订单数量 */
  finalQty = undefined;

  /** 最小装箱数 */
  mpq = undefined;

  /** 采购在途库存(占用关系) */
  purchaseStock = undefined;

  /** 运输方式 ：10:空运, 20:海运，30:快船 ,40:铁路 */
  shippingMode = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** 订单类型：0：原订单 1：新订单 2：已发运订单 */
  type = undefined;

  /** 待下单数量(占用关系) */
  waitPlaceOrderQty = undefined;

  /** 国内仓库存(占用关系) */
  warehouseCnStock = undefined;
}

class ChangeOrderDetailRequestDto {
  /** 调拨单创建占用数量 */
  allocationOccupyQty = undefined;

  /** 审批号 */
  approvalNo = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 发运数量 */
  deliveryQty = undefined;

  /** 需求日期 0：上半月 1：下半月 */
  demandDate = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 需求订单NO */
  dono = "";

  /** 是否工厂直发 */
  factoryDirectHairFlag = false;

  /** 终审订单数量 */
  finalQty = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 最小装箱数 */
  mpq = undefined;

  /** 采购在途库存(占用关系) */
  purchaseStock = undefined;

  /** 运输方式 ：10:空运, 20:海运，30:快船 ,40:铁路 */
  shippingMode = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** 订单类型：0：原订单 1：新订单 2：已发运订单 */
  type = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 待下单数量(占用关系) */
  waitPlaceOrderQty = undefined;

  /** 国内仓库存(占用关系) */
  warehouseCnStock = undefined;
}

class ChangeOrderDetailResponseDto {
  /** 调拨单创建占用数量 */
  allocationOccupyQty = undefined;

  /** 审批号 */
  approvalNo = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 发运数量 */
  deliveryQty = undefined;

  /** 需求日期 0：上半月 1：下半月 */
  demandDate = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 需求订单NO */
  dono = "";

  /** 是否工厂直发 */
  factoryDirectHairFlag = false;

  /** 终审订单数量 */
  finalQty = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 最小装箱数 */
  mpq = undefined;

  /** 采购在途库存(占用关系) */
  purchaseStock = undefined;

  /** 运输方式 ：10:空运, 20:海运，30:快船 ,40:铁路 */
  shippingMode = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** 订单类型：0：原订单 1：新订单 2：已发运订单 */
  type = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 待下单数量(占用关系) */
  waitPlaceOrderQty = undefined;

  /** 国内仓库存(占用关系) */
  warehouseCnStock = undefined;
}

class ChangeOrderRequestDto {
  /** 提交人 */
  applyUser = "";

  /** 审批号 */
  approvalNo = "";

  /** Bu编码 */
  buCode = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 变更类型：0：合并 1：拆分 */
  mode = undefined;

  /** 工作流实例id */
  processInstanceId = "";

  /** 变更原因 */
  reason = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回人 */
  rejecter = "";

  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 审批状态： -1：待审核 0：已驳回 1：审核中 2：已通过  */
  status = undefined;

  /** 变更类型：0：合并 1：拆分 */
  type = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ChangeOrderResponseDto {
  /** 提交人 */
  applyUser = "";

  /** 审批号 */
  approvalNo = "";

  /** Bu编码 */
  buCode = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 变更类型：0：合并 1：拆分 */
  mode = undefined;

  /** 工作流实例id */
  processInstanceId = "";

  /** 变更原因 */
  reason = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回人 */
  rejecter = "";

  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 审批状态： -1：待审核 0：已驳回 1：审核中 2：已通过  */
  status = undefined;

  /** 变更类型：0：合并 1：拆分 */
  type = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CheckDemandQtyRequestDto {
  /** 渠道key */
  channelKey = "";

  /** 数量 */
  qty = undefined;

  /** 站点 */
  siteKey = "";

  /** sku */
  skuNo = "";
}

class CodeAndNameListResponseDto {
  /** code */
  code = "";

  /** id */
  id = undefined;

  /** name */
  name = "";
}

class CreateInDetailWithBoxRequestDto {
  /** 交货箱信息 */
  inDeliveryDetailBoxRequestDtos = [];

  /** 操作单号 出库计划单或者库存调整单 */
  operationNo = "";

  /** 来源操作订单类型 1:入库计划单,2:出库计划单,3:库存调整单 */
  operationOrderType = undefined;

  /** 交货信息 */
  requestDto = new InMasterCreateRequestDto();
}

class CreateShipmentLabelRequestDto {
  /** msku */
  msku = "";

  /** 平台 */
  platform = "";

  /** 店铺 */
  shopNo = "";
}

class CreateShipmentLabelResponseDto {
  /** FNSKU */
  fnsku = "";

  /** msku */
  msku = "";

  /** 英文标题 */
  shopName = "";

  /** 英文标题 */
  title = "";
}

class CurrentTaskDto {
  /** 节点当前处理人 */
  currentAssignee = new AssigneeDto();

  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 节点操作类型 驳回指定节点:backToStart；驳回:reject；通过:pass,；反对：oppose；弃权：abandon；终止：cadence */
  operate = "";

  /** 任务id */
  taskId = "";
}

class DeclarationPushEbsRequestDto {
  /** aoNo单号列表 */
  aoNoList = [];

  /** 合同号 */
  contractNo = "";

  /** tmsNo单号 */
  tmsNo = "";
}

class DefaultShopInfoRequestDto {
  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨，50 WFS调拨 */
  allocationType = undefined;

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 是否默认 0:否1:是 */
  defaultFlag = undefined;

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 操作日志key:仓库+调拨类型+渠道+站点+店铺+SKU+Msku */
  key = "";

  /** MSKU */
  msku = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU */
  sku = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class DefaultShopInfoResponseDto {
  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨，50 WFS调拨 */
  allocationType = undefined;

  /** 调拨类型：10 普通调拨，20 FBA调拨，30 三方调拨，40 搬仓调拨，50 WFS调拨 */
  allocationTypeName = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 军团名称 */
  corpsName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 是否默认 0:否1:是 */
  defaultFlag = undefined;

  /** 信息明细 */
  defaultShopInfoDtos = [];

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** MSKU */
  msku = "";

  /** remark */
  remark = "";

  /** 销售负责人编码 */
  salesManagerCode = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU */
  sku = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class DeleteBillRequestDto {
  /** 单号 */
  code = [];

  /** 类型 */
  type = undefined;
}

class DeliveryNoteExcelDetailRequestDto {
  /** 箱数 */
  boxQty = "";

  /** 装箱数量 */
  boxSumQty = "";

  /** 单箱体积 */
  boxVolume = "";

  /** 是否质检 */
  itemCheck = "";

  /** 采购单号 */
  pono = "";

  /** 产品名称 */
  productName = "";

  /** 出货数量 */
  qty = "";

  /** 纸箱尺寸 */
  size = "";

  /** SKU */
  sku = "";

  /** 总体积 */
  sumVolume = "";

  /** 供应商型号款号（选填） */
  type = "";

  /** 单箱重量 */
  weight = "";
}

class DeliveryNoteExcelRequestDto {
  /** 交货单条码 */
  codeUrl = new ImageEntity();

  /** 交货单明细数据 */
  data = [];

  /** 收货地址 */
  deliveryAddress = "";

  /** 送货类别 */
  deliveryCategory = "";

  /** 送货日期 */
  deliveryDate = "";

  /** 送货单号 */
  deliveryNo = "";

  /** 收货单位联系人 */
  deliveryRecipient = "";

  /** 发货方式 */
  deliveryType = "";

  /** 是否包含运费 */
  isContainLogisticsFee = "";

  /** 供货商地址 */
  supplierAddress = "";

  /** 供货商名称 */
  supplierName = "";

  /** 供货商联系人 */
  supplierRecipient = "";

  /** 交易主体 */
  tradeCompany = "";
}

class DemandOrderApproveDto {
  /** 是否通过 true:通过 false:驳回 */
  approve = false;

  /** 初审意见 */
  comment = "";

  /** 需求订单NO */
  dono = "";
}

class DemandOrderExcelImportDto {
  /** channelKey */
  channelKey = "";

  /** 渠道 */
  channelName = "";

  /** demandDate */
  demandDate = undefined;

  /** 需求日期 */
  demandDateName = "";

  /** factoryDirectHairFlag */
  factoryDirectHairFlag = false;

  /** 是否工厂直发 */
  factoryDirectHairFlagName = "";

  /** 预计销售月份数量 */
  forecastSaleMonthQty = undefined;

  /** 订单数量 */
  initQty = undefined;

  /** shippingMode */
  shippingMode = undefined;

  /** 运输方式 */
  shippingModeName = "";

  /** siteKey */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** uniqueKey */
  uniqueKey = "";
}

class DemandOrderRequestDto {
  /** 海外库存 */
  abroadStock = undefined;

  /** 海外在途 */
  abroadTransit = undefined;

  /** 调拨占用数量 */
  allocationOccupyQty = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 基线预测版本 */
  baselineVersion = "";

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 商品分段 */
  commoditySize = undefined;

  /** 当月1日-当日销量 */
  currentMonthSales = undefined;

  /** 调拨发运日期 */
  deliveryDate = "";

  /** 发运数量 */
  deliveryQty = undefined;

  /** 需求日期 0：上半月 1：下半月 */
  demandDate = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 定金比例 */
  depositRatio = undefined;

  /** 需求订单NO */
  dono = "";

  /** 是否工厂直发 */
  factoryDirectHairFlag = false;

  /** FBA积压库存 */
  fbaBacklog = undefined;

  /** FBA库存 */
  fbaStock = undefined;

  /** FBA在途库存 */
  fbaTransit = undefined;

  /** 终审订单数量 */
  finalQty = undefined;

  /** 终审意见 */
  finalTrialComment = "";

  /** 终审单号 */
  finalTrialNo = "";

  /** 初审意见 */
  firstTrialComment = "";

  /** 初审单号 */
  firstTrialNo = "";

  /** id */
  id = undefined;

  /** 入库时间 */
  inboundTime = "";

  /** 最初订单数量 */
  initQty = undefined;

  /** 装箱数量 */
  mpq = undefined;

  /** 计划员 */
  planner = "";

  /** 产品分级 */
  productLevel = "";

  /** 一级产品线 */
  productLine1st = "";

  /** 二级产品线 */
  productLine2nd = "";

  /** 三级产品线 */
  productLine3rd = "";

  /** spu产品id */
  productNo = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 采购提前期（天） */
  purchaseLeadtime = undefined;

  /** 采购在途库存(占用关系) */
  purchaseStock = undefined;

  /** 采购单价 */
  purchaseUnitPrice = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 补货计划数量 */
  replenishmentPlanQty = undefined;

  /** 销售负责人 */
  saleOwner = "";

  /** 销售单价 */
  salesUnitPrice = undefined;

  /** SBU名称 */
  sbuName = "";

  /** 近7天销量 */
  sevenDaySales = undefined;

  /** 运输方式 ：10:空运, 20:海运，30:快船 ,40:铁路 */
  shippingMode = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** 采购在途库存(sku维度) */
  skuPurchaseStock = undefined;

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 国内仓库存(sku维度) */
  skuWarehouseCnStock = undefined;

  /** 订单状态，0：未锁定，10：待初审，20：初审驳回，30：待生成供需平衡，40：待终审，50：终审驳回,60：待生成补货计划，70：变更审批中，80：冻结期订单审批，90：待入库，100：待调拨 110：已作废，120：已完结 */
  status = undefined;

  /** 剩余未完结数量(占用关系) */
  surplusQty = undefined;

  /** T月基线预测 */
  t0BaselineForecast = undefined;

  /** T+10月销量 */
  t10Sales = undefined;

  /** T+11月销量 */
  t11Sales = undefined;

  /** T+12月销量 */
  t12Sales = undefined;

  /** T+1月基线预测 */
  t1BaselineForecast = undefined;

  /** T+1月销量 */
  t1Sales = undefined;

  /** T+2月基线预测 */
  t2BaselineForecast = undefined;

  /** T+2月销量 */
  t2Sales = undefined;

  /** T+3月基线预测 */
  t3BaselineForecast = undefined;

  /** T+3月销量 */
  t3Sales = undefined;

  /** T+4月基线预测 */
  t4BaselineForecast = undefined;

  /** T+4月销量 */
  t4Sales = undefined;

  /** T+5月基线预测 */
  t5BaselineForecast = undefined;

  /** T+5月销量 */
  t5Sales = undefined;

  /** T+6月销量 */
  t6Sales = undefined;

  /** T+7月销量 */
  t7Sales = undefined;

  /** T+8月销量 */
  t8Sales = undefined;

  /** T+9月销量 */
  t9Sales = undefined;

  /** 最近30天有效销量 */
  thirtyDaySales = undefined;

  /** 待下单数量 */
  waitPlaceOrderQty = undefined;

  /** 国内仓库存(占用关系) */
  warehouseCnStock = undefined;
}

class DemandOrderResponseDto {
  /** 海外库存 */
  abroadStock = undefined;

  /** 海外在途 */
  abroadTransit = undefined;

  /** 调拨占用数量 */
  allocationOccupyQty = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 基线预测版本 */
  baselineVersion = "";

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 商品分段 */
  commoditySize = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当月1日-当日销量 */
  currentMonthSales = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 调拨发运日期 */
  deliveryDate = "";

  /** 发运数量 */
  deliveryQty = undefined;

  /** 需求日期 0：上半月 1：下半月 */
  demandDate = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 定金比例 */
  depositRatio = undefined;

  /** 需求订单NO */
  dono = "";

  /** 是否工厂直发 */
  factoryDirectHairFlag = false;

  /** FBA积压库存 */
  fbaBacklog = undefined;

  /** FBA库存 */
  fbaStock = undefined;

  /** FBA在途库存 */
  fbaTransit = undefined;

  /** 终审订单数量 */
  finalQty = undefined;

  /** 终审意见 */
  finalTrialComment = "";

  /** 终审单号 */
  finalTrialNo = "";

  /** 初审意见 */
  firstTrialComment = "";

  /** 初审单号 */
  firstTrialNo = "";

  /** id */
  id = undefined;

  /** 入库时间 */
  inboundTime = "";

  /** 最初订单数量 */
  initQty = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 装箱数量 */
  mpq = undefined;

  /** 计划员 */
  planner = "";

  /** 计划员code */
  plannerCode = "";

  /** 产品分级 */
  productLevel = "";

  /** 一级产品线 */
  productLine1st = "";

  /** 二级产品线 */
  productLine2nd = "";

  /** 三级产品线 */
  productLine3rd = "";

  /** spu产品id */
  productNo = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 采购提前期（天） */
  purchaseLeadtime = undefined;

  /** 采购在途库存(占用关系) */
  purchaseStock = undefined;

  /** 采购单价 */
  purchaseUnitPrice = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 补货计划数量 */
  replenishmentPlanQty = undefined;

  /** 销售负责人 */
  saleOwner = "";

  /** 销售负责code */
  saleOwnerCode = "";

  /** 销售单价 */
  salesUnitPrice = undefined;

  /** SBU名称 */
  sbuName = "";

  /** 近7天销量 */
  sevenDaySales = undefined;

  /** 运输方式 ：10:空运, 20:海运，30:快船 ,40:铁路 */
  shippingMode = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** 采购在途库存(sku维度) */
  skuPurchaseStock = undefined;

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 国内仓库存(sku维度) */
  skuWarehouseCnStock = undefined;

  /** 订单状态，0：未锁定，10：待初审，20：初审驳回，30：待生成供需平衡，40：待终审，50：终审驳回,60：待生成补货计划，70：变更审批中，80：冻结期订单审批，90：待入库，100：待调拨 110：已作废，120：已完结 */
  status = undefined;

  /** 剩余未完结数量(占用关系) */
  surplusQty = undefined;

  /** T月基线预测 */
  t0BaselineForecast = undefined;

  /** T+10月销量 */
  t10Sales = undefined;

  /** T+11月销量 */
  t11Sales = undefined;

  /** T+12月销量 */
  t12Sales = undefined;

  /** T+1月基线预测 */
  t1BaselineForecast = undefined;

  /** T+1月销量 */
  t1Sales = undefined;

  /** T+2月基线预测 */
  t2BaselineForecast = undefined;

  /** T+2月销量 */
  t2Sales = undefined;

  /** T+3月基线预测 */
  t3BaselineForecast = undefined;

  /** T+3月销量 */
  t3Sales = undefined;

  /** T+4月基线预测 */
  t4BaselineForecast = undefined;

  /** T+4月销量 */
  t4Sales = undefined;

  /** T+5月基线预测 */
  t5BaselineForecast = undefined;

  /** T+5月销量 */
  t5Sales = undefined;

  /** T+6月销量 */
  t6Sales = undefined;

  /** T+7月销量 */
  t7Sales = undefined;

  /** T+8月销量 */
  t8Sales = undefined;

  /** T+9月销量 */
  t9Sales = undefined;

  /** 最近30天有效销量 */
  thirtyDaySales = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 待下单数量 */
  waitPlaceOrderQty = undefined;

  /** 国内仓库存(占用关系) */
  warehouseCnStock = undefined;
}

class ExWarehouseResponseDto {
  /** BU名称 */
  buName = "";

  /** 渠道名称 */
  channelName = "";

  /** 计划员 */
  planner = "";

  /** 产品分级 */
  productLevel = "";

  /** 采购负责人 */
  purchaser = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** T月预出库金额 */
  t0StockAmount = undefined;

  /** T月预出库数量 */
  t0StockQty = undefined;

  /** T-10月出库金额 */
  t10OutStockAmount = undefined;

  /** T-10月出库数量 */
  t10OutStockQty = undefined;

  /** T-11月出库金额 */
  t11OutStockAmount = undefined;

  /** T-11月出库数量 */
  t11OutStockQty = undefined;

  /** T-12月出库金额 */
  t12OutStockAmount = undefined;

  /** T-12月出库数量 */
  t12OutStockQty = undefined;

  /** T-1月出库金额 */
  t1OutStockAmount = undefined;

  /** T-1月出库数量 */
  t1OutStockQty = undefined;

  /** T-1月预出库金额 */
  t1StockAmount = undefined;

  /** T+1月预出库数量 */
  t1StockQty = undefined;

  /** T-2月出库金额 */
  t2OutStockAmount = undefined;

  /** T-2月出库数量 */
  t2OutStockQty = undefined;

  /** T-2月预出库金额 */
  t2StockAmount = undefined;

  /** T+2月预出库数量 */
  t2StockQty = undefined;

  /** T-3月出库金额 */
  t3OutStockAmount = undefined;

  /** T-3月出库数量 */
  t3OutStockQty = undefined;

  /** T-3月预出库金额 */
  t3StockAmount = undefined;

  /** T+3月预出库数量 */
  t3StockQty = undefined;

  /** T-4月出库金额 */
  t4OutStockAmount = undefined;

  /** T-4月出库数量 */
  t4OutStockQty = undefined;

  /** T-4月预出库金额 */
  t4StockAmount = undefined;

  /** T+4月预出库数量 */
  t4StockQty = undefined;

  /** T-5月出库金额 */
  t5OutStockAmount = undefined;

  /** T-5月出库数量 */
  t5OutStockQty = undefined;

  /** T-5月预出库金额 */
  t5StockAmount = undefined;

  /** T+5月预出库数量 */
  t5StockQty = undefined;

  /** T-6月出库金额 */
  t6OutStockAmount = undefined;

  /** T-6月出库数量 */
  t6OutStockQty = undefined;

  /** T-6月预出库金额 */
  t6StockAmount = undefined;

  /** T+6月预出库数量 */
  t6StockQty = undefined;

  /** T-7月出库金额 */
  t7OutStockAmount = undefined;

  /** T-7月出库数量 */
  t7OutStockQty = undefined;

  /** T-8月出库金额 */
  t8OutStockAmount = undefined;

  /** T-8月出库数量 */
  t8OutStockQty = undefined;

  /** T-9月出库金额 */
  t9OutStockAmount = undefined;

  /** T-9月出库数量 */
  t9OutStockQty = undefined;
}

class FilterRuleBean {
  /** 缺货时是否匹配所有仓库：1是 0否 */
  isAllWarehouses = undefined;

  /** 是否优先FBA发货：1是 0否 */
  isFbaFirst = undefined;

  /** 是否启用价格范围左：1是 0否 */
  isPriceRangeLeft = undefined;

  /** 是否启用价格范围右：1是 0否 */
  isPriceRangeRight = undefined;

  /** 价格范围左符号： >大于, >=大于等于, =等于 */
  priceRangeLeftSymbol = "";

  /** 价格范围左金额 */
  priceRangeLeftValue = undefined;

  /** 价格范围右符号： <小于, <=小于等于 */
  priceRangeRightSymbol = "";

  /** 价格范围右金额 */
  priceRangeRightValue = undefined;

  /** 匹配SKU */
  sku = [];

  /** 匹配仓库 */
  warehouses = [];

  /** 分区集合 */
  zones = [];
}

class FinalApproveRequestDto {
  /** 审批意见 */
  comment = "";

  /** 历史尾款 */
  historyBalanceDuet = undefined;

  /** 下单预算最终分配 */
  orderBudgetRatio = undefined;

  /** 付款预算最终分配 */
  paymentBudgetRatio = undefined;

  /** 订单状态，true:审核通过；false：驳回 */
  status = false;

  /** 终审单号 */
  trialNo = "";
}

class FinalTrialOrderDetailRequestDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 需求订单NO */
  dono = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** 终审单号 */
  trialNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class FinalTrialOrderDetailResponseDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 需求订单NO */
  dono = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** 终审单号 */
  trialNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class FinalTrialOrderRequestDto {
  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 审批意见 */
  comment = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 历史尾款 */
  historyBalanceDuet = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 下单预算-所有 */
  orderBudgetAll = undefined;

  /** 下单预算最终分配 */
  orderBudgetRatio = undefined;

  /** 下单预算-S */
  orderBudgetS = undefined;

  /** 下单预算-SA */
  orderBudgetSa = undefined;

  /** 付款预算-所有 */
  paymentBudgetAll = undefined;

  /** 付款预算最终分配 */
  paymentBudgetRatio = undefined;

  /** 付款预算-S */
  paymentBudgetS = undefined;

  /** 付款预算-SA */
  paymentBudgetSa = undefined;

  /** 订单状态，0：待审核，1：终审驳回，2：已完成 */
  status = undefined;

  /** 终审单号 */
  trialNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class FinalTrialOrderResponseDto {
  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 审批意见 */
  comment = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 历史尾款 */
  historyBalanceDuet = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 下单预算-所有 */
  orderBudgetAll = undefined;

  /** 下单预算最终分配 */
  orderBudgetRatio = undefined;

  /** 下单预算-S */
  orderBudgetS = undefined;

  /** 下单预算-SA */
  orderBudgetSa = undefined;

  /** 付款预算-所有 */
  paymentBudgetAll = undefined;

  /** 付款预算最终分配 */
  paymentBudgetRatio = undefined;

  /** 付款预算-S */
  paymentBudgetS = undefined;

  /** 付款预算-SA */
  paymentBudgetSa = undefined;

  /** 订单状态，0：待审核，1：终审驳回，2：已完成 */
  status = undefined;

  /** 终审单号 */
  trialNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class FinanceVoucherReportDetailResponseDto {
  /** 科目 */
  account = "";

  /** 贷方本币 */
  creditMoney = "";

  /** 贷方原币 */
  creditMoneyForeign = "";

  /** 货币 */
  currency = "";

  /** 借方本币 */
  debitMoney = "";

  /** 借方原币 */
  debitMoneyForeign = "";

  /** 汇率 */
  exchangeRate = "";

  /** ID */
  id = undefined;

  /** 是否打印  0否  1是 */
  isPrint = undefined;

  /** 金额 */
  money = "";

  /** 金额（原币） */
  moneyForeign = "";

  /** 备注 */
  remark = "";
}

class FinanceVoucherReportMasterResponseDto {
  /** 总账编号 */
  accountCode = "";

  /** 子公司 */
  entity = "";

  /** 文件号码 */
  fileNumber = "";

  /** 凭证明细 */
  financeVoucherReportDetailResponseDtos = [];

  /** 会计期 */
  financialDate = "";

  /** 事务处理日期 */
  trandate = "";

  /** 类型 */
  type = "";
}

class FirstApproveRequestDto {
  /** 审批明细 */
  list = [];

  /** 初审单号 */
  trialNo = "";
}

class FirstBatchApproveRequestDto {
  /** 是否通过 true:通过 false:驳回 */
  approve = false;

  /** 初审意见 */
  comment = "";

  /** 审批号 */
  trialNoList = [];
}

class FirstTrialOrderDetailRequestDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 审批意见 */
  comment = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 需求订单NO */
  dono = "";

  /** id */
  id = undefined;

  /** 最初订单数量 */
  initQty = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** spu产品id */
  productNo = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** 订单状态，0：未评审，1：评审通过，2：已驳回 */
  status = undefined;

  /** 初审单号 */
  trialNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class FirstTrialOrderDetailResponseDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 审批意见 */
  comment = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 需求订单NO */
  dono = "";

  /** id */
  id = undefined;

  /** 最初订单数量 */
  initQty = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** 订单状态，0：未评审，1：评审通过，2：已驳回 */
  status = undefined;

  /** 初审单号 */
  trialNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class FirstTrialOrderRequestDto {
  /** 海外库存 */
  abroadStock = undefined;

  /** 海外在途 */
  abroadTransit = undefined;

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 商品分段 */
  commoditySize = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当月1日-当日销量 */
  currentMonthSales = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** FBA积压库存 */
  fbaBacklog = undefined;

  /** FBA积压库存可用天数(基线预测) */
  fbaBacklogAvailableDayBaseline = undefined;

  /** FBA积压库存可用天数(销量) */
  fbaBacklogAvailableDaySale = undefined;

  /** FBA库存 */
  fbaStock = undefined;

  /** FBA在途库存 */
  fbaTransit = undefined;

  /** 初审意见 */
  firstTrialComment = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** MOQ比例% */
  moqRatio = undefined;

  /** 装箱数量 */
  mpq = undefined;

  /** 计划员 */
  planner = "";

  /** 产品分级 */
  productLevel = "";

  /** 一级产品线 */
  productLine1st = "";

  /** 二级产品线 */
  productLine2nd = "";

  /** 三级产品线 */
  productLine3rd = "";

  /** spu产品id */
  productNo = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 采购在途库存 */
  purchaseStock = undefined;

  /** 采购在途可用天数(基线预测) */
  purchaseTransitAvailableDayBaseline = undefined;

  /** 采购在途可用天数(销量) */
  purchaseTransitAvailableDaySale = undefined;

  /** 采购单价 */
  purchaseUnitPrice = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 订单总数 */
  qty = undefined;

  /** 补货计划金额 */
  replenishmentPlanAmount = undefined;

  /** 补货计划数量 */
  replenishmentPlanQty = undefined;

  /** 销售单价 */
  salesUnitPrice = undefined;

  /** SBU名称 */
  sbuName = "";

  /** 近7天销量 */
  sevenDaySales = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 订单状态，0：未评审，1：评审通过，2：已驳回，3：已完成 */
  status = undefined;

  /** 冗余采购在途库存数量 */
  surplusPurchaseTransit = undefined;

  /** 冗余采购在途成本金额 */
  surplusTransitAmount = undefined;

  /** 冗余采购在途成本金额 */
  surplusWarehouseCnAmount = undefined;

  /** 冗余cn仓库存数量 */
  surplusWarehouseCnStock = undefined;

  /** T月基线预测 */
  t0BaselineForecast = undefined;

  /** T月基线预测 */
  t0BaselineProjections = undefined;

  /** T+10月销量 */
  t10Sales = undefined;

  /** T+11月销量 */
  t11Sales = undefined;

  /** T+12月销量 */
  t12Sales = undefined;

  /** T+1月基线预测 */
  t1BaselineForecast = undefined;

  /** T+1月销量 */
  t1Sales = undefined;

  /** T+2月基线预测 */
  t2BaselineForecast = undefined;

  /** T+2月销量 */
  t2Sales = undefined;

  /** T+3月基线预测 */
  t3BaselineForecast = undefined;

  /** T+3月销量 */
  t3Sales = undefined;

  /** T+4月基线预测 */
  t4BaselineForecast = undefined;

  /** T+4月销量 */
  t4Sales = undefined;

  /** T+5月基线预测 */
  t5BaselineForecast = undefined;

  /** T+5月销量 */
  t5Sales = undefined;

  /** T+6月销量 */
  t6Sales = undefined;

  /** T+7月销量 */
  t7Sales = undefined;

  /** T+8月销量 */
  t8Sales = undefined;

  /** T+9月销量 */
  t9Sales = undefined;

  /** 最近30天销量 */
  thirtyDaySales = undefined;

  /** 初审单号 */
  trialNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** CN仓库存可用天数(基线预测) */
  warehouseCnAvailableDayBaseline = undefined;

  /** CN仓库存可用天数(销量) */
  warehouseCnAvailableDaySale = undefined;

  /** 国内仓库存 */
  warehouseCnStock = undefined;
}

class FirstTrialOrderResponseDto {
  /** 海外库存 */
  abroadStock = undefined;

  /** 海外在途 */
  abroadTransit = undefined;

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 商品分段 */
  commoditySize = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当月1日-当日销量 */
  currentMonthSales = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 需求明细 */
  detailList = [];

  /** FBA积压库存 */
  fbaBacklog = undefined;

  /** FBA积压库存可用天数(基线预测) */
  fbaBacklogAvailableDayBaseline = undefined;

  /** FBA积压库存可用天数(销量) */
  fbaBacklogAvailableDaySale = undefined;

  /** FBA库存 */
  fbaStock = undefined;

  /** FBA在途库存 */
  fbaTransit = undefined;

  /** 初审意见 */
  firstTrialComment = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** MOQ比例% */
  moqRatio = undefined;

  /** 装箱数量 */
  mpq = undefined;

  /** 计划员 */
  planner = "";

  /** 产品分级 */
  productLevel = "";

  /** 一级产品线 */
  productLine1st = "";

  /** 二级产品线 */
  productLine2nd = "";

  /** 三级产品线 */
  productLine3rd = "";

  /** spu产品id */
  productNo = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 采购在途库存 */
  purchaseStock = undefined;

  /** 采购在途可用天数(基线预测) */
  purchaseTransitAvailableDayBaseline = undefined;

  /** 采购在途可用天数(销量) */
  purchaseTransitAvailableDaySale = undefined;

  /** 采购单价 */
  purchaseUnitPrice = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 订单总数 */
  qty = undefined;

  /** 补货计划金额 */
  replenishmentPlanAmount = undefined;

  /** 补货计划数量 */
  replenishmentPlanQty = undefined;

  /** 销售单价 */
  salesUnitPrice = undefined;

  /** SBU名称 */
  sbuName = "";

  /** 近7天销量 */
  sevenDaySales = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 订单状态，0：未评审，1：评审通过，2：已驳回，3：已完成 */
  status = undefined;

  /** 冗余采购在途库存数量 */
  surplusPurchaseTransit = undefined;

  /** 冗余采购在途成本金额 */
  surplusTransitAmount = undefined;

  /** 冗余CN仓库存成本金额 */
  surplusWarehouseCnAmount = undefined;

  /** 冗余cn仓库存数量 */
  surplusWarehouseCnStock = undefined;

  /** T月基线预测 */
  t0BaselineForecast = undefined;

  /** T+10月销量 */
  t10Sales = undefined;

  /** T+11月销量 */
  t11Sales = undefined;

  /** T+12月销量 */
  t12Sales = undefined;

  /** T+1月基线预测 */
  t1BaselineForecast = undefined;

  /** T+1月销量 */
  t1Sales = undefined;

  /** T+2月基线预测 */
  t2BaselineForecast = undefined;

  /** T+2月销量 */
  t2Sales = undefined;

  /** T+3月基线预测 */
  t3BaselineForecast = undefined;

  /** T+3月销量 */
  t3Sales = undefined;

  /** T+4月基线预测 */
  t4BaselineForecast = undefined;

  /** T+4月销量 */
  t4Sales = undefined;

  /** T+5月基线预测 */
  t5BaselineForecast = undefined;

  /** T+5月销量 */
  t5Sales = undefined;

  /** T+6月销量 */
  t6Sales = undefined;

  /** T+7月销量 */
  t7Sales = undefined;

  /** T+8月销量 */
  t8Sales = undefined;

  /** T+9月销量 */
  t9Sales = undefined;

  /** 最近30天销量 */
  thirtyDaySales = undefined;

  /** 初审单号 */
  trialNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** CN仓库存可用天数(基线预测) */
  warehouseCnAvailableDayBaseline = undefined;

  /** CN仓库存可用天数(销量) */
  warehouseCnAvailableDaySale = undefined;

  /** 国内仓库存 */
  warehouseCnStock = undefined;
}

class FrozenCreateOrderApprovalDto {
  /** 备注 */
  applyMemo = "";

  /** 审批状态 0：驳回 1: 通过 */
  approvalStatus = undefined;

  /** id */
  id = undefined;
}

class FrozenCreateOrderDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 需求日期 0：上半月 1：下半月 */
  demandDate = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 是否直发 */
  factoryDirectHairFlag = false;

  /** 订单数量 */
  finalQty = undefined;

  /** 新增原因 */
  reason = "";

  /** 运输方式 ：10:空运, 20:海运，30:快船 ,40:铁路 */
  shippingMode = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";
}

class FrozenCreateOrderRequestDto {
  /** 提交人 */
  applyUser = "";

  /** BU编码 */
  buCode = undefined;

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 删除标识 */
  deleted = undefined;

  /** 需求日期 0：上半月 1：下半月 */
  demandDate = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 需求订单NO */
  dono = "";

  /** 是否直发 */
  factoryDirectHairFlag = false;

  /** 终审订单数量 */
  finalQty = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 工作流实例id */
  processInstanceId = "";

  /** 新增原因 */
  reason = "";

  /** 驳回人 */
  rejecter = "";

  /** 备注 */
  remark = "";

  /** 运输方式 ：10:空运, 20:海运，30:快船 ,40:铁路 */
  shippingMode = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** 审批状态：  -1：待审核 0：已驳回 1：审核中 2：已通过   */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class FrozenCreateOrderResponseDto {
  /** 提交人 */
  applyUser = "";

  /** BU编码 */
  buCode = undefined;

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 删除标识 */
  deleted = undefined;

  /** 需求日期 0：上半月 1：下半月 */
  demandDate = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 需求订单NO */
  dono = "";

  /** 是否直发 */
  factoryDirectHairFlag = false;

  /** 终审订单数量 */
  finalQty = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 工作流实例id */
  processInstanceId = "";

  /** 新增原因 */
  reason = "";

  /** 驳回人 */
  rejecter = "";

  /** 备注 */
  remark = "";

  /** 运输方式 ：10:空运, 20:海运，30:快船 ,40:铁路 */
  shippingMode = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** 审批状态： -1：待审核 0：已驳回 1：审核中 2：已通过  */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class FrozenResubmitOrderDto {
  /** 需求日期 0：上半月 1：下半月 */
  demandDate = undefined;

  /** 订单数量 */
  finalQty = undefined;
}

class FrozenStateRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 冻结期状态：0：否 1：是 */
  status = false;

  /** 类型 0:冻结期锁定 1:顺延锁定 */
  type = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class FrozenStateResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 冻结期状态：0：否 1：是 */
  status = false;

  /** 类型 0:冻结期锁定 1:顺延锁定 */
  type = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class GetBoxLabelForGjRequestDto {
  /** 调拨单号 */
  aono = "";

  /** 纸张类型 */
  pageType = "";
}

class GetFileStreamRequestDto {
  /** 文件路径 */
  filePath = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class ImageEntity {
  /** colspan */
  colspan = undefined;

  /** data */
  data = "";

  /** height */
  height = undefined;

  /** rowspan */
  rowspan = undefined;

  /** type */
  type = "";

  /** url */
  url = "";

  /** width */
  width = undefined;
}

class ImportTemplateExcelResponseDto {
  /** 海外仓库存 */
  abroadStock = undefined;

  /** 海外仓在途 */
  abroadTransit = undefined;

  /** BU */
  bu = "";

  /** channelKey */
  channelKey = "";

  /** 渠道 */
  channelName = "";

  /** 大小件 */
  commoditySize = undefined;

  /** 当月1日-当日销量 */
  currentMonthSales = undefined;

  /** 补货月份参考发货数量 */
  deliveryQtyReference = "";

  /** 需求日期 */
  demandDate = undefined;

  /** 实际发货与参考的需求偏差 */
  demandDeviation = "";

  /** 需求月份 */
  demandMonth = "";

  /** 是否工厂直发 */
  factoryDirectHairFlag = false;

  /** FBA积压库存 */
  fbaBacklog = undefined;

  /** FBA库存 */
  fbaStock = undefined;

  /** FBA在途库存 */
  fbaTransit = undefined;

  /** 预计销售月份 */
  forecastSaleMonth = "";

  /** 预计销售月份数量 */
  forecastSaleMonthQty = undefined;

  /** 预测版本 */
  importTime = "";

  /** 订单数量 */
  initQty = undefined;

  /** mpq */
  mpq = undefined;

  /** 未完成数量合计 */
  notFinishedTotal = undefined;

  /** 2050订单 */
  order2050 = undefined;

  /** 计划员 */
  planner = "";

  /** 产品分级 */
  productLevel = "";

  /** 一级产品线 */
  productLine1st = "";

  /** 二级产品线 */
  productLine2nd = "";

  /** 三级产品线 */
  productLine3rd = "";

  /** spu */
  productNo = "";

  /** 生产周期(天) */
  productionCycle = undefined;

  /** 订单采购成本金额 */
  purchaseCostAmount = undefined;

  /** 采购提前期（天） */
  purchaseLeadtime = undefined;

  /** 采购单价 */
  purchaseUnitPrice = undefined;

  /** 采购员 */
  purchaser = "";

  /** 销售单价RMB */
  salesPrice = undefined;

  /** SBU */
  sbuName = "";

  /** 近7天销量 */
  sevenDaySales = undefined;

  /** 运输方式 */
  shippingMode = undefined;

  /** 单箱体积（m³） */
  singleBoxVolume = undefined;

  /** 单箱重量（KG） */
  singlePackingWeight = undefined;

  /** siteKey */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU */
  sku = "";

  /** sku名称 */
  skuTitleCn = "";

  /** T月基线预测 */
  t0BaselineForecast = undefined;

  /** T月未完成数量 */
  t0NotFinished = undefined;

  /** 运营预测T */
  t0OperateForecast = undefined;

  /** T-10月销量 */
  t10Sales = undefined;

  /** T-11月销量 */
  t11Sales = undefined;

  /** T-12月销量 */
  t12Sales = undefined;

  /** T+1月基线预测 */
  t1BaselineForecast = undefined;

  /** T+1月未完成数量 */
  t1NotFinished = undefined;

  /** 运营预测T+1 */
  t1OperateForecast = undefined;

  /** T-1月销量 */
  t1Sales = undefined;

  /** T+2月基线预测 */
  t2BaselineForecast = undefined;

  /** T+2月未完成数量 */
  t2NotFinished = undefined;

  /** 运营预测T+2 */
  t2OperateForecast = undefined;

  /** T-2月销量 */
  t2Sales = undefined;

  /** T+3月基线预测 */
  t3BaselineForecast = undefined;

  /** T+3月未完成数量 */
  t3NotFinished = undefined;

  /** 运营预测T+3 */
  t3OperateForecast = undefined;

  /** T-3月销量 */
  t3Sales = undefined;

  /** T+4月基线预测 */
  t4BaselineForecast = undefined;

  /** T+4月未完成数量 */
  t4NotFinished = undefined;

  /** 运营预测T+4 */
  t4OperateForecast = undefined;

  /** T-4月销量 */
  t4Sales = undefined;

  /** T+5月基线预测 */
  t5BaselineForecast = undefined;

  /** T+5月未完成数量 */
  t5NotFinished = undefined;

  /** 运营预测T+5 */
  t5OperateForecast = undefined;

  /** T-5月销量 */
  t5Sales = undefined;

  /** T+6月未完成数量 */
  t6NotFinished = undefined;

  /** 运营预测T+6 */
  t6OperateForecast = undefined;

  /** T-6月销量 */
  t6Sales = undefined;

  /** 运营预测T+7 */
  t7OperateForecast = undefined;

  /** T-7月销量 */
  t7Sales = undefined;

  /** 运营预测T+8 */
  t8OperateForecast = undefined;

  /** T-8月销量 */
  t8Sales = undefined;

  /** T-9月销量 */
  t9Sales = undefined;

  /** 最近30天有效销量 */
  thirtyDaySales = undefined;
}

class InDeliveryDetailBoxRequestDto {
  /** 箱号 */
  boxNo = "";

  /** 箱高 */
  height = undefined;

  /** 装箱明细 */
  inDetailPDAReceivingRequestDtos = [];

  /** 入库单 */
  iono = "";

  /** 箱长 */
  length = undefined;

  /** MPQ数量 */
  mpq = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 箱重 */
  weight = undefined;

  /** 箱宽 */
  width = undefined;
}

class InDeliveryDetailBoxResponseDto {
  /** 批次号 */
  batchNo = "";

  /** 箱号 */
  boxNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** fn_sku */
  fnSku = "";

  /** 箱高 */
  height = undefined;

  /** 箱长 */
  length = undefined;

  /** 每箱数量 */
  mpq = undefined;

  /** fn_sku数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 来源单号 */
  sourceNo = "";

  /** 箱子来源类型 0-采购生成 1 - wms生成 */
  sourceType = undefined;

  /** 状态 0-未收箱 1-已收箱 */
  status = undefined;

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 箱宽 */
  width = undefined;
}

class InDetailBoxPDAReceivingRequestDto {
  /** 箱号 */
  boxNo = "";

  /** fnSku */
  fnSku = "";

  /** 数量 */
  number = undefined;

  /** sku */
  sku = "";
}

class InDetailBoxPrintResponseDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 入库单号 */
  iono = "";

  /** 产品标题 */
  productTitle = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 变体规格 */
  variant = "";
}

class InDetailBoxRequestDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 状态 10:已收货 20:已质检 30:已上架 */
  boxStatus = undefined;

  /** id */
  id = undefined;

  /** 质检数量 */
  inspectionQty = undefined;

  /** 质检备注 */
  inspectionRemark = "";

  /** 质检时间 */
  inspectionTime = "";

  /** 入库单号 */
  iono = "";

  /** 数量 */
  qty = undefined;

  /** 上架数量 */
  shelvesQty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 不合格数量 */
  unqualifiedQty = undefined;

  /** 不合格原因 不合格原因 10:尺寸问题 20:颜色错误 30:款式问题 40:面料问题 50:货物破损 60:货物缺漏 100:其它 */
  unqualifiedReason = "";
}

class InDetailBoxResponseDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** 状态 10:已收货 20:已质检 30:已上架 */
  boxStatus = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** fnSku */
  fnSku = "";

  /** 箱高 */
  height = undefined;

  /** id */
  id = undefined;

  /** 质检数量 */
  inspectionQty = undefined;

  /** 质检备注 */
  inspectionRemark = "";

  /** 质检时间 */
  inspectionTime = "";

  /** 入库单号 */
  iono = "";

  /** 箱长 */
  length = undefined;

  /** 每箱数量 */
  mpq = undefined;

  /** 数量 */
  qty = undefined;

  /** 上架数量 */
  shelvesQty = undefined;

  /** sku */
  sku = "";

  /** 状态 0-未收箱 1-已收箱 */
  status = undefined;

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 不合格数量 */
  unqualifiedQty = undefined;

  /** 不合格原因 不合格原因 10:尺寸问题 20:颜色错误 30:款式问题 40:面料问题 50:货物破损 60:货物缺漏 100:其它 */
  unqualifiedReason = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 箱宽 */
  width = undefined;
}

class InDetailBoxScanResponseDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** 状态 10:已收货 20:已质检 30:已上架 */
  boxStatus = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** fnSku */
  fnSku = "";

  /** 箱高 */
  height = undefined;

  /** id */
  id = undefined;

  /** 质检数量 */
  inspectionQty = undefined;

  /** 质检备注 */
  inspectionRemark = "";

  /** 质检时间 */
  inspectionTime = "";

  /** 入库单号 */
  iono = "";

  /** 箱长 */
  length = undefined;

  /** 每箱数量 */
  mpq = undefined;

  /** 数量 */
  qty = undefined;

  /** 上架数量 */
  shelvesQty = undefined;

  /** sku */
  sku = "";

  /** 产品图片 */
  skuImageUrl = "";

  /** 产品标题 */
  skuName = "";

  /** 状态 0-未收箱 1-已收箱 */
  status = undefined;

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 不合格数量 */
  unqualifiedQty = undefined;

  /** 不合格原因 不合格原因 10:尺寸问题 20:颜色错误 30:款式问题 40:面料问题 50:货物破损 60:货物缺漏 100:其它 */
  unqualifiedReason = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 箱宽 */
  width = undefined;
}

class InDetailCreateRequestDto {
  /** 箱数 */
  boxNum = undefined;

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** MPQ */
  mpq = undefined;

  /** 计划入库数 */
  planQty = undefined;

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 余数 */
  remainderQty = undefined;

  /** sku */
  sku = "";

  /** 供应商变体规格 json */
  supplierVariant = "";

  /** 变体规格 json */
  variant = "";
}

class InDetailInspectionResponseDto {
  /** 需质检数 */
  needInspectionQty = undefined;

  /** 可质检数 */
  qty = undefined;

  /** 质检合格率 */
  qualifiedRate = undefined;
}

class InDetailOncePutStorageDto {
  /** 实收数量 */
  qty = undefined;

  /** sku */
  sku = "";
}

class InDetailOneClickInboundDto {
  /** 产品名称 */
  productName = "";

  /** 实收数量 */
  realQty = undefined;

  /** sku编号 */
  skuNo = "";
}

class InDetailPDAReceivingRequestDto {
  /** fn_sku */
  fnSku = "";

  /** 实收数量/装箱数量 */
  qty = undefined;

  /** sku */
  sku = "";
}

class InDetailPutOnRequestDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** fnSku */
  fnSku = "";

  /** 库位编号 */
  positionCode = "";

  /** 上架数量 */
  qty = undefined;

  /** SKU */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;
}

class InDetailReceivingByMxRequestDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** ID */
  id = undefined;

  /** 质检备注 */
  inspectionRemark = "";

  /** 入库单号 */
  iono = "";

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 不合格数量 */
  unqualifiedQty = undefined;

  /** 不合格原因 */
  unqualifiedReason = "";
}

class InDetailRecordRequestDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** id */
  id = undefined;

  /** 入库单号 */
  iono = "";

  /** 库位编号 */
  positionCode = "";

  /** 上架数量 */
  shelvesQty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;
}

class InDetailRecordResponseDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 入库单号 */
  iono = "";

  /** 库位编号 */
  positionCode = "";

  /** 上架数量 */
  shelvesQty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class InDetailRecordResultDto {
  /** 批次号 */
  batchNo = "";

  /** sku入库总数量 */
  inTotalQty = undefined;

  /** sku编号 */
  skuNo = "";
}

class InDetailRequestDto {
  /** 箱子信息 */
  boxInfo = "";

  /** 箱数 */
  boxNum = undefined;

  /** 抽检需质检数 */
  extractInspectionQty = undefined;

  /** 抽检质检次数 */
  extractTimes = undefined;

  /** 抽检不合格数 */
  extractUnqualifiedQty = undefined;

  /** id */
  id = undefined;

  /** 质检数量 */
  inspectionQty = undefined;

  /** 质检类型 10:全检 20:抽检 30:免检 */
  inspectionType = undefined;

  /** 入库单号 */
  iono = "";

  /** 物流成本单价 */
  logisticsUnitPrice = undefined;

  /** MPQ 每箱数量 */
  mpq = undefined;

  /** 计划入库数 */
  planQty = undefined;

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 采购单价 */
  purchaseUnitPrice = undefined;

  /** 收货数量 */
  receivedQty = undefined;

  /** 余数 */
  remainderQty = undefined;

  /** 上架数量 */
  shelvesQty = undefined;

  /** sku */
  sku = "";

  /** 供应商变体规格 */
  supplierVariant = "";

  /** 不合格数 */
  unqualifiedQty = undefined;

  /** 变体规格 */
  variant = "";
}

class InDetailResponseDto {
  /** 不良品数 */
  badQty = undefined;

  /** 箱子信息 */
  boxInfo = "";

  /** 箱数 */
  boxNum = undefined;

  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** 抽检需质检数 */
  extractInspectionQty = undefined;

  /** 抽检质检次数 */
  extractTimes = undefined;

  /** 抽检不合格数 */
  extractUnqualifiedQty = undefined;

  /** 质检数量 */
  inspectionQty = undefined;

  /** 质检类型 10:全检 20:抽检 30:免检 */
  inspectionType = undefined;

  /** 入库单号 */
  iono = "";

  /** 少货数量 */
  lackQty = undefined;

  /** 物流成本单价 */
  logisticsUnitPrice = undefined;

  /** 每箱数量 */
  mpq = undefined;

  /** 良品数 */
  optimalQty = undefined;

  /** 计划入库数 */
  planQty = undefined;

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 采购单价 */
  purchaseUnitPrice = undefined;

  /** 收货数量 */
  receivedQty = undefined;

  /** 余数 */
  remainderQty = undefined;

  /** 上架数量 */
  shelvesQty = undefined;

  /** sku */
  sku = "";

  /** 供应商变体规格 */
  supplierVariant = "";

  /** 不合格数 */
  unqualifiedQty = undefined;

  /** 变体规格 */
  variant = "";
}

class InMasterBoxDetailRequestDto {
  /** 箱号 */
  boxNo = "";

  /** fnSku */
  fnSku = "";

  /** 入库单 */
  iono = "";

  /** 库位 */
  positionCode = "";

  /** sku */
  sku = "";

  /** 产品图片 */
  skuImageUrl = "";

  /** sku名称 */
  skuName = "";

  /** sku数量 */
  skuNum = undefined;
}

class InMasterBoxShelvesRequestDto {
  /** BOX上架信息 */
  inMasterBoxDetailRequestDtos = [];

  /** 托盘上架信息 */
  inMasterPlateDetailRequestDtos = [];
}

class InMasterCancelRequestDto {
  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 */
  sourceType = undefined;
}

class InMasterCreateRequestDto {
  /** 箱数 */
  boxNum = undefined;

  /** 交货模式 */
  deliveryMode = "";

  /** 预计到货时间 */
  estimateTime = "";

  /** 是否历史订单 默认false，不是历史订单不需要传该参数，是则传ture */
  historyOrder = false;

  /** 入库类型,2-换货入库，1-维修入库，-1-退货入库 */
  inboundType = undefined;

  /** inspectionType */
  inspectionType = undefined;

  /** 入库单号 */
  iono = "";

  /** 包裹明细 */
  omsPackageInfoDtos = [];

  /** 操作单号 出库计划单或者库存调整单 */
  operationNo = "";

  /** 来源操作订单类型 1:入库计划单,2:出库计划单,3:库存调整单 */
  operationOrderType = undefined;

  /** 订单子类型，1-平台订单,5-京配订单,6-京东自营订单 */
  orderChildType = undefined;

  /** 计划入库数量 */
  planQty = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 采购单号 */
  pono = "";

  /** 采购员 */
  purchaser = "";

  /** 备注 */
  remark = "";

  /** 退货单号 */
  returnOrderId = "";

  /** 入库SKU明细 */
  skuList = [];

  /** 订单编号 */
  soOrderNo = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 */
  sourceType = undefined;

  /** 供应商编号 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 是否含税 0:否1:是 */
  taxFlag = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";
}

class InMasterCreateRequestRpcDto {
  /** 渠道编号 */
  channelCode = "";

  /** 数据类型 数据类型 1:url 2:base64 */
  contentType = undefined;

  /** 文件后缀 */
  fileType = "";

  /** 包裹明细 */
  omsPackageInfoDtos = [];

  /** 操作单号 出库计划单或者库存调整单 */
  operationNo = "";

  /** 来源操作订单类型 1:入库计划单,2:出库计划单,3:库存调整单 */
  operationOrderType = undefined;

  /** 渠道商编号 */
  providerCode = "";

  /** 入库SKU明细 */
  skuList = [];

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 */
  sourceType = undefined;

  /** 跟踪号 */
  trackingNumber = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 面单数据 */
  uri = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";
}

class InMasterCreateResponseRpcDto {
  /** 入库单号 */
  iono = "";

  /** 面单路径 */
  logisticsLabelPath = "";
}

class InMasterInfoResponseRpcDto {
  /** 来源单号 */
  sourceNo = "";

  /** 状态 5:待发货 10:未签收 20:已签收 30:已收货 40:已质检 50:已称重 60:部分上架 70:已上架 80:入库失败 90:已取消 */
  status = undefined;
}

class InMasterInspectionRequestDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 质检备注 */
  inspectionRemark = "";

  /** 入库单号 */
  iono = "";

  /** 不合格数量 */
  unqualifiedQty = undefined;

  /** 不合格原因 */
  unqualifiedReason = "";
}

class InMasterInspectionResponseDto {
  /** 入库单SKU装箱信息 */
  inDetailBoxResponseDto = new InDetailBoxResponseDto();

  /** 入库单SKU质检信息 */
  inDetailInspectionResponseDto = new InDetailInspectionResponseDto();

  /** 入库单SKU */
  inDetailResponseDto = new InDetailResponseDto();

  /** 入库单 */
  inMasterResponseDto = new InMasterResponseDto();
}

class InMasterOncePutStorageDto {
  /** 入库sku信息 */
  inDetailOncePutStorageDtos = [];

  /** 入库单 */
  iono = "";

  /** 库位 */
  positionCode = "";
}

class InMasterPDAReceivingRequestDto {
  /** 整箱收货信息 */
  inDetailBoxPDAReceivingRequestDtos = [];

  /** 散货收货信息 */
  inDetailPDAReceivingRequestDtos = [];

  /** 入库单号 */
  iono = "";

  /** 收货类型 */
  type = "";
}

class InMasterPDAReceivingResponseDto {
  /** 交货单箱号 */
  allBoxNoList = [];

  /** 已收 */
  alreadyGain = undefined;

  /** 入库单箱明细 */
  inDeliveryDetailBoxResponseDtos = [];

  /** 入库单明细 */
  inDetailResponseDtoList = [];

  /** 入库单 */
  inMasterResponseDto = new InMasterResponseDto();

  /** 缺少包装信息列表 */
  lackPackInfoSkuList = [];

  /** 未收 */
  noGain = undefined;

  /** 总箱数 */
  totalBoxNum = undefined;
}

class InMasterPackingProbabilityResponseDto {
  /** 散货数量 */
  bulkQty = undefined;

  /** 日期 */
  dayTime = "";

  /** 收货数量 */
  deliveryQty = undefined;

  /** 装箱率/百分比 */
  packingProbability = undefined;

  /** 装箱数量 */
  packingQty = undefined;

  /** 采购员 */
  purchaser = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InMasterPlateDetailRequestDto {
  /** 托盘号 */
  ctno = "";

  /** 托盘明细 */
  inPlateDetailRequestDtos = [];
}

class InMasterPutOnRequestDto {
  /** 入库单号 */
  iono = "";

  /** 上架明细 */
  putOnDetailList = [];
}

class InMasterReceivingByMxRequestDto {
  /** 入库收货SKU明细 */
  inDetails = [];

  /** 入库单号 */
  iono = "";
}

class InMasterReceivingResponseDto {
  /** 入库单已装箱明细 */
  boxResponseDtos = [];

  /** 入库单装箱明细 */
  inDetailBoxResponseDtoList = [];

  /** 入库单明细 */
  inDetailResponseDtoList = [];

  /** 入库单 */
  inMasterResponseDto = new InMasterResponseDto();

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;
}

class InMasterResponseDto {
  /** 箱数 */
  boxNum = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 交货模式 */
  deliveryMode = "";

  /** 收货时间 */
  deliveryTime = "";

  /** 预计到货时间 */
  estimateTime = "";

  /** id */
  id = undefined;

  /** 质检类型 10:全检 20:抽检 30:免检 */
  inspectionType = undefined;

  /** 入库单号 */
  iono = "";

  /** 包裹信息 */
  packageInfo = "";

  /** 数量(计划入库数量) */
  planQty = undefined;

  /** POD文件地址 */
  podUrl = "";

  /** 采购单号 */
  pono = "";

  /** 采购员 */
  purchaser = "";

  /** 备注 */
  remark = "";

  /** 上架数量 */
  shelvesQty = undefined;

  /** 上架时间 */
  shelvesTime = "";

  /** 签收人 */
  signatory = "";

  /** 签收时间 */
  signingTime = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 5:交货单 6:退货入库 7:调拨入库 8:借调入库 9:销售渠道退件入库 10:调拨渠道退件入库 11:批量交货单 12:手动创建移除货件 */
  sourceType = undefined;

  /** 状态 5:待发货 10:未签收 20:已签收 30:已收货 60:部分上架 70:已上架 90:已取消 */
  status = undefined;

  /** 供应商编号 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 是否含税 0:否1:是 */
  taxFlag = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";

  /** 收货备注 */
  waybillRemark = "";
}

class InMasterResponseRpcDto {
  /** 箱数 */
  boxNum = undefined;

  /** 收货时间 */
  deliveryTime = "";

  /** 预计到货时间 */
  estimateTime = "";

  /** id */
  id = undefined;

  /** 入库单明细 */
  inDetailResponseRpcDtoList = [];

  /** 质检类型 10:全检 20:抽检 30:免检 */
  inspectionType = undefined;

  /** 入库单号 */
  iono = "";

  /** 包裹信息 */
  packageInfo = "";

  /** 数量(计划入库数量) */
  planQty = undefined;

  /** POD文件地址 */
  podUrl = "";

  /** 采购单号 */
  pono = "";

  /** 采购员 */
  purchaser = "";

  /** 备注 */
  remark = "";

  /** 上架时间 */
  shelvesTime = "";

  /** 签收人 */
  signatory = "";

  /** 签收时间 */
  signingTime = "";

  /** 订单编号 */
  soOrderNo = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 5:交货单 6:退货入库 7:调拨入库 8:借调入库 9:销售渠道退件入库 10:调拨渠道退件入库 11:批量交货单 12:手动创建移除货件 */
  sourceType = undefined;

  /** 状态 5:待发货 10:未签收 20:已签收 30:已收货 40:已质检 50:已称重 60:部分上架 70:已上架 80:入库失败 90:已取消 */
  status = undefined;

  /** 供应商编号 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 是否含税 0:否1:是 */
  taxFlag = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";

  /** 收货备注 */
  waybillRemark = "";
}

class InPlanMasterOneClickInboundDto {
  /** 入库sku信息 */
  inDetailDtoList = [];

  /** 入库单 */
  iono = "";

  /** 库位 */
  positionCode = "";
}

class InPlateDetailRequestDto {
  /** 箱号 */
  boxNo = "";

  /** 托盘编号 */
  ctno = "";

  /** fnSku */
  fnSku = "";

  /** 入库单 */
  iono = "";

  /** 库位 */
  positionCode = "";

  /** sku */
  sku = "";

  /** 产品图片 */
  skuImageUrl = "";

  /** 产品标题 */
  skuName = "";

  /** sku数量 */
  skuNum = undefined;
}

class InPlateDetailResponseDto {
  /** 箱号 */
  boxNo = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 托盘编号 */
  ctno = "";

  /** fnSku */
  fnSku = "";

  /** id */
  id = undefined;

  /** 入库单号 */
  iono = "";

  /** sku */
  sku = "";

  /** 产品图片 */
  skuImageUrl = "";

  /** 产品标题 */
  skuName = "";

  /** sku数量 */
  skuNum = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class InPlateMasterResponseDto {
  /** 箱数 */
  boxNum = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 托盘编号 */
  ctno = "";

  /** id */
  id = undefined;

  /** 产品数 */
  productNum = undefined;

  /** 件数 */
  skuNum = undefined;

  /** 托盘状态 0-未使用 1-装载中 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class InoutStepRecordRequestDto {
  /** 条码 */
  barcode = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** id */
  id = undefined;

  /** 标签(fnsku) */
  label = "";

  /** 操作内容 */
  operationContent = "";

  /** 操作单号 */
  operationNo = "";

  /** 单据类型 10:入库单 20:出库单 */
  operationOrderType = undefined;

  /** 类型 10:收货 20:质检 30:称重 40:上架 50:下架 60:校验 70:发货 80:还货 */
  operationType = undefined;

  /** 库位 */
  positionCode = "";

  /** 产品名称 */
  productTitle = "";

  /** 产品数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InoutStepRecordResponseDto {
  /** 条码 */
  barcode = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 标签(fnsku) */
  label = "";

  /** 操作内容 */
  operationContent = "";

  /** 操作单号 */
  operationNo = "";

  /** 单据类型 10:入库单 20:出库单 30:移库 40:盘点单 50:报损单 */
  operationOrderType = undefined;

  /** 类型 5:签收 10:收货 20:质检 30:称重 40:上架 50:下架 60:校验 70:发货 80:还货 90:移入 95 移出 100：报损 110：盘点 */
  operationType = undefined;

  /** 库位 */
  positionCode = "";

  /** 产品名称 */
  productTitle = "";

  /** 产品数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InventoryApprovalResponseDto {
  /** 准确率 */
  accuracy = undefined;

  /** 审批单号 */
  approvalNo = "";

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人 */
  currentHandler = "";

  /** 删除0：否1：是 */
  deleted = undefined;

  /** 盘点单单号 */
  icno = "";

  /** id */
  id = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 盘亏金额 */
  lossesMoney = undefined;

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 审批状态  10待审核，20已审核，30已驳回 */
  status = undefined;

  /** 盘盈金额 */
  surplusMoney = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编码 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InventoryDetailRecordResponseDto {
  /** 审批单号 */
  approvalNo = "";

  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除0：否1：是 */
  deleted = undefined;

  /** 盘点单单号 */
  icno = "";

  /** id */
  id = undefined;

  /** 标签(fnsku) */
  label = "";

  /** 是否开过箱：1是 0否 */
  openFlag = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 变体规格 */
  variants = "";
}

class InventoryDetailResultRequestDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** batchNo */
  batchNo = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 盘点数 */
  inventoryQty = undefined;

  /** 标签(fnsku) */
  label = "";

  /** 库位编号 */
  positionCode = "";

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;
}

class InventoryDetailResultResponseDto {
  /** 批次号 */
  batchNo = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 军团名称 */
  corpsName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 盘点单单号 */
  icno = "";

  /** 盘点数 */
  inventoryQty = undefined;

  /** 盘亏数量 */
  lossesQty = undefined;

  /** 操作人 */
  operator = "";

  /** 库位编号 */
  positionCode = "";

  /** 一级品类 */
  primaryProductLine = "";

  /** 产品编号 */
  productCode = "";

  /** 产品标题 */
  productTitle = "";

  /** sku */
  sku = "";

  /** spu编码 */
  spuNo = "";

  /** 盘盈数量 */
  surplusQty = undefined;

  /** 总额 */
  totalAmount = undefined;

  /** 单价 */
  unitPrice = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class InventoryDetailResultStatisticsRequestDto {
  /** 盘点单单号 */
  icno = "";

  /** 操作人 */
  operator = "";

  /** 库位编号 */
  positionCode = "";

  /** 产品盘点明细 */
  resultRequestDtos = [];
}

class InventoryErrorListResponseDto {
  /** 准确率 */
  accuracy = undefined;

  /** 完成率 */
  finishRate = undefined;

  /** 盘点单号 */
  icno = "";

  /** 数量差异 */
  quantityVariance = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InventoryMasterRequestDto {
  /** 对账类型 10:账到实 20:实到账 */
  checkType = undefined;

  /** 盘点单号 */
  icno = "";

  /** 盘点单库位SKU明细 */
  inventorySkuRequestDtos = [];

  /** 盘点类型：10:静态盘点 20:动态盘点 */
  inventoryType = undefined;

  /** 计划开始时间 */
  planBeginTime = "";

  /** 计划结束时间 */
  planEndTime = "";

  /** 原因 */
  reason = "";

  /** 备注 */
  remark = "";

  /** 仓库编码 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InventoryMasterResponseDto {
  /** 准确率 */
  accuracyRate = undefined;

  /** 实际开始时间 */
  actualBeginTime = "";

  /** 实际结束时间 */
  actualEndTime = "";

  /** 审核时间 */
  auditTime = "";

  /** 审核人 */
  auditor = "";

  /** 对账类型 10:账到实 20:实到账 */
  checkType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建类型 10:手工创建 20:月度盘点 30:季度盘点 40:年度盘点 */
  createType = undefined;

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 完成率 */
  finishRate = undefined;

  /** 盘点单号 */
  icno = "";

  /** id */
  id = undefined;

  /** 盘点状态：5:待分配 10:待执行 20:执行中 30:未完成 40:已完成 */
  inventoryStatus = undefined;

  /** 盘点类型：10:静态盘点 20:动态盘点 30:异常盘点 40:三方&工厂盘点 */
  inventoryType = undefined;

  /** 计划开始时间 */
  planBeginTime = "";

  /** 计划结束时间 */
  planEndTime = "";

  /** 盘点单库位明细 */
  positionResponseDtos = [];

  /** 是否有盘盈盘亏记录 0:否1:是 */
  profitLossflag = undefined;

  /** 原因 */
  reason = "";

  /** 备注 */
  remark = "";

  /** 异常盘点sku */
  sku = "";

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编码 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InventoryPositionResponseDto {
  /** 实际开始时间 */
  actualBeginTime = "";

  /** 实际结束时间 */
  actualEndTime = "";

  /** 库区编号 */
  areaCode = "";

  /** 对账类型 10:账到实 20:实到账 */
  checkType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除0：否1：是 */
  deleted = undefined;

  /** 货架组编号 */
  groupCode = "";

  /** 盘点单单号 */
  icno = "";

  /** id */
  id = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 货架编号 */
  shelvesCode = "";

  /** 状态 5:待分配 10:未处理 20:已处理 */
  status = undefined;

  /** 任务编号 */
  tono = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编码 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InventoryScreenPositionResponseDto {
  /** 库区编号 */
  areaCode = "";

  /** 货架组编号 */
  groupCode = "";

  /** 库位编号 */
  positionCode = "";

  /** 货架编号 */
  shelvesCode = "";

  /** 仓库编号 */
  warehouseCode = "";
}

class InventorySkuRequestDto {
  /** 箱号 */
  boxCode = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 库位编号 */
  positionCode = "";

  /** sku */
  sku = "";
}

class InventoryTaskCreateDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 止 */
  createTimeEnd = "";

  /** 创建时间 起 */
  createTimeStart = "";

  /** 执行人 */
  executor = "";

  /** 盘点单单号 */
  icno = "";

  /** id */
  id = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 状态 */
  status = undefined;

  /** 任务编号 */
  tono = "";
}

class InventoryTaskResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 执行人 */
  executor = "";

  /** 盘点单单号 */
  icno = "";

  /** id */
  id = undefined;

  /** 任务明细 */
  positionResponseDtos = [];

  /** 状态 5:待执行 10:执行中 15:已盘点 20:已确认 30:已删除 */
  status = undefined;

  /** 任务编号 */
  tono = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class InventoryThireFactoryRequestDetailDto {
  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 数量 */
  inventoryQty = undefined;

  /** sku */
  sku = "";
}

class InventoryThireFactoryRequestDto {
  /** 盘点明细 */
  inventoryThireFactoryRequestDetailDtoList = [];

  /** 盘点原因 */
  reason = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InventoryWorkflowDto {
  /** 提交人备注 */
  applyMemo = "";

  /** 提交人ID */
  applyUserId = undefined;

  /** 盘点审批单号 */
  approvalNo = "";

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 工作流实例ID */
  processInstanceId = "";

  /** 工作流TaskID */
  taskId = "";
}

class LendDetailCreateRequestDto {
  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** cost */
  cost = undefined;

  /** 需求数量 */
  number = undefined;

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** sku */
  sku = "";

  /** 变体规格 */
  variants = "";
}

class LendDetailResponseDto {
  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 产品线 */
  categoryName = "";

  /** 军团名称 */
  corpsName = "";

  /** 成本价 */
  cost = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 领用单号 */
  lyno = "";

  /** 需求数量 */
  number = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** sku */
  sku = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 变体规格 */
  variants = "";
}

class LendMasterAuditActivitiDto {
  /** 审核意见 */
  applyMemo = "";

  /** 审核状态 1-审核通过 0-驳回 */
  approvalStatus = undefined;

  /** 军团名称 */
  corpsName = "";

  /** 领用单 */
  lyno = "";

  /** 运营经理 */
  managerUserCode = "";

  /** 需求计划员编号 */
  plannerUserCode = "";

  /** 一级部门负责人编码 */
  principalUserCode = "";

  /** 工作流实例ID */
  processInstanceId = "";

  /** 样品管理员 */
  sampleManagerUserCode = "";

  /** 成本总价 */
  storageCost = undefined;

  /** 工作流TaskID */
  taskId = "";
}

class LendMasterCreateRequestDto {
  /** 领用地址 */
  address = "";

  /** 领用首要原因 */
  firstReason = "";

  /** 领用单详情 */
  lendDetailCreateRequestDtos = [];

  /** 联系电话 */
  mobile = "";

  /** 领用人 */
  recipients = "";

  /** 备注 */
  remark = "";

  /** 领用次要原因 */
  secondReason = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 来源仓库编号 */
  warehouseCode = "";

  /** 来源仓库名称 */
  warehouseName = "";
}

class LendMasterResponseDto {
  /** 领用地址 */
  address = "";

  /** 审核人 */
  auditBy = "";

  /** 审核意见 */
  auditOpinion = "";

  /** 审核时间 */
  auditTime = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 领用首要原因 */
  firstReason = "";

  /** id */
  id = undefined;

  /** 领用单号 */
  lyno = "";

  /** 运营经理编码 */
  managerCode = "";

  /** 联系电话 */
  mobile = "";

  /** 领用总数量 */
  number = undefined;

  /** 工作流实例id */
  processInstanceId = "";

  /** 领用原因 */
  reason = "";

  /** 领用人 */
  recipients = "";

  /** 备注 */
  remark = "";

  /** 样品管理员编码 */
  sampleManagerCode = "";

  /** 领用次要原因 */
  secondReason = "";

  /** 状态 10:未审核 20:审核通过 30:已拣货 40:已发运 50:已驳回 60:审核中 */
  status = undefined;

  /** 成本总价 */
  storageCost = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 来源仓库编号 */
  warehouseCode = "";

  /** 来源仓库名称 */
  warehouseName = "";
}

class LogisticsCycleInfoRequestDto {
  /** id */
  id = undefined;

  /** 物流周期(天) */
  logisticsCycle = undefined;

  /** 运输方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车,60 快递 */
  shippingType = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;
}

class LogisticsCycleInfoResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 物流周期(天) */
  logisticsCycle = undefined;

  /** remark */
  remark = "";

  /** 运输方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车,60 快递 */
  shippingType = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsOrderRequestRpcDto {
  /** 渠道编号 */
  channelCode = "";

  /** 数据类型 数据类型 1:url 2:base64 */
  contentType = undefined;

  /** 文件后缀 */
  fileType = "";

  /** 单号 */
  orderNo = "";

  /** 渠道商编号 */
  providerCode = "";

  /** 跟踪号 */
  trackingNumber = "";

  /** 面单数据 */
  uri = "";

  /** 运单号 */
  waybillNo = "";
}

class LogisticsOrderResponseDto {
  /** 渠道编号 */
  channelCode = "";

  /** 数据类型 数据类型 1:url 2:base64 */
  contentType = undefined;

  /** 文件后缀 */
  fileType = "";

  /** 单号 */
  orderNo = "";

  /** 渠道商编号 */
  providerCode = "";

  /** 跟踪号 */
  trackingNumber = "";

  /** 面单数据 */
  uri = "";

  /** 运单号 */
  waybillNo = "";
}

class LogisticsReturnCreateInDto {
  /** 出库单号 */
  dono = "";

  /** 退件记录号 */
  returnNo = "";

  /** sku明细 */
  skuDetails = [];
}

class LogisticsReturnRecordRequestDto {
  /** 出库数量 */
  qty = undefined;

  /** 退件记录号 */
  returnNo = "";

  /** 已退货数量 */
  returnQty = undefined;

  /** sku */
  sku = "";
}

class LogisticsReturnRecordResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 出库单号 */
  dono = "";

  /** 处理结果 10:入库 20:报损 30:重发 */
  handleResult = undefined;

  /** id */
  id = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 备注 */
  remark = "";

  /** 退件原因详情 */
  returnDetail = "";

  /** 退件记录号 */
  returnNo = "";

  /** 退件原因 */
  returnReason = "";

  /** 退件签收时间 */
  signTime = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 10:销售订单 20:调拨单 */
  sourceType = undefined;

  /** 状态 10:退件签收 20:部分入库 30:全部入库 */
  status = undefined;

  /** 来源单号 */
  trackingNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class LogisticsReverseLabelDetailRequestDto {
  /** 单价 */
  price = undefined;

  /** 出库数量 */
  qty = undefined;

  /** sku */
  sku = "";
}

class LogisticsReverseLabelRequestDto {
  /** sku明细 */
  detailRequestDtos = [];

  /** 发件人地址1 */
  fromAddress1 = "";

  /** 发件人地址2 */
  fromAddress2 = "";

  /** 发件人城市 */
  fromCity = "";

  /** 发件人国家 */
  fromCounty = "";

  /** 发件人国家简称 */
  fromCountyCode = "";

  /** 发件人姓名 */
  fromName = "";

  /** 发件人电话号码 */
  fromPhone = "";

  /** 发件人邮编 */
  fromPostCode = "";

  /** 发件人州 */
  fromProvince = "";

  /** 发件人州简称 */
  fromProvinceCode = "";

  /** 标签备注 */
  labelRemark = "";

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 包裹明细 */
  omsPackageInfoDtos = [];

  /** 销售订单号 */
  orderNo = "";

  /** 退货单号 */
  returnOrderId = "";

  /** 收件人地址1 */
  toAddress1 = "";

  /** 收件人地址2 */
  toAddress2 = "";

  /** 收件人城市 */
  toCity = "";

  /** 收件人国家 */
  toCounty = "";

  /** 收件人国家简称 */
  toCountyCode = "";

  /** 收件人姓名 */
  toName = "";

  /** 收件人电话号码 */
  toPhone = "";

  /** 收件人邮编 */
  toPostCode = "";

  /** 收件人州 */
  toProvince = "";

  /** 收件人州简称 */
  toProvinceCode = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 退货仓库 */
  warehouse = "";

  /** 退货仓库编号 */
  warehouseCode = "";
}

class LogisticsReverseLabelResponseDto {
  /** 数据类型 1:url 2:base64 */
  contentType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 文件类型 */
  fileType = "";

  /** 发件人地址1 */
  fromAddress1 = "";

  /** 发件人地址2 */
  fromAddress2 = "";

  /** 发件人城市 */
  fromCity = "";

  /** 发件人国家 */
  fromCounty = "";

  /** 发件人国家简称 */
  fromCountyCode = "";

  /** 发件人姓名 */
  fromName = "";

  /** 发件人电话号码 */
  fromPhone = "";

  /** 发件人邮编 */
  fromPostCode = "";

  /** 发件人州 */
  fromProvince = "";

  /** 发件人州简称 */
  fromProvinceCode = "";

  /** id */
  id = undefined;

  /** 标签备注 */
  labelRemark = "";

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 销售订单号 */
  orderNo = "";

  /** 包裹信息 */
  packageInfo = "";

  /** 文件路径 */
  path = "";

  /** 是否已生成逆向物流单: 0:否 1:是 */
  reverseFlag = false;

  /** 状态: 0:初始化 10:未处理 20:已处理 30:处理失败 */
  status = undefined;

  /** 收件人地址1 */
  toAddress1 = "";

  /** 收件人地址2 */
  toAddress2 = "";

  /** 收件人城市 */
  toCity = "";

  /** 收件人国家 */
  toCounty = "";

  /** 收件人国家简称 */
  toCountyCode = "";

  /** 收件人姓名 */
  toName = "";

  /** 收件人电话号码 */
  toPhone = "";

  /** 收件人邮编 */
  toPostCode = "";

  /** 收件人州 */
  toProvince = "";

  /** 收件人州简称 */
  toProvinceCode = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 退货仓库 */
  warehouse = "";

  /** 退货仓库编号 */
  warehouseCode = "";

  /** 运单号 */
  waybillNo = "";
}

class LogisticsWaybillLabelResponseDto {
  /** 内容 */
  content = "";

  /** 数据类型 1:url 2:base64 */
  contentType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 文件类型 */
  fileType = "";

  /** id */
  id = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 文件路径 */
  path = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 运单号 */
  waybillNo = "";
}

class ModifyShippingTypeRequestDto {
  /** 需求订单NO */
  dono = "";

  /** 运输方式 ：10:空运, 20:海运，30:快船 ,40:铁路 */
  shippingMode = undefined;
}

class NsStorageRequestDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 库位编号 */
  positionCode = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class NsStorageResponseDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** id */
  id = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class OmsPackageInfoDetailDto {
  /** 数量 */
  qty = undefined;

  /** 实收数量 */
  realQty = undefined;

  /** sku */
  sku = "";
}

class OmsPackageInfoDto {
  /** 创建时间 */
  createTime = "";

  /** 包裹明细 */
  omsPackageInfoDetailDtos = [];

  /** 包裹单号 */
  packageNo = "";

  /** 平台编号 */
  platformCode = "";

  /** 退货单号 */
  returnOrderId = "";
}

class OperateForecastRequestDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 预测月份 */
  month = "";

  /** 运营预测版本 */
  operateVersion = "";

  /** 预测数量 */
  qty = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class OperateForecastResponseDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 销售月份 */
  month = "";

  /** 运营预测版本 */
  operateVersion = "";

  /** 销售月份预测数量 */
  qty = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class OperationRecordResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 操作描述 */
  operationDescribe = "";

  /** 操作单号 */
  operationNo = "";

  /** 操作类型  */
  operationType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 1:交货单-PO单 2:交货单-RE单 3:交货单-工厂整柜订舱 4:交货单-工厂散货订舱 5:入库单-交货单 6:入库单-退货入库 7:入库单-调拨入库 8:入库单-借调入库9：入库单-销售渠道退件入库 10:入库单-调拨渠道退件入库 11:入库单-批量交货单 12:入库单-手动创建移除货件 13:出库单-销售订单 14:出库单-采购退货单15:出库单-调拨单 16:出库单-借调单 17:出库单-SP销售单 18:出库单-委托单 19:出库单-多渠道订单  */
  sourceType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class OutCheckResponseDto {
  /** 地址 */
  address = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 发货时间 */
  deliveryTime = "";

  /** 出库单号 */
  dono = "";

  /** 邮箱地址 */
  email = "";

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 出库单校验产品明细 */
  outInfoSkuResponseDtos = [];

  /** 拣货单号 */
  pickno = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 数量 */
  qty = undefined;

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 平台编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源订单状态 10:正常 20:订单取消 */
  sourceStatus = undefined;

  /** 来源类型 13:销售订单 14:采购退货单 15:调拨单 16:借调单 17:SP销售单 18:委托单 19:多渠道订单 */
  sourceType = undefined;

  /** 状态 0:未分配 10:待拣货 20:已拣货 30:已校验 40:校验失败 45:已还货 50:已称重 60:已扫描 70:已出库 80:待还货 */
  status = undefined;

  /** 固定电话 */
  telephone = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";

  /** 出库重量 */
  weight = undefined;
}

class OutDetailCheckRequestDto {
  /** 校验失败数量 */
  qty = undefined;

  /** SKU */
  sku = "";
}

class OutDetailCreateRequestDto {
  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 出库数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 变体规格 */
  variants = "";
}

class OutDetailResponseRpcDto {
  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** 校验数量 */
  checkQty = undefined;

  /** 出库单号 */
  dono = "";

  /** 拣货数量 */
  pickQty = undefined;

  /** 单价 */
  price = undefined;

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 出库数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 变体规格 */
  variants = "";
}

class OutInfoResponseDto {
  /** 地址 */
  address = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 发货时间 */
  deliveryTime = "";

  /** 配货位 */
  distribute = undefined;

  /** 出库单号 */
  dono = "";

  /** 邮箱地址 */
  email = "";

  /** 出库sku信息 */
  infoSkuList = [];

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 拣货单号 */
  pickno = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 数量 */
  qty = undefined;

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 平台编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源订单状态 10:正常 20:订单取消 */
  sourceStatus = undefined;

  /** 来源类型 13:销售订单 14:采购退货单 15:调拨单 16:借调单 17:SP销售单 18:委托单 19:多渠道订单 */
  sourceType = undefined;

  /** 状态 0:未分配 10:待拣货 20:已拣货 30:已校验 40:校验失败 45:已还货 50:已称重 60:已扫描 70:已出库 80:待还货 */
  status = undefined;

  /** 固定电话 */
  telephone = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";

  /** 出库重量 */
  weight = undefined;
}

class OutInfoSkuResponseDto {
  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 出库单号 */
  dono = "";

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 出库数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 变体规格 */
  variants = "";
}

class OutInterceptBeforeResponseDto {
  /** 是否可拦截: 1是 0否 */
  isSuccess = undefined;

  /** 来源单号(包裹号) */
  sourceNo = "";
}

class OutMasterCreateRequestDto {
  /** 地址 */
  address = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 出库单明细 */
  detailCreateRequestDtos = [];

  /** 邮箱地址 */
  email = "";

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 物流申请信息 */
  logisticsOrderResponseRpcDto = new LogisticsOrderRequestRpcDto();

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 操作单号 出库计划单或者库存调整单 */
  operationNo = "";

  /** 来源操作订单类型 1:入库计划单,2:出库计划单,3:库存调整单 */
  operationOrderType = undefined;

  /** 是否允许出库，否：0，是：1 */
  outWarehouseFlag = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 销售价格 */
  salePrice = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 */
  sourceType = undefined;

  /** 固定电话 */
  telephone = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";
}

class OutMasterCreateResponseRpcDto {
  /** 出库单号 */
  dono = "";

  /** 物流面单文件路径 */
  logisticsLabelPath = "";
}

class OutMasterLendCreateRequestDto {
  /** 地址 */
  address = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 出库单明细 */
  detailCreateRequestDtos = [];

  /** 邮箱地址 */
  email = "";

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** PO单号 */
  pono = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 数量 */
  qty = undefined;

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 13:销售订单 14:采购退货单 15:调拨单 16:借调单 17:SP销售单 18:委托单 19:多渠道订单 */
  sourceType = undefined;

  /** 固定电话 */
  telephone = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";
}

class OutMasterLendCreateRequestRpcDto {
  /** 地址 */
  address = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 出库单明细 */
  detailCreateRequestDtos = [];

  /** 出库单号 */
  dono = "";

  /** 邮箱地址 */
  email = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** PO单号 */
  pono = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 数量 */
  qty = undefined;

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 13:销售订单 14:采购退货单 15:调拨单 16:借调单 17:SP销售单 18:委托单 19:多渠道订单 */
  sourceType = undefined;

  /** 固定电话 */
  telephone = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class OutMasterResponseDto {
  /** 地址 */
  address = "";

  /** 地址2 */
  address2 = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 发货时间 */
  deliveryTime = "";

  /** 出库单号 */
  dono = "";

  /** 邮箱地址 */
  email = "";

  /** id */
  id = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 是否允许出库，否：0，是：1 */
  outWarehouseFlag = undefined;

  /** 拣货单号 */
  pickno = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** POD文件地址 */
  podUrl = "";

  /** PO单号 */
  pono = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 省份编号 */
  provinceCode = "";

  /** 下单时间 */
  purchaseDate = "";

  /** 积加返回内容 */
  pushGjData = "";

  /** 是否已推送积加：1是 0否 */
  pushGjFlag = undefined;

  /** 数量 */
  qty = undefined;

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 退货金额 */
  returnAmount = "";

  /** 平台编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源订单状态 10:正常 20:订单取消 */
  sourceStatus = undefined;

  /** 来源类型 13:销售订单 14:采购退货单 15:调拨单 16:借调单 17:SP销售单 18:委托单 19:多渠道订单 */
  sourceType = undefined;

  /** 状态 0:待处理 10:待拣货 20:已拣货 30:已校验 40:校验失败 45:已还货 50:已称重 60:已扫描 65: 发运中 72: 发运失败 70:已出库 75: 已退件签收 80:待还货 90: 已推送  -30: 缺货中 -20: 已齐货 -10: 创建失败 */
  status = undefined;

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 固定电话 */
  telephone = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 仓库类型 10:自营 20:FBA 30:第三方仓 40:工厂仓 50:WFS */
  warehouseType = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 出库重量 */
  weight = undefined;
}

class OutMasterResponseRpcDto {
  /** address */
  address = "";

  /** 地址2 */
  address2 = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 发货时间 */
  deliveryTime = "";

  /** 区县 */
  district = "";

  /** 出库单号 */
  dono = "";

  /** 邮箱地址 */
  email = "";

  /** 物流状态 0:初始化 10:未处理 20:已处理 */
  logisticStatus = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 运费 */
  logisticsPrice = undefined;

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 出库计划单号 */
  opno = "";

  /** outDetailResponseRpcDtoList */
  outDetailResponseRpcDtoList = [];

  /** 拣货单号 */
  pickno = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 平台订单号 */
  platformOrderId = "";

  /** 采购单号 */
  pono = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 省份编号 */
  provinceCode = "";

  /** 下单时间 */
  purchaseDate = "";

  /** 内容 */
  pushGjData = "";

  /** 是否已推送积加：1是 0否 */
  pushGjFlag = undefined;

  /** 数量 */
  qty = undefined;

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 销售价格USD */
  salePrice = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源订单状态 10:正常 20:订单取消 */
  sourceStatus = undefined;

  /** 来源类型 13:销售订单 14:采购退货单 15:调拨单 16:借调单 17:SP销售单 18:委托单 19:多渠道订单 */
  sourceType = undefined;

  /** 状态 0:待处理 10:待拣货 20:已拣货 30:已校验 40:校验失败 45:已还货 50:已称重 60:已扫描 65:发运中 70:已发运  75:已退件签收 80:待还货 */
  status = undefined;

  /** 收件人纳税号 */
  taxid = "";

  /** 固定电话 */
  telephone = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";

  /** 出库重量 */
  weight = undefined;
}

class OutMasterSnListRequestDto {
  /** sn编号 */
  donoList = [];

  /** 排序 */
  orderBy = "";

  /** 订单号 */
  orderNo = "";

  /** 当前页 */
  pageNumber = undefined;

  /** 每页条数 */
  pageSize = undefined;

  /** sku编号 */
  sku = "";

  /** sn编号 */
  snCode = "";

  /** 包裹单号 */
  sourceNo = "";
}

class OutMasterSnListResponseDto {
  /** 箱号 */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** 发货时间 */
  deliveryTime = "";

  /** 出库单号 */
  dono = "";

  /** 销售订单号 */
  orderNo = "";

  /** 平台编号 */
  platformCode = "";

  /** 产品名称 */
  productTitle = "";

  /** 收件人 */
  recipient = "";

  /** sku */
  sku = "";

  /** sn码 */
  snCode = "";

  /** 包裹单号 */
  sourceNo = "";

  /** supplierName */
  supplierName = "";

  /** 1:箱，2:散货 */
  type = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class OutMasterSnResponseDto {
  /** 出库单号 */
  dono = "";

  /** sku */
  sku = "";

  /** sn码 */
  snCode = "";
}

class OutPlanCreateRequestDto {
  /** 地址 */
  address = "";

  /** 地址2 */
  address2 = "";

  /** 买家指定物流 */
  buyerSpecifyLogistics = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 币种 */
  currency = "";

  /** 客户公司名称 */
  customerName = "";

  /** 出库计划单明细明细 */
  detailCreateRequestDtos = [];

  /** 区县 */
  district = "";

  /** 邮箱地址 */
  email = "";

  /** 是否历史订单 默认false，不是历史订单不需要传该参数，是则传ture */
  historyOrder = false;

  /** 门牌号 */
  houseNumber = "";

  /** 是否异常确认 1:是 0:否 */
  isAbnormalConfirm = undefined;

  /** 是否申请多渠道订单 1：是 0：否 */
  isMcf = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 移动电话 */
  mobilePhone = "";

  /** oms订单子类型，1维修,2换货,3其他 */
  omsOrderChildType = undefined;

  /** 订单类型，1-平台订单,5-京配订单,6-京东自营订单 */
  orderChildType = undefined;

  /** 订单号 */
  orderNo = "";

  /** oms订单类型，1正常 2补发 3重发 4测评 5改发 */
  orderType = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 平台订单号 */
  platformOrderId = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 省份编号 */
  provinceCode = "";

  /** 下单时间 */
  purchaseDate = "";

  /** 数量 */
  qty = undefined;

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 销售价格 */
  salePrice = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 来源单号 */
  sourceNo = "";

  /** 收件人纳税号 */
  taxid = "";

  /** 固定电话 */
  telephone = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 包裹交易号 */
  transactionId = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class OutPlanDetailCreateRequestDto {
  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** 订单物品明细ID */
  itemId = "";

  /** 单价 */
  price = undefined;

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** SKU数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 包裹交易号 */
  transactionId = "";
}

class OutPlanDetailResponseDto {
  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 出库计划单号 */
  opno = "";

  /** 单价 */
  price = undefined;

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 出库数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class OutPlanMastSkuDetailResponseDto {
  /** 国家名称 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 邮编 */
  postcode = "";

  /** sku明细 */
  skuList = [];
}

class OutPlanMasterResponseDto {
  /** 地址 */
  address = "";

  /** 地址2 */
  address2 = "";

  /** 买家指定物流 */
  buyerSpecifyLogistics = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 客户公司名称 */
  customerName = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 发货时间 */
  deliveryTime = "";

  /** 出库单号 */
  dono = "";

  /** 邮箱地址 */
  email = "";

  /** 错误信息 */
  errorMessage = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 物流状态 0:初始化 10:未处理 20:已处理 */
  logisticStatus = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 运费 */
  logisticsPrice = undefined;

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 多渠道订单号 */
  multiChannelOrder = "";

  /** 出库计划单号 */
  opno = "";

  /** 订单号 */
  orderNo = "";

  /** sku明细 */
  outPlanDetailResponseDtos = [];

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 平台订单号 */
  platformOrderId = "";

  /** 平台邮寄方式 */
  platformPost = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 省份编号 */
  provinceCode = "";

  /** 下单时间 */
  purchaseDate = "";

  /** 推送积加内容 */
  pushGjData = "";

  /** 是否已推送积加：1是 0否 */
  pushGjFlag = undefined;

  /** 数量 */
  qty = undefined;

  /** 收件人 */
  recipient = "";

  /** remark */
  remark = "";

  /** 销售价格 */
  salePrice = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源订单状态 10:正常 20:订单取消 */
  sourceStatus = undefined;

  /** 来源类型 13:销售订单 18:委托单 19:多渠道订单 */
  sourceType = undefined;

  /** 状态 0:待匹配 10:缺货中 20:匹配失败 30:待物流申请 40:申请失败 50:已推送 60:已发运 70:异常作废 */
  status = undefined;

  /** 收件人纳税号 */
  taxid = "";

  /** 固定电话 */
  telephone = "";

  /** 跟踪地址 */
  traceAddresse = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";

  /** 出库重量 */
  weight = undefined;
}

class OutReturnRequestDto {
  /** 库位还货产品明细 */
  outReturnSerialRequestDtos = [];

  /** 库位编号 */
  positionCode = "";
}

class OutReturnResponseDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** 出库单号 */
  dono = "";

  /** 库位 */
  positionCode = "";

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 数量 */
  realQty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 是否拆箱 0:否1:是 */
  unpackFlag = undefined;

  /** 变体规格 */
  variants = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class OutReturnResponseParamsDto {
  /** 出库单还货列表 */
  outReturnResponseDtoList = [];

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;
}

class OutReturnSerialRequestDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;
}

class OutReturnSignRequestDto {
  /** 出库单号 */
  dono = "";

  /** 退件原因详情 */
  explain = "";

  /** 备注 */
  remark = "";

  /** 退件原因 */
  returnReason = "";

  /** 仓库Code */
  warehouseCode = "";

  /** 仓库Name */
  warehouseName = "";
}

class PackageDetailResponseDto {
  /** 地址 */
  address = "";

  /** 渠道编号 */
  channelCode = "";

  /** 渠道名称 */
  channelName = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 发货时间 */
  deliveryTime = "";

  /** 出库单号 */
  dono = "";

  /** 主键 */
  id = undefined;

  /** 订单号 */
  orderNo = "";

  /** 订单状态 */
  orderStatus = undefined;

  /** pkg号 */
  pkg = "";

  /** 省份 */
  province = "";

  /** 发货数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";
}

class PackageMasterDetailResponseDto {
  /** 包裹分拣详情 */
  detailResponseDtos = [];

  /** 包裹分拣主表 */
  masterResponseDto = new PackageMasterResponseDto();
}

class PackageMasterResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 发运时间 */
  deliveryTime = "";

  /** 主键 */
  id = undefined;

  /** 物流商编号 */
  logisticsProviderCode = "";

  /** 物流商名称 */
  logisticsProviderName = "";

  /** pkg号 */
  pkg = "";

  /** 备注 */
  remark = "";

  /** 状态 10:未扫描 20:已扫描 30:已发运 40:已取消 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class PackageWaybillResponseDto {
  /** 地址 */
  address = "";

  /** 城市 */
  city = "";

  /** 关联单号 */
  correlationNo = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道商 */
  logisticsProvider = "";

  /** 操作单号 */
  operationNo = "";

  /** 订单状态 */
  orderStatus = undefined;

  /** 省份 */
  province = "";

  /** 物流跟踪号 */
  trackingNo = "";

  /** 运单号 */
  waybillNo = "";
}

class PageInfo {
  /** endRow */
  endRow = undefined;

  /** hasNextPage */
  hasNextPage = false;

  /** hasPreviousPage */
  hasPreviousPage = false;

  /** isFirstPage */
  isFirstPage = false;

  /** isLastPage */
  isLastPage = false;

  /** list */
  list = [];

  /** navigateFirstPage */
  navigateFirstPage = undefined;

  /** navigateLastPage */
  navigateLastPage = undefined;

  /** navigatePages */
  navigatePages = undefined;

  /** navigatepageNums */
  navigatepageNums = [];

  /** nextPage */
  nextPage = undefined;

  /** pageNum */
  pageNum = undefined;

  /** pageSize */
  pageSize = undefined;

  /** pages */
  pages = undefined;

  /** prePage */
  prePage = undefined;

  /** size */
  size = undefined;

  /** startRow */
  startRow = undefined;

  /** total */
  total = undefined;
}

class PdaFnskuRequestDto {
  /** fnskuList */
  fnskuList = [];
}

class PdaFnskuResponseDto {
  /** fnsku */
  fnsku = "";

  /** productNameCn */
  productNameCn = "";

  /** sku */
  sku = "";
}

class PdfContentDto {
  /** base64 */
  base64 = "";
}

class PickAddRequestDto {
  /** 创建拣货单筛选项 */
  pickDetailFilterRequestDto = new PickDetailFilterRequestDto();

  /** 出库单配货位列表 */
  pickOutRequestDtoList = [];
}

class PickDetailBoxRequestDto {
  /** barcode */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** 出库单号 */
  dono = "";

  /** 标签 sku/fnSku */
  label = "";

  /** 拣货类型 1:整箱拣 2:整箱拆箱拣/散货拣 */
  pickType = undefined;

  /** 拣货单号 */
  pickno = "";

  /** 库位编号 */
  positionCode = "";

  /** qty */
  qty = undefined;

  /** sku */
  sku = "";

  /** 状态 20:已拣货 30:丢失 */
  status = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 仓库编号 */
  warehouseCode = "";
}

class PickDetailFilterRequestDto {
  /** 出库单开始创建时间 */
  beginCreateTime = "";

  /** begin总数量 */
  beginQty = undefined;

  /** 出库单结束创建时间 */
  endCreateTime = "";

  /** end总数量 */
  endQty = undefined;

  /** 物流渠道 */
  logisticsList = [];

  /** 平台 */
  platformList = [];

  /** sku */
  sku = "";

  /** 包裹上限 */
  upperLimit = undefined;

  /** 仓库编号 */
  warehouseCode = "";
}

class PickDetailFilterResponseDto {
  /** 配货位 */
  distribute = "";

  /** 出库单号 */
  dono = "";

  /** 物流渠道 */
  logistics = "";

  /** 平台名称 */
  platformName = "";

  /** 运单号 */
  waybillNo = "";
}

class PickDetailResponseDto {
  /** 地址 */
  address = "";

  /** 配货位 */
  distribute = undefined;

  /** 出库单号 */
  dono = "";

  /** 物流渠道 */
  logisticsChannel = "";

  /** 拣货单号 */
  pickno = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 店铺名称 */
  shopName = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 10:销售订单 20:调拨单 30:库存调整单 40:移库单 */
  sourceType = undefined;

  /** 状态 10:待拣货 20:已拣货 30:已校验 40:校验失败 50:已称重 60:已发运 */
  status = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";
}

class PickDetailSerialBySkuDonoResponseDto {
  /** sku拣货明细 */
  detailSerialResponseDto = new PickDetailSerialResponseDto();

  /** sku加dono唯一key */
  skuDono = "";
}

class PickDetailSerialResponseDto {
  /** asin */
  asin = "";

  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 配货位 */
  distribute = undefined;

  /** 出库单号 */
  dono = "";

  /** fnsku */
  fnSku = "";

  /** id */
  id = undefined;

  /** msku */
  msku = "";

  /** 拣货单号 */
  pickno = "";

  /** 库位编号 */
  positionCode = "";

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 产品类型 10:成品 20:半成品 30:组合产品 40:包装材料 */
  productType = undefined;

  /** 数量 */
  qty = undefined;

  /** 实拣数量 */
  realQty = undefined;

  /** sku */
  sku = "";

  /** 库位下sku明细 */
  skuDetailResponseDtos = [];

  /** 状态 10:未拣货 20:已拣货 30:丢失 40:已还货 */
  status = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 是否拆箱 0:否1:是 */
  unpackFlag = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 变体规格 */
  variants = "";
}

class PickInfoPositionResponseDto {
  /** 库位编号 */
  positionCode = "";

  /** 拣货sku */
  skuResponseDtos = [];
}

class PickInfoResponseDto {
  /** 包裹数 */
  boxNum = undefined;

  /** 创建时间 */
  createTime = "";

  /** 物流渠道 */
  logisticsChannelName = "";

  /** 物流商 */
  logisticsProviderName = "";

  /** 拣货单号 */
  pickno = "";

  /** 拣货库位列表 */
  positionResponseDtos = [];

  /** 拣货数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** 运输方式：10 空运，20 海运，30 快船，40 铁路 */
  shippingType = undefined;

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 交易主体 */
  tradeCompanyName = "";

  /** 来源仓库名称 */
  warehouseName = "";
}

class PickInfoSkuDetailResponseDto {
  /** 配货位 */
  distribute = undefined;

  /** fnsku */
  fnsku = "";

  /** 物流分组 */
  logisticsGroup = "";

  /** 库位编号 */
  positionCode = "";

  /** 产品标题 */
  productTitle = "";

  /** 拣货数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 规格 */
  variants = "";
}

class PickInfoSkuResponseDto {
  /** 库位编号 */
  positionCode = "";

  /** 拣货数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** sku配货明细 */
  skuDetailResponseDtos = [];

  /** 规格 */
  variants = "";
}

class PickMasterResponseDto {
  /** 库位数量 */
  binNum = undefined;

  /** 包裹数量 */
  boxNum = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 总数量 */
  num = undefined;

  /** 拣货单号 */
  pickno = "";

  /** 打印人 */
  printBy = "";

  /** 打印时间 */
  printTime = "";

  /** 打印标识 0：否1：是 */
  printed = false;

  /** 产品数量 (sku+批次) */
  productNum = undefined;

  /** 备注 */
  remark = "";

  /** 状态 0:未拣货 1:已拣货 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class PickOutRequestDto {
  /** 配货位 */
  distribute = undefined;

  /** 出库单号 */
  dono = "";
}

class PickPositionResponseDto {
  /** 拣货产品--根据dono+sku分组 */
  pickDetailSerialResponseDtos = [];

  /** 库位编号 */
  positionCode = "";
}

class PickWaitInfoResponseDto {
  /** 是否自由拣货 0-否 1-是 */
  inPosition = undefined;

  /** 拣货单信息 */
  pickMasterResponseDto = new PickMasterResponseDto();

  /** 拣货库位信息 */
  pickPositionList = [];

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;
}

class PonoStockDetailResultDto {
  /** 可用库存 */
  qty = undefined;

  /** sku */
  sku = "";
}

class PonoStockResultDto {
  /** sku明细 */
  dtoList = [];

  /** pono */
  pono = "";
}

class PositionStorageCapacityInfoResponseDto {
  /** ipage */
  ipage = new IPage();

  /** 总数 */
  total = undefined;

  /** 已使用总数 */
  use = undefined;
}

class PositionStorageCapacityRequestDto {
  /** 库区编号列表 */
  areaCodeList = [];

  /** 计算时间 */
  calculatingTime = "";

  /** 排序 */
  orderBy = "";

  /** 当前页 */
  pageNumber = undefined;

  /** 每页条数 */
  pageSize = undefined;

  /** 报表类型，1：库位使用率 2：库容使用率 */
  reportType = undefined;

  /** 母仓库编号列表 */
  rootWarehouseCodeList = [];

  /** 统计维度 */
  statisticalDimension = "";

  /** 子仓库编号列表 */
  warehouseCodeList = [];
}

class PositionStorageCapacityResponseDto {
  /** 库区编号 */
  areaCode = "";

  /** 库位编号 */
  positionCode = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 货架编号 */
  shelvesCode = "";

  /** 库位总数 */
  totalQty = "";

  /** 库位体积总量 */
  totalVolume = "";

  /** 库位已使用数 */
  useQty = "";

  /** 库位已使用体积 */
  useVolume = "";

  /** 利用率 */
  utilization = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class PostponementOrderResponseDto {
  /** 明细 */
  details = [];

  /** 需求月份 */
  maxDemandMonth = "";
}

class ProductSizeSectionRequestParamsDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 商品尺寸分段：10 标准件，20 大货件 */
  productSizeSection = undefined;

  /** SKU */
  sku = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class ProductSizeSectionResponseDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 商品尺寸分段：10 标准件，20 大货件 */
  productSizeSection = undefined;

  /** 尺寸分段 */
  productSizeSectionCN = "";

  /** SKU */
  sku = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class PurchaseStockOccupyDetailRequestDto {
  /** 合同交期 */
  contractDeliveryTime = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 采购确定交期 */
  determineDeliveryTime = "";

  /** 需求订单NO */
  dono = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 采购占用数量 */
  occupyQty = undefined;

  /** 原定交期 */
  originalDeliveryTime = "";

  /** PO单据NO */
  pono = "";

  /** 采购数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 采购单价 */
  unitPrice = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PurchaseStockOccupyDetailResponseDto {
  /** 合同交期 */
  contractDeliveryTime = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 采购确定交期 */
  determineDeliveryTime = "";

  /** 需求订单NO */
  dono = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 采购占用数量 */
  occupyQty = undefined;

  /** 原定交期 */
  originalDeliveryTime = "";

  /** PO单据NO */
  pono = "";

  /** 采购数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 采购单价 */
  unitPrice = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PurchaseStockOccupyRequestDto {
  /** 合同交期 */
  contractDeliveryTime = "";

  /** 采购确定交期 */
  determineDeliveryTime = "";

  /** 原定交期 */
  originalDeliveryTime = "";

  /** PO单据NO */
  pono = "";

  /** 采购数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 采购单价 */
  unitPrice = undefined;
}

class RedundancyStockResponseDto {
  /** 采购在途冗余库存 */
  purchaseRedundancyQty = undefined;

  /** 国内仓冗余数量 */
  warehouseCnRedundancyQty = undefined;
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new AllocationBatchDetailResponseDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResubmitRequestDto {
  /** 需求日期 0：上半月 1：下半月 */
  demandDate = undefined;

  /** 订单号 */
  dono = "";

  /** 是否工厂直发 */
  factoryDirectHairFlag = false;

  /** 订单数量 */
  initQty = undefined;
}

class SaleForecastRequestDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 导入时间 */
  importTime = "";

  /** 版本 */
  lockVersion = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** T月基线预测 */
  t0BaselineForecast = undefined;

  /** T+1月基线预测 */
  t1BaselineForecast = undefined;

  /** T+2月基线预测 */
  t2BaselineForecast = undefined;

  /** T+3月基线预测 */
  t3BaselineForecast = undefined;

  /** T+4月基线预测 */
  t4BaselineForecast = undefined;

  /** T+5月基线预测 */
  t5BaselineForecast = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SaleForecastResponseDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 导入时间 */
  importTime = "";

  /** 版本 */
  lockVersion = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** T月基线预测 */
  t0BaselineForecast = undefined;

  /** T+1月基线预测 */
  t1BaselineForecast = undefined;

  /** T+2月基线预测 */
  t2BaselineForecast = undefined;

  /** T+3月基线预测 */
  t3BaselineForecast = undefined;

  /** T+4月基线预测 */
  t4BaselineForecast = undefined;

  /** T+5月基线预测 */
  t5BaselineForecast = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SaleTransferOrderTxRequestDto {
  /** aonos */
  aonos = [];
}

class SalesOwnerInfoRequestDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** id */
  id = undefined;

  /** 销售负责人 */
  saleOwner = "";

  /** 销售负责人编号 */
  saleOwnerCode = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU */
  sku = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;
}

class SalesOwnerInfoResponseDto {
  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** remark */
  remark = "";

  /** 销售负责人 */
  saleOwner = "";

  /** 销售负责人编号 */
  saleOwnerCode = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU */
  sku = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class ShelvesAddRequestDto {
  /** 库区编号 */
  areaCode = "";

  /** 自动生成：0:否 1:是 */
  autoCreate = undefined;

  /** 货架组编号 */
  code = "";

  /** id */
  id = undefined;

  /** 货架组名称 */
  name = "";

  /** 新库区编号 */
  newAreaCode = "";

  /** 新仓库编号 */
  newWarehouseCode = "";

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** 货架集合 */
  storageGroupList = [];

  /** 转移：0:否 1:是 */
  transferFlag = false;

  /** 仓库编号 */
  warehouseCode = "";
}

class ShopDepartmentMappingRequestDto {
  /** 地址 */
  address = "";

  /** 事业部 */
  department = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 货代信息 */
  representativesInformation = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺 */
  shopName = "";
}

class ShopDepartmentMappingResponseDto {
  /** 地址 */
  address = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 事业部 */
  department = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 货代信息 */
  representativesInformation = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺 */
  shopName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SinglePostponementRequestDto {
  /** 调整订单 */
  adjustmentOrderList = [];

  /** 调拨占用数量 */
  allocationOccupyQty = undefined;

  /** 发运数量 */
  deliveryQty = undefined;

  /** id */
  id = undefined;

  /** 新增订单 */
  newOrderList = [];

  /** sku */
  skuNo = "";
}

class SiteDimensionKeyDto {
  /** 渠道key */
  channelKey = "";

  /** 站点 */
  siteKey = "";

  /** SKU */
  sku = "";
}

class SkuInfoDetailRequestDto {
  /** 渠道 */
  channel = "";

  /** 当月1日-当日销量 */
  currentMonthSales = undefined;

  /** 处理时间 */
  etlTime = "";

  /** FBA积压库存 */
  fbaBacklog = undefined;

  /** FBA库存 */
  fbaStock = undefined;

  /** FBA在途库存 */
  fbaTransit = undefined;

  /** id */
  id = undefined;

  /** insertTime */
  insertTime = "";

  /** lastUpdateTime */
  lastUpdateTime = "";

  /** 销售单价RMB */
  salesPrice = undefined;

  /** SBU */
  sbuName = "";

  /** 近7天销量 */
  sevenDaySales = undefined;

  /** 站点 */
  siteKey = "";

  /** sku */
  skuNo = "";

  /** T-10月销量 */
  t10Sales = undefined;

  /** T-11月销量 */
  t11Sales = undefined;

  /** T-12月销量 */
  t12Sales = undefined;

  /** T-1月销量 */
  t1Sales = undefined;

  /** T-2月销量 */
  t2Sales = undefined;

  /** T-3月销量 */
  t3Sales = undefined;

  /** T-4月销量 */
  t4Sales = undefined;

  /** T-5月销量 */
  t5Sales = undefined;

  /** T-6月销量 */
  t6Sales = undefined;

  /** T-7月销量 */
  t7Sales = undefined;

  /** T-8月销量 */
  t8Sales = undefined;

  /** T-9月销量 */
  t9Sales = undefined;

  /** 最近30天有效销量 */
  thirtyDaySales = undefined;
}

class SkuInfoDetailResponseDto {
  /** 渠道 */
  channel = "";

  /** 当月1日-当日销量 */
  currentMonthSales = undefined;

  /** 处理时间 */
  etlTime = "";

  /** FBA积压库存 */
  fbaBacklog = undefined;

  /** FBA库存 */
  fbaStock = undefined;

  /** FBA在途库存 */
  fbaTransit = undefined;

  /** id */
  id = undefined;

  /** insertTime */
  insertTime = "";

  /** lastUpdateTime */
  lastUpdateTime = "";

  /** 销售单价RMB */
  salesPrice = undefined;

  /** SBU */
  sbuName = "";

  /** 近7天销量 */
  sevenDaySales = undefined;

  /** 站点 */
  siteKey = "";

  /** sku */
  skuNo = "";

  /** T-10月销量 */
  t10Sales = undefined;

  /** T-11月销量 */
  t11Sales = undefined;

  /** T-12月销量 */
  t12Sales = undefined;

  /** T-1月销量 */
  t1Sales = undefined;

  /** T-2月销量 */
  t2Sales = undefined;

  /** T-3月销量 */
  t3Sales = undefined;

  /** T-4月销量 */
  t4Sales = undefined;

  /** T-5月销量 */
  t5Sales = undefined;

  /** T-6月销量 */
  t6Sales = undefined;

  /** T-7月销量 */
  t7Sales = undefined;

  /** T-8月销量 */
  t8Sales = undefined;

  /** T-9月销量 */
  t9Sales = undefined;

  /** 最近30天有效销量 */
  thirtyDaySales = undefined;
}

class SkuInfoRequestDto {
  /** 海外仓库存 */
  abroadStock = undefined;

  /** 海外仓在途 */
  abroadTransit = undefined;

  /** BU */
  bu = "";

  /** 大小件 */
  commoditySize = undefined;

  /** 处理时间 */
  etlTime = "";

  /** id */
  id = undefined;

  /** insertTime */
  insertTime = "";

  /** lastUpdateTime */
  lastUpdateTime = "";

  /** MOQ */
  moq = undefined;

  /** MPQ */
  mpq = undefined;

  /** 计划员 */
  planner = "";

  /** 产品分级 */
  productLevel = "";

  /** 一级产品线 */
  productLine1st = "";

  /** 二级产品线 */
  productLine2nd = "";

  /** 三级产品线 */
  productLine3rd = "";

  /** SPU */
  productNo = "";

  /** 生产周期(天) */
  productionCycle = undefined;

  /** 采购员 */
  purchaser = "";

  /** 单箱体积（m³） */
  singleBoxVolume = undefined;

  /** 单箱重量（KG） */
  singlePackingWeight = undefined;

  /** sku */
  skuNo = "";

  /** 采购在途库存 */
  skuPurchaseStock = undefined;

  /** sku名称 */
  skuTitleCn = "";

  /** 国内仓库存 */
  skuWarehouseCnStock = undefined;
}

class SkuInfoResponseDto {
  /** 海外仓库存 */
  abroadStock = undefined;

  /** 海外仓在途 */
  abroadTransit = undefined;

  /** BU */
  bu = "";

  /** 大小件 */
  commoditySize = undefined;

  /** 处理时间 */
  etlTime = "";

  /** id */
  id = undefined;

  /** insertTime */
  insertTime = "";

  /** lastUpdateTime */
  lastUpdateTime = "";

  /** MOQ */
  moq = undefined;

  /** MPQ */
  mpq = undefined;

  /** 计划员 */
  planner = "";

  /** 产品分级 */
  productLevel = "";

  /** 一级产品线 */
  productLine1st = "";

  /** 二级产品线 */
  productLine2nd = "";

  /** 三级产品线 */
  productLine3rd = "";

  /** SPU */
  productNo = "";

  /** 生产周期(天) */
  productionCycle = undefined;

  /** 采购员 */
  purchaser = "";

  /** 单箱体积（m³） */
  singleBoxVolume = undefined;

  /** 单箱重量（KG） */
  singlePackingWeight = undefined;

  /** sku */
  skuNo = "";

  /** 采购在途库存 */
  skuPurchaseStock = undefined;

  /** sku名称 */
  skuTitleCn = "";

  /** 国内仓库存 */
  skuWarehouseCnStock = undefined;
}

class SkuPackageInfo {
  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** sku数量 */
  qty = undefined;

  /** sku编码 */
  skuNo = "";
}

class SkuQtyDetail {
  /** 数量 */
  qty = undefined;

  /** sku */
  skuNO = "";
}

class SnCodeInfoDto {
  /** 平台 */
  platformCode = "";

  /** sku名称 */
  skuName = "";

  /** sku编号 */
  skuNo = "";

  /** sn码 */
  snCode = "";
}

class StagingAreaDetailAddRequestDto {
  /** 关联单号 */
  correlationNo = "";

  /** 操作单号 */
  operationNo = "";

  /** 数量 */
  qty = undefined;

  /** 暂存区编号 */
  stagingCode = "";

  /** 暂存区名称 */
  stagingName = "";

  /** 仓库编码 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StagingAreaDetailResponseDto {
  /** 关联单号 */
  correlationNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 操作单号 */
  operationNo = "";

  /** 操作类型：1:调拨单 2:销售订单 */
  operationType = undefined;

  /** 数量 */
  qty = undefined;

  /** 暂存区编号 */
  stagingCode = "";

  /** 暂存区名称 */
  stagingName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StagingAreaLogModel {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 操作内容 */
  operatingContent = "";

  /** 暂存区编号 */
  stagingCode = "";

  /** 暂存区名称 */
  stagingName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StagingAreaMasterRequestDto {
  /** 关联单号 */
  correlationNo = "";

  /** 操作类型 */
  operationType = undefined;

  /** 暂存区编号 */
  stagingCode = "";

  /** 暂存区名称 */
  stagingName = "";

  /** 集货状态 1:已集货 0:未集货 */
  stagingStatus = undefined;

  /** 状态 1:启用 0:未启用 */
  status = undefined;

  /** 仓库编码 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StagingAreaMasterResponseDto {
  /** 关联单号 */
  correlationNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 操作类型：1:调拨单单 2:销售订 */
  operationType = undefined;

  /** 数量 */
  qty = undefined;

  /** 暂存区编号 */
  stagingCode = "";

  /** 暂存区名称 */
  stagingName = "";

  /** 集货状态 1:已集货 0:未集货 */
  stagingStatus = undefined;

  /** 集货状态 1:启用 0:未启用 */
  status = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockAgeInfoResponseDto {
  /** 库龄（天） */
  age = undefined;

  /** 批次 */
  batchNo = "";

  /** 入库时间 */
  inTime = "";

  /** 库位或单据 */
  positionCode = "";

  /** 产品名称 */
  productName = "";

  /** 在库数量 */
  qty = undefined;

  /** sku编号 */
  skuNo = "";

  /** 来源单号 */
  sourceNo = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockAgeRequestDto {
  /** 库龄 */
  age = undefined;

  /** 排序 */
  orderBy = "";

  /** 当前页 */
  pageNumber = undefined;

  /** 每页条数 */
  pageSize = undefined;

  /** 母仓库编号列表 */
  rootWarehouseCodeList = [];

  /** sku编号 */
  skuNo = "";

  /** 主体编号列表 */
  tradeCompanyCodeList = [];

  /** 子仓库编号列表 */
  warehouseCodeList = [];
}

class StockAgeResponseDto {
  /** ipage */
  ipage = new IPage();

  /** 在库总数 */
  totalQty = undefined;
}

class StockChangeLabelRequestDto {
  /** 整箱信息 */
  boxStorageDto = new StorageChangeLabelBoxRequestDto();

  /** Sku信息 */
  skuStorageDto = new StorageChangeLabelSkuRequestDto();
}

class StockDetailGroupResponseDto {
  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** id */
  id = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 产品名称 */
  productName = "";

  /** 总库存 */
  qty = undefined;

  /** 蓝图创拓库存 */
  rantionForeignQty = undefined;

  /** 蓝深科技库存 */
  rantionTechnologyQty = undefined;

  /** 蓝深贸易库存 */
  rantionTradeQty = undefined;

  /** sku */
  sku = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 可用数量 */
  useQty = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 芯蓝科技库存 */
  xinRantionQty = undefined;
}

class StockDetailRequestParamsDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** id */
  id = undefined;

  /** 标签(fnsku) */
  label = "";

  /** 库位编号 */
  positionCode = "";

  /** sku */
  sku = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 仓库编号 */
  warehouseCode = "";
}

class StockDetailResponseDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 高度(cm) */
  height = undefined;

  /** id */
  id = undefined;

  /** 标签(fnsku) */
  label = "";

  /** 长度(cm) */
  length = undefined;

  /** 锁定数量 */
  lockQty = undefined;

  /** 是否开过箱：1是 0否 */
  openFlag = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 产品名称 */
  productName = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 库龄 */
  stockAge = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 可用数量 */
  useQty = undefined;

  /** 体积(cm3) */
  volume = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 宽度(cm) */
  width = undefined;
}

class StockDetailSummaryResponseDto {
  /** 总箱数 */
  boxQty = undefined;

  /** 总库存 */
  qty = undefined;

  /** 总SKU数 */
  skuQty = undefined;
}

class StockFreezeRecordRequestDto {
  /** 冻结原因 */
  freezeReason = "";

  /** id */
  id = undefined;

  /** 库位编号 */
  positionCode = "";

  /** sku */
  sku = "";

  /** 预计解冻时间 */
  unfreezeDate = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockFreezeRecordResponseDto {
  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 冻结原因 */
  freezeReason = "";

  /** 冻结编号 */
  freezeno = "";

  /** id */
  id = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 总库存 */
  qty = undefined;

  /** 蓝图创拓库存 */
  rantionForeignQty = undefined;

  /** 蓝深科技库存 */
  rantionTechnologyQty = undefined;

  /** 蓝深贸易库存 */
  rantionTradeQty = undefined;

  /** sku */
  sku = "";

  /** 状态 10:已冻结 20:已解冻 */
  status = undefined;

  /** 预计解冻时间 */
  unfreezeDate = "";

  /** 解冻时间 */
  unfreezeTime = "";

  /** 解冻人 */
  unfreezeUser = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockGroupForPositionResponseDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 库位编号 */
  positionCode = "";

  /** 产品名称 */
  productName = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockMoveRequestDto {
  /** 整箱移库信息 */
  boxtorageDto = new StorageMoveBoxRequestDto();

  /** Sku移库信息 */
  skuStorageDto = new StorageMoveSkuRequestDto();
}

class StockOccupyMasterSelectRequestDto {
  /** 采购单号 */
  pono = "";

  /** sku集合 */
  skuPrice = [];

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** warehoseCodes */
  warehoseCodes = [];

  /** 仓库编号 */
  warehouseCode = "";
}

class StockOccupyMasterSelectSkuRequestDto {
  /** 价格 */
  price = undefined;

  /** sku */
  sku = "";
}

class StockSplitBoxDto {
  /** 箱号 */
  box = "";

  /** 整箱拆分标识 */
  isAllStockFlag = false;

  /** 存在散货记录标识 */
  isExistStockFlag = false;

  /** 数量 */
  qty = undefined;
}

class StorageChangeLabelBoxRequestDto {
  /** 箱号 */
  barcode = "";

  /** 新标签 */
  newLabel = "";

  /** 库位 */
  positionCode = "";
}

class StorageChangeLabelSkuRequestDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** 标签(fnsku) */
  label = "";

  /** 新标签 */
  newLabel = "";

  /** 库位 */
  positionCode = "";

  /** 数量 */
  qty = undefined;

  /** SKU */
  sku = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;
}

class StorageDamageDetailResponseDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 报损单号 */
  fono = "";

  /** 标签(fnsku) */
  label = "";

  /** 数量 */
  num = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StorageDamagetWorkflowDto {
  /** 提交人备注 */
  applyMemo = "";

  /** 提交人ID */
  applyUserId = undefined;

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 报损单号 */
  fono = "";

  /** 工作流实例ID */
  processInstanceId = "";

  /** 工作流TaskID */
  taskId = "";
}

class StorageForNsDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 创建时间 */
  createTime = "";

  /** fn_sku */
  fnSku = "";

  /** 是否开过箱：1是 0否 */
  openFlag = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 可用数量 */
  qty = undefined;

  /** SKU */
  sku = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StorageGroupRequestDto {
  /** 货架编号 */
  code = "";

  /** 列数 (货架组必填) */
  columns = "";

  /** 层数 (货架组必填) */
  layers = undefined;

  /** 状态 0:停用 1:启用 */
  status = undefined;
}

class StorageLocationListRequestDto {
  /** 库区编号 */
  areaCode = "";

  /** 货架组编号 */
  groupCode = "";

  /** 货架编号 */
  shelvesCode = "";

  /** 仓库编号 */
  warehouseCode = "";
}

class StorageMoveBoxRequestDto {
  /** 箱号 */
  barcodeList = [];

  /** 新库位 */
  newPositionCode = "";

  /** 旧库位 */
  oldPositionCode = "";
}

class StorageMoveSkuRequestDto {
  /** 条码 装箱条码/SKU */
  barcode = "";

  /** 批次号 */
  batchNo = "";

  /** 标签(fnsku) */
  label = "";

  /** 新库位 */
  newPosition = "";

  /** 旧库位 */
  positionCode = "";

  /** 数量 */
  qty = undefined;

  /** SKU */
  sku = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;
}

class StorageOfOccupyResponseDto {
  /** 出库单号 */
  dono = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 单据号 */
  sourceNo = "";

  /** 单据类型 10:销售订单 20:采购退货单 30:调拨单 40:借调单 */
  sourceType = undefined;

  /** 仓库编号 */
  warehouseCode = "";
}

class StorageReportDamageResponseDto {
  /** 审核时间 */
  auditTime = "";

  /** 审核人 */
  auditor = "";

  /** 条码 装箱条码/SKU */
  barcode = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 事业部 */
  department = "";

  /** 报损单号 */
  fono = "";

  /** id */
  id = undefined;

  /** 标签(fnsku) */
  label = "";

  /** 数量 */
  num = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 工作流实例id */
  processInstanceId = undefined;

  /** 驳回人 */
  rejecter = "";

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** 报损状态 10:待审核 20:已审核 30:已驳回 */
  status = undefined;

  /** 库存成本 */
  storageCost = undefined;

  /** 主体编号 */
  tradeCompanyCode = "";

  /** 主体名称 */
  tradeCompanyName = "";

  /** 类型 1:已装箱 2:未装箱 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StorageUnitAreaRequestDto {
  /** 库区类型 10:自营 20:FBA */
  areaType = undefined;

  /** 编号 */
  code = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** 仓库编号 */
  warehouseCode = "";
}

class StorageUnitResponseDto {
  /** 库区编号 */
  areaCode = "";

  /** 库区名称 */
  areaName = "";

  /** 库区类型 10:自营 20:FBA */
  areaType = undefined;

  /** 自动生成：0:否 1:是 */
  autoCreate = undefined;

  /** 编号 */
  code = "";

  /** 列数 (货架组必填) */
  columns = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 层数 (货架组必填) */
  layers = undefined;

  /** 名称 */
  name = "";

  /** 关联编号(弃用) */
  relationCode = "";

  /** 行数 (货架组必填 默认1) */
  rows = undefined;

  /** 货架编号 */
  shelvesCode = "";

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** 存储类型 10:库区 20:货架 30:货架组 */
  storageType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class SupplyDemandBalanceDetailRequestDto {
  /** 基线预测版本 */
  baselineVersion = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 汇总id */
  collectId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当月1日销量 */
  currentMonthSales = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 需求订单NO */
  dono = "";

  /** 初审单号 */
  firstTrialNo = "";

  /** id */
  id = undefined;

  /** 最初订单数量 */
  initQty = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 补货计划金额 */
  replenishmentPlanAmount = undefined;

  /** 补货计划定金 */
  replenishmentPlanDeposit = undefined;

  /** 补货计划数量 */
  replenishmentPlanQty = undefined;

  /** 销售单价 */
  salesUnitPrice = undefined;

  /** SBU名称 */
  sbuName = "";

  /** 近7天销量 */
  sevenDaySales = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** T月基线预测 */
  t0BaselineForecast = undefined;

  /** T月发货需求 */
  t0DeliveryDemand = undefined;

  /** T+1月基线预测 */
  t1BaselineForecast = undefined;

  /** T+1月发货需求 */
  t1DeliveryDemand = undefined;

  /** T-1月销量 */
  t1Sales = undefined;

  /** T+2月基线预测 */
  t2BaselineForecast = undefined;

  /** T+2月发货需求 */
  t2DeliveryDemand = undefined;

  /** T-2月销量 */
  t2Sales = undefined;

  /** T+3月基线预测 */
  t3BaselineForecast = undefined;

  /** T+3月发货需求 */
  t3DeliveryDemand = undefined;

  /** T-3月销量 */
  t3Sales = undefined;

  /** T+4月基线预测 */
  t4BaselineForecast = undefined;

  /** T+4月发货需求 */
  t4DeliveryDemand = undefined;

  /** T-4月销量 */
  t4Sales = undefined;

  /** T+5月基线预测 */
  t5BaselineForecast = undefined;

  /** T+5月发货需求 */
  t5DeliveryDemand = undefined;

  /** T-5月销量 */
  t5Sales = undefined;

  /** T-6月销量 */
  t6Sales = undefined;

  /** 最近30天有效销量 */
  thirtyDaySales = undefined;

  /** 总发货需求 */
  totalDeliveryDemand = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplyDemandBalanceDetailResponseDto {
  /** 海外库存 */
  abroadStock = undefined;

  /** 海外在途 */
  abroadTransit = undefined;

  /** 基线预测版本 */
  baselineVersion = "";

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 渠道key */
  channelKey = "";

  /** 渠道名称 */
  channelName = "";

  /** 汇总id */
  collectId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当月1日销量 */
  currentMonthSales = undefined;

  /** 交货计划金额 */
  deliveryPlanAmount = undefined;

  /** 交货计划尾款 */
  deliveryPlanBalanceDuet = undefined;

  /** 交货计划数量 */
  deliveryPlanQty = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 需求订单NO */
  dono = "";

  /** FBA积压库存 */
  fbaBacklog = undefined;

  /** FBA库存 */
  fbaStock = undefined;

  /** FBA在途库存 */
  fbaTransit = undefined;

  /** 初审单号 */
  firstTrialNo = "";

  /** id */
  id = undefined;

  /** 最初订单数量 */
  initQty = undefined;

  /** 计划员 */
  planner = "";

  /** 产品分级 */
  productLevel = "";

  /** 一级产品线 */
  productLine1st = "";

  /** 二级产品线 */
  productLine2nd = "";

  /** 三级产品线 */
  productLine3rd = "";

  /** spu产品id */
  productNo = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 采购周期（天） */
  purchaseCycle = undefined;

  /** 采购提前期（天） */
  purchaseLeadtime = undefined;

  /** 采购单价 */
  purchaseUnitPrice = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 补货计划金额 */
  replenishmentPlanAmount = undefined;

  /** 补货计划定金 */
  replenishmentPlanDeposit = undefined;

  /** 补货计划数量 */
  replenishmentPlanQty = undefined;

  /** 销售单价 */
  salesUnitPrice = undefined;

  /** SBU名称 */
  sbuName = "";

  /** 近7天销量 */
  sevenDaySales = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** 采购在途库存(sku维度) */
  skuPurchaseStock = undefined;

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 国内仓库存(sku维度) */
  skuWarehouseCnStock = undefined;

  /** 冗余采购在途库存数量 */
  surplusPurchaseTransit = undefined;

  /** 冗余采购在途成本金额 */
  surplusPurchaseTransitAmount = undefined;

  /** 冗余CN仓库存成本金额 */
  surplusWarehouseCnAmount = undefined;

  /** 冗余cn仓库存数量 */
  surplusWarehouseCnStock = undefined;

  /** T月基线预测 */
  t0BaselineForecast = undefined;

  /** T月发货需求 */
  t0DeliveryDemand = undefined;

  /** T+1月基线预测 */
  t1BaselineForecast = undefined;

  /** T+1月发货需求 */
  t1DeliveryDemand = undefined;

  /** T-1月销量 */
  t1Sales = undefined;

  /** T+2月基线预测 */
  t2BaselineForecast = undefined;

  /** T+2月发货需求 */
  t2DeliveryDemand = undefined;

  /** T-2月销量 */
  t2Sales = undefined;

  /** T+3月基线预测 */
  t3BaselineForecast = undefined;

  /** T+3月发货需求 */
  t3DeliveryDemand = undefined;

  /** T-3月销量 */
  t3Sales = undefined;

  /** T+4月基线预测 */
  t4BaselineForecast = undefined;

  /** T+4月发货需求 */
  t4DeliveryDemand = undefined;

  /** T-4月销量 */
  t4Sales = undefined;

  /** T+5月基线预测 */
  t5BaselineForecast = undefined;

  /** T+5月发货需求 */
  t5DeliveryDemand = undefined;

  /** T-5月销量 */
  t5Sales = undefined;

  /** T-6月销量 */
  t6Sales = undefined;

  /** 最近30天有效销量 */
  thirtyDaySales = undefined;

  /** 总发货需求 */
  totalDeliveryDemand = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplyDemandBalanceRequestDto {
  /** 海外库存 */
  abroadStock = undefined;

  /** 海外在途 */
  abroadTransit = undefined;

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当月1日-当日销量 */
  currentMonthSales = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 交货计划金额 */
  deliveryPlanAmount = undefined;

  /** 交货计划尾款 */
  deliveryPlanBalanceDuet = undefined;

  /** 交货计划数量 */
  deliveryPlanQty = undefined;

  /** FBA积压库存 */
  fbaBacklog = undefined;

  /** FBA库存 */
  fbaStock = undefined;

  /** FBA在途库存 */
  fbaTransit = undefined;

  /** id */
  id = undefined;

  /** 最初订单数量 */
  initQty = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 计划员 */
  planner = "";

  /** 产品分级 */
  productLevel = "";

  /** 一级产品线 */
  productLine1st = "";

  /** 二级产品线 */
  productLine2nd = "";

  /** 三级产品线 */
  productLine3rd = "";

  /** spu产品id */
  productNo = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 采购提前期（天） */
  purchaseLeadtime = undefined;

  /** 采购单价 */
  purchaseUnitPrice = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 补货计划金额 */
  replenishmentPlanAmount = undefined;

  /** 补货计划定金 */
  replenishmentPlanDeposit = undefined;

  /** 补货计划数量 */
  replenishmentPlanQty = undefined;

  /** 近7天销量 */
  sevenDaySales = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU编号 */
  skuNo = "";

  /** 采购在途库存(sku维度) */
  skuPurchaseStock = undefined;

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 国内仓库存(sku维度) */
  skuWarehouseCnStock = undefined;

  /** 冗余采购在途库存数量 */
  surplusPurchaseTransit = undefined;

  /** 冗余采购在途成本金额 */
  surplusPurchaseTransitAmount = undefined;

  /** 冗余CN仓库存成本金额 */
  surplusWarehouseCnAmount = undefined;

  /** 冗余cn仓库存数量 */
  surplusWarehouseCnStock = undefined;

  /** T月基线预测 */
  t0BaselineForecast = undefined;

  /** T+1月基线预测 */
  t1BaselineForecast = undefined;

  /** T-1月销量 */
  t1Sales = undefined;

  /** T+2月基线预测 */
  t2BaselineForecast = undefined;

  /** T-2月销量 */
  t2Sales = undefined;

  /** T+3月基线预测 */
  t3BaselineForecast = undefined;

  /** T-3月销量 */
  t3Sales = undefined;

  /** T+4月基线预测 */
  t4BaselineForecast = undefined;

  /** T-4月销量 */
  t4Sales = undefined;

  /** T+5月基线预测 */
  t5BaselineForecast = undefined;

  /** T-5月销量 */
  t5Sales = undefined;

  /** T-6月销量 */
  t6Sales = undefined;

  /** 最近30天有效销量 */
  thirtyDaySales = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplyDemandBalanceResponseDto {
  /** 海外库存 */
  abroadStock = undefined;

  /** 海外在途 */
  abroadTransit = undefined;

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当月1日-当日销量 */
  currentMonthSales = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 交货计划金额 */
  deliveryPlanAmount = undefined;

  /** 交货计划尾款 */
  deliveryPlanBalanceDuet = undefined;

  /** 交货计划数量 */
  deliveryPlanQty = undefined;

  /** FBA积压库存 */
  fbaBacklog = undefined;

  /** FBA库存 */
  fbaStock = undefined;

  /** FBA在途库存 */
  fbaTransit = undefined;

  /** id */
  id = undefined;

  /** 最初订单数量 */
  initQty = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 计划员 */
  planner = "";

  /** 产品分级 */
  productLevel = "";

  /** 一级产品线 */
  productLine1st = "";

  /** 二级产品线 */
  productLine2nd = "";

  /** 三级产品线 */
  productLine3rd = "";

  /** spu产品id */
  productNo = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 采购周期（天） */
  purchaseCycle = undefined;

  /** 采购提前期（天） */
  purchaseLeadtime = undefined;

  /** 采购单价 */
  purchaseUnitPrice = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 补货计划金额 */
  replenishmentPlanAmount = undefined;

  /** 补货计划定金 */
  replenishmentPlanDeposit = undefined;

  /** 补货计划数量 */
  replenishmentPlanQty = undefined;

  /** 近7天销量 */
  sevenDaySales = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU编号 */
  skuNo = "";

  /** 采购在途库存(sku维度) */
  skuPurchaseStock = undefined;

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 国内仓库存(sku维度) */
  skuWarehouseCnStock = undefined;

  /** 冗余采购在途库存数量 */
  surplusPurchaseTransit = undefined;

  /** 冗余采购在途成本金额 */
  surplusPurchaseTransitAmount = undefined;

  /** 冗余CN仓库存成本金额 */
  surplusWarehouseCnAmount = undefined;

  /** 冗余cn仓库存数量 */
  surplusWarehouseCnStock = undefined;

  /** T月基线预测 */
  t0BaselineForecast = undefined;

  /** T+1月基线预测 */
  t1BaselineForecast = undefined;

  /** T-1月销量 */
  t1Sales = undefined;

  /** T+2月基线预测 */
  t2BaselineForecast = undefined;

  /** T-2月销量 */
  t2Sales = undefined;

  /** T+3月基线预测 */
  t3BaselineForecast = undefined;

  /** T-3月销量 */
  t3Sales = undefined;

  /** T+4月基线预测 */
  t4BaselineForecast = undefined;

  /** T-4月销量 */
  t4Sales = undefined;

  /** T+5月基线预测 */
  t5BaselineForecast = undefined;

  /** T-5月销量 */
  t5Sales = undefined;

  /** T-6月销量 */
  t6Sales = undefined;

  /** 最近30天有效销量 */
  thirtyDaySales = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplyDemandMatchReportResponseDto {
  /** 渠道名称 */
  channelName = "";

  /** 创建时间 */
  createTime = "";

  /** 需求日期 0：上半月 1：下半月 */
  demandDate = undefined;

  /** 需求月份 */
  demandMonth = "";

  /** 需求订单NO */
  dono = "";

  /** 终审订单数量 */
  finalQty = undefined;

  /** 是否满足 */
  isSatisfy = false;

  /** 未创建调拨数量 */
  notCreateAllocationQty = undefined;

  /** 计划员 */
  planner = "";

  /** 产品分级 */
  productLevel = "";

  /** 二级产品线 */
  productLine2nd = "";

  /** 采购在途库存(占用关系) */
  purchaseStock = undefined;

  /** 合同到期采购在途数量 */
  purchaseStockByExpire = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 运输方式 */
  shippingMode = undefined;

  /** 站点名称 */
  siteName = "";

  /** SKU编号 */
  skuNo = "";

  /** 剩余未完结数量(占用关系) */
  surplusQty = undefined;

  /** 国内仓库存(占用关系) */
  warehouseCnStock = undefined;
}

class SystemForecastRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 预测数量 */
  forecastQty = undefined;

  /** 预测使用数据 */
  forecastUsageData = "";

  /** 预测使用模型 */
  forecastUsageModel = "";

  /** 预测周 */
  forecastWeek = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 销售市场 */
  saleMarket = "";

  /** SKU编号 */
  skuNo = "";

  /** 开始周 */
  startWeek = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 预测版本 */
  version = "";
}

class SystemForecastResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 预测数量 */
  forecastQty = undefined;

  /** 预测使用数据 */
  forecastUsageData = "";

  /** 预测使用模型 */
  forecastUsageModel = "";

  /** 预测周 */
  forecastWeek = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 销售市场 */
  saleMarket = "";

  /** SKU编号 */
  skuNo = "";

  /** 开始周 */
  startWeek = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 预测版本 */
  version = "";
}

class TaskDto {
  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 任务id */
  taskId = "";
}

class TimelinessDashboardRequestDto {
  /** 起始时间 */
  beginTime = "";

  /** 结束时间 */
  endTime = "";

  /** sku */
  sku = "";
}

class TimelinessDashboardResponseDto {
  /** 批次号 */
  abno = "";

  /** sku */
  aono = "";

  /** 打包装箱完成时间 */
  boxTime = "";

  /** TO创建时间 */
  createTime = "";

  /** 出库时间 */
  deliveryTime = "";

  /** FBA到仓时间 */
  fbaInTime = "";

  /** 已出库数量 */
  qty = undefined;

  /** 运输方式 1：龙舟空运 2：龙舟海运 3：龙舟快船 4：龙舟散货 10 普通空运 15：普通空运(带电带磁)，20 普通海运，30 快船，40 铁路 50：卡车 60：快递 */
  shippingType = undefined;

  /** 调拨状态：10 未处理，20 已打印，30 已拣货，40 已装箱，50 待发运，55：发运中 57：发运失败 60 已发运，62：已退件签收 65：中转签收 68：中转发运 69：部分收货 70 已完成，80 已取消 90 待还货 */
  status = undefined;
}

class TransferPreemptionQtyDto {
  /** 新单号 */
  newDoNo = "";

  /** 原单号 */
  originalDoNo = "";

  /** 转移数量 */
  qty = undefined;

  /** SKU编号 */
  skuNo = "";
}

class WarehouseCompanyRelevanceReponseDto {
  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class WarehouseCompanyRelevanceRequestDto {
  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";
}

class WarehouseCostPayRequestDto {
  /** 费用用途备注 */
  costPurposeRemark = "";

  /** 财务附件 */
  financeFile = "";

  /** 付款银行编号 */
  paymentBankCode = "";

  /** 付款银行名称 */
  paymentBankName = "";

  /** 付款时间 */
  paymentDate = "";

  /** 审批信息 */
  requestDto = new WarehouseCostWorkflowDto();

  /** 仓库费用编号 */
  wcno = "";
}

class WarehouseCostRequestDto {
  /** 受益部门 */
  benefitDepartment = "";

  /** 费用金额 */
  costAmount = undefined;

  /** 费用结束时间 */
  costEndDate = "";

  /** 费用附件 */
  costFile = "";

  /** 费用选项 */
  costOption = "";

  /** 费用选项编号 */
  costOptionCode = "";

  /** 费用用途备注 */
  costPurposeRemark = "";

  /** 费用开始时间 */
  costStartDate = "";

  /** 币种 */
  currency = "";

  /** 汇率 */
  exchangeRate = undefined;

  /** id */
  id = undefined;

  /** 收款人开户行 */
  payeeBankName = "";

  /** 收款人银行账户 */
  payeeBankNumber = "";

  /** 收款人名称 */
  payeeName = "";

  /** 付款银行编号 */
  paymentBankCode = "";

  /** 付款银行名称 */
  paymentBankName = "";

  /** 付款时间 */
  paymentDate = "";

  /** 备注 */
  remark = "";

  /** 状态 10:审批中 20:待付款 30:已付款 40:审批驳回 */
  status = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 仓库费用编号 */
  wcno = "";
}

class WarehouseCostResponseDto {
  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 受益部门 */
  benefitDepartment = "";

  /** 费用金额 */
  costAmount = undefined;

  /** 费用结束时间 */
  costEndDate = "";

  /** 费用附件 */
  costFile = "";

  /** 费用选项 */
  costOption = "";

  /** 费用选项编号 */
  costOptionCode = "";

  /** 费用用途备注 */
  costPurposeRemark = "";

  /** 费用开始时间 */
  costStartDate = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人 */
  currentHandler = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** 财务附件 */
  financeFile = "";

  /** id */
  id = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 收款人开户行 */
  payeeBankName = "";

  /** 收款人银行账户 */
  payeeBankNumber = "";

  /** 收款人名称 */
  payeeName = "";

  /** 付款银行编号 */
  paymentBankCode = "";

  /** 付款银行名称 */
  paymentBankName = "";

  /** 付款时间 */
  paymentDate = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 备注 */
  remark = "";

  /** 状态 10:审批中 20:待付款 30:已付款 40:审批驳回 */
  status = undefined;

  /** 状态 10:审批中 20:待付款 30:已付款 40:审批驳回 */
  statusStr = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 仓库费用编号 */
  wcno = "";
}

class WarehouseCostWorkflowDto {
  /** 提交人备注 */
  applyMemo = "";

  /** 提交人ID */
  applyUserId = undefined;

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 工作流实例ID */
  processInstanceId = "";

  /** 工作流TaskID */
  taskId = "";
}

class WarehouseInfoResponseDto {
  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 仓库类型 10:自营 20:FBA 30:第三方仓 */
  type = undefined;

  /** 编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 仓库英文名称 */
  warehouseNameEn = "";
}

class WarehouseParamsDto {
  /** 地址 */
  address = "";

  /** 区 */
  area = "";

  /** 城市 */
  city = "";

  /** 联系人 */
  contacts = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 负责人 */
  director = "";

  /** 邮箱 */
  email = "";

  /** 积加-地址行1 */
  gjAddressLine1 = "";

  /** 积加-地址名称 */
  gjAddressName = "";

  /** 积加-城市 */
  gjCity = "";

  /** 积加-发货地址国家 */
  gjCountryCode = "";

  /** 积加-市/镇 */
  gjDistrictOrCounty = "";

  /** 积加发货地址ID */
  gjShipfromAddress = "";

  /** 积加-州、省、直辖市或自治区 */
  gjStateOrProvinceCode = "";

  /** id */
  id = undefined;

  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 移动电话 */
  mobilePhone = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** 供应商 */
  supplier = "";

  /** 供应商 多选 */
  supplierList = [];

  /** 固定电话 */
  telephone = "";

  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 仓库类型 10:自营仓 20:FBA仓 30:三方仓 40:工厂仓 */
  type = undefined;

  /** 仓库类型 多选 */
  typeList = [];

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 编号 */
  warehouseCode = "";

  /** 仓库编号多选 */
  warehouseCodes = [];

  /** 仓库名称 */
  warehouseName = "";

  /** 仓库英文名称 */
  warehouseNameEn = "";

  /** 仓库名称多选 */
  warehouseNames = [];

  /** 重量单位 10:g 20:kg */
  weightUnit = undefined;
}

class WarehousePerformanceResponseDto {
  /** 操作人 */
  operation = "";

  /** PCS数 */
  pcsNum = undefined;

  /** sku数 */
  skuNum = undefined;

  /** 汇总维度 0-汇总统计 1-按天统计 默认汇总统计 */
  sumDimension = undefined;

  /** 日期 */
  time = "";

  /** 方数m3 */
  totalVolume = undefined;

  /** 绩效类型 10-收货 15-装箱 25-分箱 40-上架 50-拣货 90-移库 70-发货 */
  type = undefined;

  /** 绩效类型 10-收货 15-装箱  40-上架 50-拣货 90-移库 70-发货 */
  typeName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class WarehousePerformanceSummaryResponseDto {
  /** PCS数 */
  totalPcsNum = undefined;

  /** sku数 */
  totalSkuNum = undefined;

  /** 方数m3 */
  totalVolume = "";
}

class WarehousePositionRequestDto {
  /** 高度(mm) */
  height = undefined;

  /** id */
  id = undefined;

  /** 长度(mm) */
  length = undefined;

  /** 拣货顺序 */
  order = undefined;

  /** 体积(mm3) */
  volume = undefined;

  /** 宽度(mm) */
  width = undefined;
}

class WarehousePositionResponseDto {
  /** 库区编号 */
  areaCode = "";

  /** 库区名称 */
  areaName = "";

  /** 列 */
  column = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 货架组编号 */
  groupCode = "";

  /** 高度(mm) */
  height = undefined;

  /** id */
  id = undefined;

  /** 层 */
  layer = undefined;

  /** 长度(mm) */
  length = undefined;

  /** 拣货顺序 */
  order = undefined;

  /** 库位编号 */
  positionCode = "";

  /** 库存总数 */
  qty = undefined;

  /** 行 */
  row = undefined;

  /** 货架编号 */
  shelvesCode = "";

  /** 货架名称 */
  shelvesName = "";

  /** sku个数 */
  skuNum = undefined;

  /** 状态 0-禁用 1-启用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 体积(mm3) */
  volume = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 宽度(mm) */
  width = undefined;
}

class WarehouseRequestDto {
  /** 地址 */
  address = "";

  /** 区 */
  area = "";

  /** 城市 */
  city = "";

  /** 联系人 */
  contacts = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 负责人 */
  director = "";

  /** 邮箱 */
  email = "";

  /** 积加-地址行1 */
  gjAddressLine1 = "";

  /** 积加-地址名称 */
  gjAddressName = "";

  /** 积加-城市 */
  gjCity = "";

  /** 积加-发货地址国家 */
  gjCountryCode = "";

  /** 积加-市/镇 */
  gjDistrictOrCounty = "";

  /** 积加发货地址ID */
  gjShipfromAddress = "";

  /** 积加-州、省、直辖市或自治区 */
  gjStateOrProvinceCode = "";

  /** id */
  id = undefined;

  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 移动电话 */
  mobilePhone = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 交易主体 */
  relevanceRequestDtos = [];

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** supplier */
  supplier = "";

  /** 固定电话 */
  telephone = "";

  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 仓库类型 10:自营仓 20:FBA仓 30:三方仓 40:工厂仓 */
  type = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 仓库英文名称 */
  warehouseNameEn = "";

  /** 重量单位 10:g 20:kg */
  weightUnit = undefined;
}

class WarehouseResponseDto {
  /** 地址 */
  address = "";

  /** 区 */
  area = "";

  /** 城市 */
  city = "";

  /** 联系人 */
  contacts = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 负责人 */
  director = "";

  /** 邮箱 */
  email = "";

  /** 积加-地址行1 */
  gjAddressLine1 = "";

  /** 积加-地址名称 */
  gjAddressName = "";

  /** 积加-城市 */
  gjCity = "";

  /** 积加-发货地址国家 */
  gjCountryCode = "";

  /** 积加-市/镇 */
  gjDistrictOrCounty = "";

  /** 积加发货地址ID */
  gjShipfromAddress = "";

  /** 积加-州、省、直辖市或自治区 */
  gjStateOrProvinceCode = "";

  /** id */
  id = undefined;

  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 移动电话 */
  mobilePhone = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 供应商 */
  supplier = "";

  /** 固定电话 */
  telephone = "";

  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 仓库类型 10:自营 20:FBA 30:第三方仓 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 仓库英文名称 */
  warehouseNameEn = "";

  /** 重量单位 10:g 20:kg */
  weightUnit = undefined;
}

class WarehouseRulesDetailShowDto {
  /** 过滤规则 */
  filterRule = new FilterRuleBean();

  /** 是否启用：1是 0否 */
  isEnable = undefined;

  /** 规则名称 */
  ruleName = "";
}

class WarehouseRulesRequestDto {
  /** 优先类型：time时效   price价格 */
  firstType = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 匹配规则 */
  rules = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class WarehouseRulesRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 优先类型：time时效   price价格 */
  firstType = "";

  /** id */
  id = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 备注 */
  remark = "";

  /** 匹配规则 */
  rules = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class WarehouseShopReponseDto {
  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class WarehouseSkuBatchQueryRequestDto {
  /** 三方仓sku编号 */
  skuCode = [];

  /** 中台sku编号 */
  skuNo = [];

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 中台仓库编号 */
  warehouseCode = [];
}

class WarehouseSkuGroupDetailResponseDto {
  /** sku库存编码 */
  skuCode = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class WarehouseSkuGroupResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 分组明细 */
  detailResponseDtos = [];

  /** 产品标题 */
  productTitle = "";

  /** sku */
  sku = "";
}

class WarehouseSkuRequestDto {
  /** 创建人 */
  createBy = "";

  /** 产品标题 */
  productTitle = "";

  /** sku */
  sku = "";

  /** sku库存编码 */
  skuCode = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class WarehouseSkuRpcResponseDto {
  /** id */
  id = undefined;

  /** 产品标题 */
  productTitle = "";

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** sku库存编码 */
  skuCode = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class WaybillMasterResponseDto {
  /** 地址 */
  address = "";

  /** 城市 */
  city = "";

  /** 关联单号 */
  correlationNo = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申报价格USD */
  declarePrice = undefined;

  /** 妥投时间 */
  deliveredTime = "";

  /** 发货时间 */
  deliveryTime = "";

  /** 邮箱地址 */
  email = "";

  /** 预估费用 */
  estimatePrice = undefined;

  /** 预估重量 */
  estimateWeight = undefined;

  /** id */
  id = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流商运费 */
  logisticsPrice = undefined;

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 物流状态 10:未发运 20:已发运 30:已妥投 40:已退回 */
  logisticsStatus = undefined;

  /** 物流商重量 */
  logisticsWeight = undefined;

  /** 移动电话 */
  mobilePhone = "";

  /** 操作单号 */
  operationNo = "";

  /** 单据类型 10:入库单 20:出库单 */
  operationOrderType = undefined;

  /** 平台名 */
  platformName = "";

  /** 邮编 */
  postcode = "";

  /** 产品集合 */
  productJson = "";

  /** 省份 */
  province = "";

  /** 出库数量 */
  qty = undefined;

  /** 实际运费 */
  realityFreight = undefined;

  /** 实际费用 */
  realityPrice = undefined;

  /** 实际重量 */
  realityWeight = undefined;

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 销售价格USD */
  salePrice = undefined;

  /** 店铺名 */
  shopName = "";

  /** 固定电话 */
  telephone = "";

  /** 跟踪号 */
  trackingNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 运单号 */
  waybillNo = "";
}

class WaybillTraceRecordResponseDto {
  /** 跟踪时间 */
  acceptTime = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 跟踪信息 */
  remark = "";

  /** 跟踪号 */
  trackingNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 物流单号 */
  waybillNo = "";
}

class ZoneBean {
  /** 邮编范围止 */
  postcodeEnd = "";

  /** 邮编范围起 */
  postcodeStart = "";

  /** 目的国家数简码 */
  targetCountryCode = "";
}

class skuInfoResponseDto {
  /** 附件链接 */
  annexUrl = "";

  /** 提交人ID */
  applyUser = undefined;

  /** 提交人备注 */
  applyUserMemo = "";

  /** 提交人名称 */
  applyUserName = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** asin */
  asin = "";

  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 品牌名称 */
  brandName = "";

  /** 品牌名称（CN） */
  brandNameCn = "";

  /** 品牌编号 */
  brandNo = "";

  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** 产品认证类型 */
  certificationType = "";

  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** commoditySize */
  commoditySize = undefined;

  /** 质检确认箱规-高 */
  confirmBoxHeightCm = undefined;

  /** 质检确认箱规-长 */
  confirmBoxLongCm = undefined;

  /** 质检确认箱规-宽 */
  confirmBoxWidthCm = undefined;

  /** 质检确认产品包装高（CM） */
  confirmPackHeightCm = undefined;

  /** 质检确认产品包装长（CM） */
  confirmPackLongCm = undefined;

  /** 质检确认产品包装重量（G） */
  confirmPackWeight = undefined;

  /** 质检确认产品包装宽（CM） */
  confirmPackWidthCm = undefined;

  /** 质检确认单箱体积重 */
  confirmSingleBoxVolumeWeight = undefined;

  /** 质检确认单箱毛重 */
  confirmSinglePackingWeight = undefined;

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 海关监管条件 */
  customsControl = "";

  /** 法定海关单位 */
  customsUnit = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 是否申报型号 */
  declareTypeFlag = false;

  /** 产品交期 */
  deliveryDay = undefined;

  /** 描述 */
  description = "";

  /** fnStock */
  fnStock = undefined;

  /** fnsku */
  fnsku = "";

  /** 产品高 */
  heightCm = undefined;

  /** HSCODE(国内) */
  hscodeCn = "";

  /** HSCODE(国外) */
  hscodeEn = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 产品初始分级 */
  initLevelNum = "";

  /** 检疫检验类别 */
  inspectionType = "";

  /** 工作流实例ID */
  instanceId = undefined;

  /** 开票单位名称 */
  invoiceUnitName = "";

  /** 开票单位编号 */
  invoiceUnitNo = "";

  /** 是否研发产品：false or true */
  isDevolopFlag = false;

  /** 是否需要厂检 */
  isFactoryCheck = undefined;

  /** 是否需要质检 */
  isWarehouseCheck = undefined;

  /** 产品分级 */
  levelNum = "";

  /** 物流周期 */
  logisticsCycle = undefined;

  /** 物流分组 */
  logisticsGroupNo = "";

  /** 产品长 */
  longCm = undefined;

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 最小供应商moq */
  minMoq = undefined;

  /** 每箱数量（MPQ） */
  mpq = undefined;

  /** MQ推送状态: -1 未推送 0 推送失败 1推送成功 */
  mqSendStatus = undefined;

  /** msku */
  msku = "";

  /** NS消费状态：-1 未消费 0消费失败 1消费成功 */
  nsConsumeStatus = undefined;

  /** 事业部 */
  organizationNane = "";

  /** 原申报量 */
  originQuantityShipped = undefined;

  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** 计划员 */
  planner = "";

  /** 是否产品化管理 */
  productManagementFlag = false;

  /** 产品名称（CN） */
  productNameCn = "";

  /** 产品名称（EN） */
  productNameEn = "";

  /** 产品编号 */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";

  /** 项目经理用户编码 */
  projectManager = "";

  /** 采购单位名称 */
  purchaseUnitName = "";

  /** 采购单位编号 */
  purchaseUnitNo = "";

  /** 采购负责人 */
  purchaser = "";

  /** 数量 */
  quantityIncase = undefined;

  /** 收货数量 */
  quantityReceived = undefined;

  /** 发货数量 */
  quantityShipped = undefined;

  /** 出口退税率 */
  rebateRate = undefined;

  /** 驳回人ID */
  rejecter = undefined;

  /** 驳回人名称 */
  rejecterName = "";

  /** 备注 */
  remark = "";

  /** 产品销售链接 */
  salesLink = "";

  /** 产品销售价格 */
  salesPrice = undefined;

  /** SBU编码 */
  sbuCode = undefined;

  /** SBU名称 */
  sbuName = "";

  /** 副产品负责人 */
  secondOwner = "";

  /** 副产品负责人名称 */
  secondOwnerName = "";

  /** 默认运输方式名称 */
  shippingMethodName = "";

  /** 默认运输方式编号 */
  shippingMethodNo = "";

  /** 单个产品计费重（g） */
  singleBillingWeight = undefined;

  /** 装箱体积（CM3） */
  singleBoxVolume = undefined;

  /** 单个产品装箱体积重(g) */
  singleBoxVolumeWeight = undefined;

  /** 单箱净重 */
  singlePackingSuttleWeight = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU简称 */
  skuAbbreviation = "";

  /** SKU型号 */
  skuModel = "";

  /** SKU编号 */
  skuNo = "";

  /** skuStock */
  skuStock = undefined;

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** SKU标题（EN） */
  skuTitleEn = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 计量单位名称(弃用字段，采购单位) */
  unitName = "";

  /** 计量单位编号(弃用字段，采购单位) */
  unitNo = "";

  /** 单位类型名称 */
  unitTypeName = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 默认供应商名称 */
  vendorName = "";

  /** 默认供应商编号 */
  vendorNo = "";

  /** 体积重 */
  volumeWeight = undefined;

  /** 产品重量（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

export const wms = {
  AdjustmentOrderRequestDto,
  AllocationApprovalResponseDto,
  AllocationApprovalResponseModel,
  AllocationBatchCreateRequestDto,
  AllocationBatchDetailResponseDto,
  AllocationBatchResponseDto,
  AllocationBatchUploadPodFileRequestDto,
  AllocationBoxCollectDto,
  AllocationBoxDetailRequestDto,
  AllocationBoxDetailResponseDto,
  AllocationBoxHeadDto,
  AllocationBoxRequestDto,
  AllocationBoxResponseDto,
  AllocationBoxingReportDto,
  AllocationContainerRequestDto,
  AllocationContainerResponseDto,
  AllocationDetailCreateRequestDto,
  AllocationDetailCreateRpcRequestDto,
  AllocationDetailInfoRpcResponseDto,
  AllocationDetailModel,
  AllocationDetailResponseDto,
  AllocationDetailRpcResponseDto,
  AllocationMasterBoxDetailResponseDto,
  AllocationMasterBoxingReportDto,
  AllocationMasterCreateForPageRequestDto,
  AllocationMasterCreateForTransferDetailRequestDto,
  AllocationMasterCreateForTransferRequestDto,
  AllocationMasterCreateRequestDto,
  AllocationMasterListResponseDto,
  AllocationMasterModel,
  AllocationMasterParamsDto,
  AllocationMasterResponseDto,
  AllocationMasterRpcResponseDto,
  AllocationMasterUpdateRequestDto,
  AllocationMasterWFSResponseDto,
  AllocationMasterWithDetailsResponseDto,
  AllocationOperationTimeResponseDto,
  AllocationPlanPageResponseDto,
  AllocationPlanUpdateRequestDto,
  AllocationTrialPageResponseDto,
  AllocationUpdateCabinStatusRequestDto,
  AllocationUpdateOrderStatusDto,
  AllocationWFSLabelResponseDto,
  ApprovalBeforeRequestDto,
  ApprovalRequestDto,
  AssigneeDto,
  BatchPostponementRequestDto,
  ChangeOrderApprovalDto,
  ChangeOrderCreateDto,
  ChangeOrderDetailCreateDto,
  ChangeOrderDetailRequestDto,
  ChangeOrderDetailResponseDto,
  ChangeOrderRequestDto,
  ChangeOrderResponseDto,
  CheckDemandQtyRequestDto,
  CodeAndNameListResponseDto,
  CreateInDetailWithBoxRequestDto,
  CreateShipmentLabelRequestDto,
  CreateShipmentLabelResponseDto,
  CurrentTaskDto,
  DeclarationPushEbsRequestDto,
  DefaultShopInfoRequestDto,
  DefaultShopInfoResponseDto,
  DeleteBillRequestDto,
  DeliveryNoteExcelDetailRequestDto,
  DeliveryNoteExcelRequestDto,
  DemandOrderApproveDto,
  DemandOrderExcelImportDto,
  DemandOrderRequestDto,
  DemandOrderResponseDto,
  ExWarehouseResponseDto,
  FilterRuleBean,
  FinalApproveRequestDto,
  FinalTrialOrderDetailRequestDto,
  FinalTrialOrderDetailResponseDto,
  FinalTrialOrderRequestDto,
  FinalTrialOrderResponseDto,
  FinanceVoucherReportDetailResponseDto,
  FinanceVoucherReportMasterResponseDto,
  FirstApproveRequestDto,
  FirstBatchApproveRequestDto,
  FirstTrialOrderDetailRequestDto,
  FirstTrialOrderDetailResponseDto,
  FirstTrialOrderRequestDto,
  FirstTrialOrderResponseDto,
  FrozenCreateOrderApprovalDto,
  FrozenCreateOrderDto,
  FrozenCreateOrderRequestDto,
  FrozenCreateOrderResponseDto,
  FrozenResubmitOrderDto,
  FrozenStateRequestDto,
  FrozenStateResponseDto,
  GetBoxLabelForGjRequestDto,
  GetFileStreamRequestDto,
  IPage,
  ImageEntity,
  ImportTemplateExcelResponseDto,
  InDeliveryDetailBoxRequestDto,
  InDeliveryDetailBoxResponseDto,
  InDetailBoxPDAReceivingRequestDto,
  InDetailBoxPrintResponseDto,
  InDetailBoxRequestDto,
  InDetailBoxResponseDto,
  InDetailBoxScanResponseDto,
  InDetailCreateRequestDto,
  InDetailInspectionResponseDto,
  InDetailOncePutStorageDto,
  InDetailOneClickInboundDto,
  InDetailPDAReceivingRequestDto,
  InDetailPutOnRequestDto,
  InDetailReceivingByMxRequestDto,
  InDetailRecordRequestDto,
  InDetailRecordResponseDto,
  InDetailRecordResultDto,
  InDetailRequestDto,
  InDetailResponseDto,
  InMasterBoxDetailRequestDto,
  InMasterBoxShelvesRequestDto,
  InMasterCancelRequestDto,
  InMasterCreateRequestDto,
  InMasterCreateRequestRpcDto,
  InMasterCreateResponseRpcDto,
  InMasterInfoResponseRpcDto,
  InMasterInspectionRequestDto,
  InMasterInspectionResponseDto,
  InMasterOncePutStorageDto,
  InMasterPDAReceivingRequestDto,
  InMasterPDAReceivingResponseDto,
  InMasterPackingProbabilityResponseDto,
  InMasterPlateDetailRequestDto,
  InMasterPutOnRequestDto,
  InMasterReceivingByMxRequestDto,
  InMasterReceivingResponseDto,
  InMasterResponseDto,
  InMasterResponseRpcDto,
  InPlanMasterOneClickInboundDto,
  InPlateDetailRequestDto,
  InPlateDetailResponseDto,
  InPlateMasterResponseDto,
  InoutStepRecordRequestDto,
  InoutStepRecordResponseDto,
  InventoryApprovalResponseDto,
  InventoryDetailRecordResponseDto,
  InventoryDetailResultRequestDto,
  InventoryDetailResultResponseDto,
  InventoryDetailResultStatisticsRequestDto,
  InventoryErrorListResponseDto,
  InventoryMasterRequestDto,
  InventoryMasterResponseDto,
  InventoryPositionResponseDto,
  InventoryScreenPositionResponseDto,
  InventorySkuRequestDto,
  InventoryTaskCreateDto,
  InventoryTaskResponseDto,
  InventoryThireFactoryRequestDetailDto,
  InventoryThireFactoryRequestDto,
  InventoryWorkflowDto,
  LendDetailCreateRequestDto,
  LendDetailResponseDto,
  LendMasterAuditActivitiDto,
  LendMasterCreateRequestDto,
  LendMasterResponseDto,
  LogisticsCycleInfoRequestDto,
  LogisticsCycleInfoResponseDto,
  LogisticsOrderRequestRpcDto,
  LogisticsOrderResponseDto,
  LogisticsReturnCreateInDto,
  LogisticsReturnRecordRequestDto,
  LogisticsReturnRecordResponseDto,
  LogisticsReverseLabelDetailRequestDto,
  LogisticsReverseLabelRequestDto,
  LogisticsReverseLabelResponseDto,
  LogisticsWaybillLabelResponseDto,
  ModifyShippingTypeRequestDto,
  NsStorageRequestDto,
  NsStorageResponseDto,
  OmsPackageInfoDetailDto,
  OmsPackageInfoDto,
  OperateForecastRequestDto,
  OperateForecastResponseDto,
  OperationRecordResponseDto,
  OutCheckResponseDto,
  OutDetailCheckRequestDto,
  OutDetailCreateRequestDto,
  OutDetailResponseRpcDto,
  OutInfoResponseDto,
  OutInfoSkuResponseDto,
  OutInterceptBeforeResponseDto,
  OutMasterCreateRequestDto,
  OutMasterCreateResponseRpcDto,
  OutMasterLendCreateRequestDto,
  OutMasterLendCreateRequestRpcDto,
  OutMasterResponseDto,
  OutMasterResponseRpcDto,
  OutMasterSnListRequestDto,
  OutMasterSnListResponseDto,
  OutMasterSnResponseDto,
  OutPlanCreateRequestDto,
  OutPlanDetailCreateRequestDto,
  OutPlanDetailResponseDto,
  OutPlanMastSkuDetailResponseDto,
  OutPlanMasterResponseDto,
  OutReturnRequestDto,
  OutReturnResponseDto,
  OutReturnResponseParamsDto,
  OutReturnSerialRequestDto,
  OutReturnSignRequestDto,
  PackageDetailResponseDto,
  PackageMasterDetailResponseDto,
  PackageMasterResponseDto,
  PackageWaybillResponseDto,
  PageInfo,
  PdaFnskuRequestDto,
  PdaFnskuResponseDto,
  PdfContentDto,
  PickAddRequestDto,
  PickDetailBoxRequestDto,
  PickDetailFilterRequestDto,
  PickDetailFilterResponseDto,
  PickDetailResponseDto,
  PickDetailSerialBySkuDonoResponseDto,
  PickDetailSerialResponseDto,
  PickInfoPositionResponseDto,
  PickInfoResponseDto,
  PickInfoSkuDetailResponseDto,
  PickInfoSkuResponseDto,
  PickMasterResponseDto,
  PickOutRequestDto,
  PickPositionResponseDto,
  PickWaitInfoResponseDto,
  PonoStockDetailResultDto,
  PonoStockResultDto,
  PositionStorageCapacityInfoResponseDto,
  PositionStorageCapacityRequestDto,
  PositionStorageCapacityResponseDto,
  PostponementOrderResponseDto,
  ProductSizeSectionRequestParamsDto,
  ProductSizeSectionResponseDto,
  PurchaseStockOccupyDetailRequestDto,
  PurchaseStockOccupyDetailResponseDto,
  PurchaseStockOccupyRequestDto,
  RedundancyStockResponseDto,
  Response,
  ResponseDto,
  ResubmitRequestDto,
  SaleForecastRequestDto,
  SaleForecastResponseDto,
  SaleTransferOrderTxRequestDto,
  SalesOwnerInfoRequestDto,
  SalesOwnerInfoResponseDto,
  ShelvesAddRequestDto,
  ShopDepartmentMappingRequestDto,
  ShopDepartmentMappingResponseDto,
  SinglePostponementRequestDto,
  SiteDimensionKeyDto,
  SkuInfoDetailRequestDto,
  SkuInfoDetailResponseDto,
  SkuInfoRequestDto,
  SkuInfoResponseDto,
  SkuPackageInfo,
  SkuQtyDetail,
  SnCodeInfoDto,
  StagingAreaDetailAddRequestDto,
  StagingAreaDetailResponseDto,
  StagingAreaLogModel,
  StagingAreaMasterRequestDto,
  StagingAreaMasterResponseDto,
  StockAgeInfoResponseDto,
  StockAgeRequestDto,
  StockAgeResponseDto,
  StockChangeLabelRequestDto,
  StockDetailGroupResponseDto,
  StockDetailRequestParamsDto,
  StockDetailResponseDto,
  StockDetailSummaryResponseDto,
  StockFreezeRecordRequestDto,
  StockFreezeRecordResponseDto,
  StockGroupForPositionResponseDto,
  StockMoveRequestDto,
  StockOccupyMasterSelectRequestDto,
  StockOccupyMasterSelectSkuRequestDto,
  StockSplitBoxDto,
  StorageChangeLabelBoxRequestDto,
  StorageChangeLabelSkuRequestDto,
  StorageDamageDetailResponseDto,
  StorageDamagetWorkflowDto,
  StorageForNsDto,
  StorageGroupRequestDto,
  StorageLocationListRequestDto,
  StorageMoveBoxRequestDto,
  StorageMoveSkuRequestDto,
  StorageOfOccupyResponseDto,
  StorageReportDamageResponseDto,
  StorageUnitAreaRequestDto,
  StorageUnitResponseDto,
  SupplyDemandBalanceDetailRequestDto,
  SupplyDemandBalanceDetailResponseDto,
  SupplyDemandBalanceRequestDto,
  SupplyDemandBalanceResponseDto,
  SupplyDemandMatchReportResponseDto,
  SystemForecastRequestDto,
  SystemForecastResponseDto,
  TaskDto,
  TimelinessDashboardRequestDto,
  TimelinessDashboardResponseDto,
  TransferPreemptionQtyDto,
  WarehouseCompanyRelevanceReponseDto,
  WarehouseCompanyRelevanceRequestDto,
  WarehouseCostPayRequestDto,
  WarehouseCostRequestDto,
  WarehouseCostResponseDto,
  WarehouseCostWorkflowDto,
  WarehouseInfoResponseDto,
  WarehouseParamsDto,
  WarehousePerformanceResponseDto,
  WarehousePerformanceSummaryResponseDto,
  WarehousePositionRequestDto,
  WarehousePositionResponseDto,
  WarehouseRequestDto,
  WarehouseResponseDto,
  WarehouseRulesDetailShowDto,
  WarehouseRulesRequestDto,
  WarehouseRulesRequestParamsDto,
  WarehouseShopReponseDto,
  WarehouseSkuBatchQueryRequestDto,
  WarehouseSkuGroupDetailResponseDto,
  WarehouseSkuGroupResponseDto,
  WarehouseSkuRequestDto,
  WarehouseSkuRpcResponseDto,
  WaybillMasterResponseDto,
  WaybillTraceRecordResponseDto,
  ZoneBean,
  skuInfoResponseDto,
};
